
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire72c9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire72c9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $9ATkq = parcelRequire("9ATkq");

var $bh6RR = parcelRequire("bh6RR");
// NOTE: IF YOU CHANGE THE CONTENT HERE YOU NEED TO CHANGE THE CONTENT ON THE WRAPPED CALCULATOR HERE AND ON WEBSITE TOO

var $ih19M = parcelRequire("ih19M");


var $gSab4 = parcelRequire("gSab4");

var $3HS2q = parcelRequire("3HS2q");

var $6ujkL = parcelRequire("6ujkL");

var $g2NHD = parcelRequire("g2NHD");
// src/components/accordion.ts
var $4c008118e645dd87$export$77f5744dadf9dca6 = (0, $6ujkL.tv)({
    base: "px-2",
    variants: {
        variant: {
            light: "",
            shadow: "px-4 shadow-medium rounded-medium bg-content1",
            bordered: "px-4 border-medium border-divider rounded-medium",
            splitted: "group is-splitted flex flex-col gap-2"
        },
        fullWidth: {
            true: "w-full"
        }
    },
    defaultVariants: {
        variant: "light",
        fullWidth: true
    }
});
var $4c008118e645dd87$export$b0ae97173709dbd3 = (0, $6ujkL.tv)({
    slots: {
        base: [
            "group-[.is-splitted]:px-4",
            "group-[.is-splitted]:bg-content1",
            "group-[.is-splitted]:shadow-medium",
            "group-[.is-splitted]:rounded-medium"
        ],
        heading: "",
        trigger: [
            "flex py-4 w-full h-full gap-3 outline-none items-center tap-highlight-transparent",
            ...(0, $g2NHD.dataFocusVisibleClasses)
        ],
        startContent: "flex-shrink-0",
        indicator: "text-default-400",
        titleWrapper: "flex-1 flex flex-col text-start",
        title: "text-foreground text-large",
        subtitle: "text-small text-foreground-500 font-normal",
        content: "py-2"
    },
    variants: {
        isCompact: {
            true: {
                trigger: "py-2",
                title: "text-medium",
                subtitle: "text-small",
                indicator: "text-medium",
                content: "py-1"
            }
        },
        isDisabled: {
            true: {
                base: "opacity-disabled pointer-events-none"
            }
        },
        hideIndicator: {
            true: {
                indicator: "hidden"
            }
        },
        disableAnimation: {
            true: {
                content: "hidden data-[open=true]:block"
            },
            false: {
                indicator: "transition-transform",
                trigger: "transition-opacity"
            }
        },
        disableIndicatorAnimation: {
            true: {
                indicator: "transition-none"
            },
            false: {
                indicator: "rotate-0 data-[open=true]:-rotate-90 rtl:-rotate-180 rtl:data-[open=true]:-rotate-90"
            }
        }
    },
    defaultVariants: {
        size: "md",
        radius: "lg",
        isDisabled: false,
        hideIndicator: false,
        disableIndicatorAnimation: false
    }
});



var $6N9Z9 = parcelRequire("6N9Z9");
var $3xP29 = parcelRequire("3xP29");
var $6G4gc = parcelRequire("6G4gc");

var $bIkcs = parcelRequire("bIkcs");
var $gedB5 = parcelRequire("gedB5");
// src/use-accordion-item.ts

var $bh6RR = parcelRequire("bh6RR");

var $3HS2q = parcelRequire("3HS2q");

var $i65Wu = parcelRequire("i65Wu");
var $leZvJ = parcelRequire("leZvJ");
var $dCyIs = parcelRequire("dCyIs");

var $61nPD = parcelRequire("61nPD");
var $ld26B = parcelRequire("ld26B");
var $8l8s9 = parcelRequire("8l8s9");

var $ld26B = parcelRequire("ld26B");
var $kI2if = parcelRequire("kI2if");
var $7uYIl = parcelRequire("7uYIl");

var $bh6RR = parcelRequire("bh6RR");

var $2GhkT = parcelRequire("2GhkT");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$currentModality = null;
let $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $4f4acfcef2ff32f4$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $kI2if.isMac)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$currentModality = "keyboard";
        $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $7uYIl.isVirtualClick)(e)) {
        $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$currentModality = "virtual";
        $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === "undefined" || $4f4acfcef2ff32f4$export$d90243b58daecda7.get((0, $ld26B.getOwnerWindow)(element))) return;
    const windowObject = (0, $ld26B.getOwnerWindow)(element);
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener("keydown", $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("keyup", $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("click", $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener("focus", $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener("blur", $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.addEventListener("pointerdown", $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointermove", $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointerup", $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener("mousedown", $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mousemove", $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mouseup", $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener("beforeunload", ()=>{
        $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $4f4acfcef2ff32f4$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $ld26B.getOwnerWindow)(element);
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
    if (!$4f4acfcef2ff32f4$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $4f4acfcef2ff32f4$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener("keydown", $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("keyup", $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("click", $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener("focus", $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener("blur", $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.removeEventListener("pointerdown", $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointermove", $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointerup", $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener("mousedown", $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mousemove", $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mouseup", $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $4f4acfcef2ff32f4$export$d90243b58daecda7.delete(windowObject);
};
function $4f4acfcef2ff32f4$export$2f1888112f558a7d(element) {
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    let loadListener;
    if (documentObject.readyState !== "loading") $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener("DOMContentLoaded", loadListener);
    }
    return ()=>$4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== "undefined") $4f4acfcef2ff32f4$export$2f1888112f558a7d();
function $4f4acfcef2ff32f4$export$b9b3dfddab17db27() {
    return $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $4f4acfcef2ff32f4$export$630ff653c5ada6a9() {
    return $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$currentModality;
}
function $4f4acfcef2ff32f4$export$8397ddfc504fdb9a(modality) {
    $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$currentModality = modality;
    $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $4f4acfcef2ff32f4$export$98e20ec92f614cfe() {
    $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $bh6RR.useState)($4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$currentModality);
    (0, $bh6RR.useEffect)(()=>{
        let handler = ()=>{
            setModality($4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$currentModality);
        };
        $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $2GhkT.useIsSSR)() ? null : modality;
}
const $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    const IHTMLInputElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === "keyboard" && e instanceof IKeyboardEvent && !$4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $4f4acfcef2ff32f4$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $bh6RR.useState)(autoFocus || $4f4acfcef2ff32f4$export$b9b3dfddab17db27());
    $4f4acfcef2ff32f4$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $4f4acfcef2ff32f4$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $bh6RR.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($4f4acfcef2ff32f4$export$b9b3dfddab17db27());
        };
        $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $4f4acfcef2ff32f4$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $7c67938dc3e4d6fb$export$80f3e147d781571c(element) {
    // If the user is interacting with a virtual cursor, e.g. screen reader, then
    // wait until after any animated transitions that are currently occurring on
    // the page before shifting focus. This avoids issues with VoiceOver on iOS
    // causing the page to scroll when moving focus if the element is transitioning
    // from off the screen.
    const ownerDocument = (0, $ld26B.getOwnerDocument)(element);
    if ((0, $4f4acfcef2ff32f4$export$630ff653c5ada6a9)() === "virtual") {
        let lastFocusedElement = ownerDocument.activeElement;
        (0, $8l8s9.runAfterTransition)(()=>{
            // If focus did not move and the element is still in the document, focus it.
            if (ownerDocument.activeElement === lastFocusedElement && element.isConnected) (0, $61nPD.focusWithoutScrolling)(element);
        });
    } else (0, $61nPD.focusWithoutScrolling)(element);
}



var $dCyIs = parcelRequire("dCyIs");
var $99EP5 = parcelRequire("99EP5");
var $2Cn0z = parcelRequire("2Cn0z");

var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");

var $77fRS = parcelRequire("77fRS");
var $1nsPC = parcelRequire("1nsPC");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $06bd0166e167cc56$export$905e7fc544a71f36 {
    isDefaultPrevented() {
        return this.nativeEvent.defaultPrevented;
    }
    preventDefault() {
        this.defaultPrevented = true;
        this.nativeEvent.preventDefault();
    }
    stopPropagation() {
        this.nativeEvent.stopPropagation();
        this.isPropagationStopped = ()=>true;
    }
    isPropagationStopped() {
        return false;
    }
    persist() {}
    constructor(type, nativeEvent){
        this.nativeEvent = nativeEvent;
        this.target = nativeEvent.target;
        this.currentTarget = nativeEvent.currentTarget;
        this.relatedTarget = nativeEvent.relatedTarget;
        this.bubbles = nativeEvent.bubbles;
        this.cancelable = nativeEvent.cancelable;
        this.defaultPrevented = nativeEvent.defaultPrevented;
        this.eventPhase = nativeEvent.eventPhase;
        this.isTrusted = nativeEvent.isTrusted;
        this.timeStamp = nativeEvent.timeStamp;
        this.type = type;
    }
}
function $06bd0166e167cc56$export$715c682d09d639cc(onBlur) {
    let stateRef = (0, $bh6RR.useRef)({
        isFocused: false,
        observer: null
    });
    (0, $1nsPC.useLayoutEffect)(()=>{
        const state = stateRef.current;
        return ()=>{
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    let dispatchBlur = (0, $77fRS.useEffectEvent)((e)=>{
        onBlur === null || onBlur === void 0 || onBlur(e);
    });
    // This function is called during a React onFocus event.
    return (0, $bh6RR.useCallback)((e)=>{
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            let target = e.target;
            let onBlurHandler = (e)=>{
                stateRef.current.isFocused = false;
                if (target.disabled) dispatchBlur(new $06bd0166e167cc56$export$905e7fc544a71f36("blur", e));
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener("focusout", onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(()=>{
                if (stateRef.current.isFocused && target.disabled) {
                    var _stateRef_current_observer;
                    (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 || _stateRef_current_observer.disconnect();
                    let relatedTargetEl = target === document.activeElement ? null : document.activeElement;
                    target.dispatchEvent(new FocusEvent("blur", {
                        relatedTarget: relatedTargetEl
                    }));
                    target.dispatchEvent(new FocusEvent("focusout", {
                        bubbles: true,
                        relatedTarget: relatedTargetEl
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    "disabled"
                ]
            });
        }
    }, [
        dispatchBlur
    ]);
}



var $bh6RR = parcelRequire("bh6RR");

var $ld26B = parcelRequire("ld26B");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $006524fa72e2dea8$export$f8168d8dd8fd66e6(props) {
    let { isDisabled: isDisabled, onFocus: onFocusProp, onBlur: onBlurProp, onFocusChange: onFocusChange } = props;
    const onBlur = (0, $bh6RR.useCallback)((e)=>{
        if (e.target === e.currentTarget) {
            if (onBlurProp) onBlurProp(e);
            if (onFocusChange) onFocusChange(false);
            return true;
        }
    }, [
        onBlurProp,
        onFocusChange
    ]);
    const onSyntheticFocus = (0, $06bd0166e167cc56$export$715c682d09d639cc)(onBlur);
    const onFocus = (0, $bh6RR.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        const ownerDocument = (0, $ld26B.getOwnerDocument)(e.target);
        if (e.target === e.currentTarget && ownerDocument.activeElement === e.target) {
            if (onFocusProp) onFocusProp(e);
            if (onFocusChange) onFocusChange(true);
            onSyntheticFocus(e);
        }
    }, [
        onFocusChange,
        onFocusProp,
        onSyntheticFocus
    ]);
    return {
        focusProps: {
            onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : undefined,
            onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : undefined
        }
    };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $341be393c471fb1f$export$48d1ea6320830260(handler) {
    if (!handler) return undefined;
    let shouldStopPropagation = true;
    return (e)=>{
        let event = {
            ...e,
            preventDefault () {
                e.preventDefault();
            },
            isDefaultPrevented () {
                return e.isDefaultPrevented();
            },
            stopPropagation () {
                console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.");
            },
            continuePropagation () {
                shouldStopPropagation = false;
            }
        };
        handler(event);
        if (shouldStopPropagation) e.stopPropagation();
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d4a2120374372fbd$export$8f71654801c2f7cd(props) {
    return {
        keyboardProps: props.isDisabled ? {} : {
            onKeyDown: (0, $341be393c471fb1f$export$48d1ea6320830260)(props.onKeyDown),
            onKeyUp: (0, $341be393c471fb1f$export$48d1ea6320830260)(props.onKeyUp)
        }
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $d84515fe59f4eafa$var$$e6afbd83fe6ebbd2$var$FocusableContext = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(null);
function $d84515fe59f4eafa$var$$e6afbd83fe6ebbd2$var$useFocusableContext(ref) {
    let context = (0, $bh6RR.useContext)($d84515fe59f4eafa$var$$e6afbd83fe6ebbd2$var$FocusableContext) || {};
    (0, $2Cn0z.useSyncRef)(context, ref);
    // eslint-disable-next-line
    let { ref: _, ...otherProps } = context;
    return otherProps;
}
/**
 * Provides DOM props to the nearest focusable child.
 */ function $d84515fe59f4eafa$var$$e6afbd83fe6ebbd2$var$FocusableProvider(props, ref) {
    let { children: children, ...otherProps } = props;
    let objRef = (0, $99EP5.useObjectRef)(ref);
    let context = {
        ...otherProps,
        ref: objRef
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($d84515fe59f4eafa$var$$e6afbd83fe6ebbd2$var$FocusableContext.Provider, {
        value: context
    }, children);
}
let $d84515fe59f4eafa$export$13f3202a3e5ddd5 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef($d84515fe59f4eafa$var$$e6afbd83fe6ebbd2$var$FocusableProvider);
function $d84515fe59f4eafa$export$4c014de7c8940b4c(props, domRef) {
    let { focusProps: focusProps } = (0, $006524fa72e2dea8$export$f8168d8dd8fd66e6)(props);
    let { keyboardProps: keyboardProps } = (0, $d4a2120374372fbd$export$8f71654801c2f7cd)(props);
    let interactions = (0, $dCyIs.mergeProps)(focusProps, keyboardProps);
    let domProps = $d84515fe59f4eafa$var$$e6afbd83fe6ebbd2$var$useFocusableContext(domRef);
    let interactionProps = props.isDisabled ? {} : domProps;
    let autoFocusRef = (0, $bh6RR.useRef)(props.autoFocus);
    (0, $bh6RR.useEffect)(()=>{
        if (autoFocusRef.current && domRef.current) (0, $7c67938dc3e4d6fb$export$80f3e147d781571c)(domRef.current);
        autoFocusRef.current = false;
    }, [
        domRef
    ]);
    return {
        focusableProps: (0, $dCyIs.mergeProps)({
            ...interactions,
            tabIndex: props.excludeFromTabOrder && !props.isDisabled ? -1 : undefined
        }, interactionProps)
    };
}



var $ld26B = parcelRequire("ld26B");
var $kI2if = parcelRequire("kI2if");
var $8l8s9 = parcelRequire("8l8s9");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Note that state only matters here for iOS. Non-iOS gets user-select: none applied to the target element
// rather than at the document level so we just need to apply/remove user-select: none for each pressed element individually
let $b3d8de24accd3f58$var$$14c0b72509d70225$var$state = "default";
let $b3d8de24accd3f58$var$$14c0b72509d70225$var$savedUserSelect = "";
let $b3d8de24accd3f58$var$$14c0b72509d70225$var$modifiedElementMap = new WeakMap();
function $b3d8de24accd3f58$export$16a4697467175487(target) {
    if ((0, $kI2if.isIOS)()) {
        if ($b3d8de24accd3f58$var$$14c0b72509d70225$var$state === "default") {
            // eslint-disable-next-line no-restricted-globals
            const documentObject = (0, $ld26B.getOwnerDocument)(target);
            $b3d8de24accd3f58$var$$14c0b72509d70225$var$savedUserSelect = documentObject.documentElement.style.webkitUserSelect;
            documentObject.documentElement.style.webkitUserSelect = "none";
        }
        $b3d8de24accd3f58$var$$14c0b72509d70225$var$state = "disabled";
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        // If not iOS, store the target's original user-select and change to user-select: none
        // Ignore state since it doesn't apply for non iOS
        $b3d8de24accd3f58$var$$14c0b72509d70225$var$modifiedElementMap.set(target, target.style.userSelect);
        target.style.userSelect = "none";
    }
}
function $b3d8de24accd3f58$export$b0d6fa1ab32e3295(target) {
    if ((0, $kI2if.isIOS)()) {
        // If the state is already default, there's nothing to do.
        // If it is restoring, then there's no need to queue a second restore.
        if ($b3d8de24accd3f58$var$$14c0b72509d70225$var$state !== "disabled") return;
        $b3d8de24accd3f58$var$$14c0b72509d70225$var$state = "restoring";
        // There appears to be a delay on iOS where selection still might occur
        // after pointer up, so wait a bit before removing user-select.
        setTimeout(()=>{
            (0, $8l8s9.runAfterTransition)(()=>{
                // Avoid race conditions
                if ($b3d8de24accd3f58$var$$14c0b72509d70225$var$state === "restoring") {
                    // eslint-disable-next-line no-restricted-globals
                    const documentObject = (0, $ld26B.getOwnerDocument)(target);
                    if (documentObject.documentElement.style.webkitUserSelect === "none") documentObject.documentElement.style.webkitUserSelect = $b3d8de24accd3f58$var$$14c0b72509d70225$var$savedUserSelect || "";
                    $b3d8de24accd3f58$var$$14c0b72509d70225$var$savedUserSelect = "";
                    $b3d8de24accd3f58$var$$14c0b72509d70225$var$state = "default";
                }
            });
        }, 300);
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        if (target && $b3d8de24accd3f58$var$$14c0b72509d70225$var$modifiedElementMap.has(target)) {
            let targetOldUserSelect = $b3d8de24accd3f58$var$$14c0b72509d70225$var$modifiedElementMap.get(target);
            if (target.style.userSelect === "none") target.style.userSelect = targetOldUserSelect;
            if (target.getAttribute("style") === "") target.removeAttribute("style");
            $b3d8de24accd3f58$var$$14c0b72509d70225$var$modifiedElementMap.delete(target);
        }
    }
}



var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $6c19b65fd1fa8ecc$export$5165eccb35aaadb5 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext({
    register: ()=>{}
});
$6c19b65fd1fa8ecc$export$5165eccb35aaadb5.displayName = "PressResponderContext";



var $2iPDq = parcelRequire("2iPDq");

var $f9kyn = parcelRequire("f9kyn");

var $lgPAm = parcelRequire("lgPAm");

var $i65Wu = parcelRequire("i65Wu");
var $61nPD = parcelRequire("61nPD");
var $ld26B = parcelRequire("ld26B");
var $kI2if = parcelRequire("kI2if");
var $7uYIl = parcelRequire("7uYIl");
var $dCyIs = parcelRequire("dCyIs");
var $aCMC4 = parcelRequire("aCMC4");
var $77fRS = parcelRequire("77fRS");
var $1mw9Z = parcelRequire("1mw9Z");
var $2Cn0z = parcelRequire("2Cn0z");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$usePressResponderContext(props) {
    // Consume context from <PressResponder> and merge with props.
    let context = (0, $bh6RR.useContext)((0, $6c19b65fd1fa8ecc$export$5165eccb35aaadb5));
    if (context) {
        let { register: register, ...contextProps } = context;
        props = (0, $dCyIs.mergeProps)(contextProps, props);
        register();
    }
    (0, $2Cn0z.useSyncRef)(context, props.ref);
    return props;
}
var $cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$_shouldStopPropagation = /*#__PURE__*/ new WeakMap();
class $cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$PressEvent {
    continuePropagation() {
        (0, $lgPAm._)(this, $cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$_shouldStopPropagation, false);
    }
    get shouldStopPropagation() {
        return (0, $2iPDq._)(this, $cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$_shouldStopPropagation);
    }
    constructor(type, pointerType, originalEvent){
        (0, $f9kyn._)(this, $cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$_shouldStopPropagation, {
            writable: true,
            value: void 0
        });
        (0, $lgPAm._)(this, $cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$_shouldStopPropagation, true);
        this.type = type;
        this.pointerType = pointerType;
        this.target = originalEvent.currentTarget;
        this.shiftKey = originalEvent.shiftKey;
        this.metaKey = originalEvent.metaKey;
        this.ctrlKey = originalEvent.ctrlKey;
        this.altKey = originalEvent.altKey;
    }
}
const $cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$LINK_CLICKED = Symbol("linkClicked");
function $cbf892c24e1f47ab$export$45712eceda6fad21(props) {
    let { onPress: onPress, onPressChange: onPressChange, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressUp: onPressUp, isDisabled: isDisabled, isPressed: isPressedProp, preventFocusOnPress: preventFocusOnPress, shouldCancelOnPointerExit: shouldCancelOnPointerExit, allowTextSelectionOnPress: allowTextSelectionOnPress, ref: _, ...domProps } = $cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$usePressResponderContext(props);
    let [isPressed, setPressed] = (0, $bh6RR.useState)(false);
    let ref = (0, $bh6RR.useRef)({
        isPressed: false,
        ignoreEmulatedMouseEvents: false,
        ignoreClickAfterPress: false,
        didFirePressStart: false,
        isTriggeringEvent: false,
        activePointerId: null,
        target: null,
        isOverTarget: false,
        pointerType: null
    });
    let { addGlobalListener: addGlobalListener, removeAllGlobalListeners: removeAllGlobalListeners } = (0, $1mw9Z.useGlobalListeners)();
    let triggerPressStart = (0, $77fRS.useEffectEvent)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled || state.didFirePressStart) return false;
        let shouldStopPropagation = true;
        state.isTriggeringEvent = true;
        if (onPressStart) {
            let event = new $cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$PressEvent("pressstart", pointerType, originalEvent);
            onPressStart(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(true);
        state.isTriggeringEvent = false;
        state.didFirePressStart = true;
        setPressed(true);
        return shouldStopPropagation;
    });
    let triggerPressEnd = (0, $77fRS.useEffectEvent)((originalEvent, pointerType, wasPressed = true)=>{
        let state = ref.current;
        if (!state.didFirePressStart) return false;
        state.ignoreClickAfterPress = true;
        state.didFirePressStart = false;
        state.isTriggeringEvent = true;
        let shouldStopPropagation = true;
        if (onPressEnd) {
            let event = new $cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$PressEvent("pressend", pointerType, originalEvent);
            onPressEnd(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(false);
        setPressed(false);
        if (onPress && wasPressed && !isDisabled) {
            let event = new $cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$PressEvent("press", pointerType, originalEvent);
            onPress(event);
            shouldStopPropagation && (shouldStopPropagation = event.shouldStopPropagation);
        }
        state.isTriggeringEvent = false;
        return shouldStopPropagation;
    });
    let triggerPressUp = (0, $77fRS.useEffectEvent)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled) return false;
        if (onPressUp) {
            state.isTriggeringEvent = true;
            let event = new $cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$PressEvent("pressup", pointerType, originalEvent);
            onPressUp(event);
            state.isTriggeringEvent = false;
            return event.shouldStopPropagation;
        }
        return true;
    });
    let cancel = (0, $77fRS.useEffectEvent)((e)=>{
        let state = ref.current;
        if (state.isPressed && state.target) {
            if (state.isOverTarget && state.pointerType != null) triggerPressEnd($cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
            state.isPressed = false;
            state.isOverTarget = false;
            state.activePointerId = null;
            state.pointerType = null;
            removeAllGlobalListeners();
            if (!allowTextSelectionOnPress) (0, $b3d8de24accd3f58$export$b0d6fa1ab32e3295)(state.target);
        }
    });
    let cancelOnPointerExit = (0, $77fRS.useEffectEvent)((e)=>{
        if (shouldCancelOnPointerExit) cancel(e);
    });
    let pressProps = (0, $bh6RR.useMemo)(()=>{
        let state = ref.current;
        let pressProps = {
            onKeyDown (e) {
                if ($cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e.nativeEvent, e.currentTarget) && e.currentTarget.contains(e.target)) {
                    var _state_metaKeyEvents;
                    if ($cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                    // If the event is repeating, it may have started on a different element
                    // after which focus moved to the current element. Ignore these events and
                    // only handle the first key down event.
                    let shouldStopPropagation = true;
                    if (!state.isPressed && !e.repeat) {
                        state.target = e.currentTarget;
                        state.isPressed = true;
                        shouldStopPropagation = triggerPressStart(e, "keyboard");
                        // Focus may move before the key up event, so register the event on the document
                        // instead of the same element where the key down event occurred. Make it capturing so that it will trigger
                        // before stopPropagation from useKeyboard on a child element may happen and thus we can still call triggerPress for the parent element.
                        let originalTarget = e.currentTarget;
                        let pressUp = (e)=>{
                            if ($cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e, originalTarget) && !e.repeat && originalTarget.contains(e.target) && state.target) triggerPressUp($cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard");
                        };
                        addGlobalListener((0, $ld26B.getOwnerDocument)(e.currentTarget), "keyup", (0, $i65Wu.chain)(pressUp, onKeyUp), true);
                    }
                    if (shouldStopPropagation) e.stopPropagation();
                    // Keep track of the keydown events that occur while the Meta (e.g. Command) key is held.
                    // macOS has a bug where keyup events are not fired while the Meta key is down.
                    // When the Meta key itself is released we will get an event for that, and we'll act as if
                    // all of these other keys were released as well.
                    // https://bugs.chromium.org/p/chromium/issues/detail?id=1393524
                    // https://bugs.webkit.org/show_bug.cgi?id=55291
                    // https://bugzilla.mozilla.org/show_bug.cgi?id=1299553
                    if (e.metaKey && (0, $kI2if.isMac)()) (_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 || _state_metaKeyEvents.set(e.key, e.nativeEvent);
                } else if (e.key === "Meta") state.metaKeyEvents = new Map();
            },
            onClick (e) {
                if (e && !e.currentTarget.contains(e.target)) return;
                if (e && e.button === 0 && !state.isTriggeringEvent && !(0, $aCMC4.openLink).isOpening) {
                    let shouldStopPropagation = true;
                    if (isDisabled) e.preventDefault();
                    // If triggered from a screen reader or by using element.click(),
                    // trigger as if it were a keyboard click.
                    if (!state.ignoreClickAfterPress && !state.ignoreEmulatedMouseEvents && !state.isPressed && (state.pointerType === "virtual" || (0, $7uYIl.isVirtualClick)(e.nativeEvent))) {
                        // Ensure the element receives focus (VoiceOver on iOS does not do this)
                        if (!isDisabled && !preventFocusOnPress) (0, $61nPD.focusWithoutScrolling)(e.currentTarget);
                        let stopPressStart = triggerPressStart(e, "virtual");
                        let stopPressUp = triggerPressUp(e, "virtual");
                        let stopPressEnd = triggerPressEnd(e, "virtual");
                        shouldStopPropagation = stopPressStart && stopPressUp && stopPressEnd;
                    }
                    state.ignoreEmulatedMouseEvents = false;
                    state.ignoreClickAfterPress = false;
                    if (shouldStopPropagation) e.stopPropagation();
                }
            }
        };
        let onKeyUp = (e)=>{
            var _state_metaKeyEvents;
            if (state.isPressed && state.target && $cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e, state.target)) {
                var _state_metaKeyEvents1;
                if ($cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                let target = e.target;
                triggerPressEnd($cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard", state.target.contains(target));
                removeAllGlobalListeners();
                // If a link was triggered with a key other than Enter, open the URL ourselves.
                // This means the link has a role override, and the default browser behavior
                // only applies when using the Enter key.
                if (e.key !== "Enter" && $cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(state.target) && state.target.contains(target) && !e[$cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$LINK_CLICKED]) {
                    // Store a hidden property on the event so we only trigger link click once,
                    // even if there are multiple usePress instances attached to the element.
                    e[$cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$LINK_CLICKED] = true;
                    (0, $aCMC4.openLink)(state.target, e, false);
                }
                state.isPressed = false;
                (_state_metaKeyEvents1 = state.metaKeyEvents) === null || _state_metaKeyEvents1 === void 0 || _state_metaKeyEvents1.delete(e.key);
            } else if (e.key === "Meta" && ((_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 ? void 0 : _state_metaKeyEvents.size)) {
                var _state_target;
                // If we recorded keydown events that occurred while the Meta key was pressed,
                // and those haven't received keyup events already, fire keyup events ourselves.
                // See comment above for more info about the macOS bug causing this.
                let events = state.metaKeyEvents;
                state.metaKeyEvents = undefined;
                for (let event of events.values())(_state_target = state.target) === null || _state_target === void 0 || _state_target.dispatchEvent(new KeyboardEvent("keyup", event));
            }
        };
        if (typeof PointerEvent !== "undefined") {
            pressProps.onPointerDown = (e)=>{
                // Only handle left clicks, and ignore events that bubbled through portals.
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // iOS safari fires pointer events from VoiceOver with incorrect coordinates/target.
                // Ignore and let the onClick handler take care of it instead.
                // https://bugs.webkit.org/show_bug.cgi?id=222627
                // https://bugs.webkit.org/show_bug.cgi?id=223202
                if ((0, $7uYIl.isVirtualPointerEvent)(e.nativeEvent)) {
                    state.pointerType = "virtual";
                    return;
                }
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on pointer down and handle focusing the pressable element ourselves.
                if ($cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                state.pointerType = e.pointerType;
                let shouldStopPropagation = true;
                if (!state.isPressed) {
                    state.isPressed = true;
                    state.isOverTarget = true;
                    state.activePointerId = e.pointerId;
                    state.target = e.currentTarget;
                    if (!isDisabled && !preventFocusOnPress) (0, $61nPD.focusWithoutScrolling)(e.currentTarget);
                    if (!allowTextSelectionOnPress) (0, $b3d8de24accd3f58$export$16a4697467175487)(state.target);
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    addGlobalListener((0, $ld26B.getOwnerDocument)(e.currentTarget), "pointermove", onPointerMove, false);
                    addGlobalListener((0, $ld26B.getOwnerDocument)(e.currentTarget), "pointerup", onPointerUp, false);
                    addGlobalListener((0, $ld26B.getOwnerDocument)(e.currentTarget), "pointercancel", onPointerCancel, false);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseDown = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (e.button === 0) {
                    // Chrome and Firefox on touch Windows devices require mouse down events
                    // to be canceled in addition to pointer events, or an extra asynchronous
                    // focus event will be fired.
                    if ($cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                    e.stopPropagation();
                }
            };
            pressProps.onPointerUp = (e)=>{
                // iOS fires pointerup with zero width and height, so check the pointerType recorded during pointerdown.
                if (!e.currentTarget.contains(e.target) || state.pointerType === "virtual") return;
                // Only handle left clicks
                // Safari on iOS sometimes fires pointerup events, even
                // when the touch isn't over the target, so double check.
                if (e.button === 0 && $cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$isOverTarget(e, e.currentTarget)) triggerPressUp(e, state.pointerType || e.pointerType);
            };
            // Safari on iOS < 13.2 does not implement pointerenter/pointerleave events correctly.
            // Use pointer move events instead to implement our own hit testing.
            // See https://bugs.webkit.org/show_bug.cgi?id=199803
            let onPointerMove = (e)=>{
                if (e.pointerId !== state.activePointerId) return;
                if (state.target && $cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        triggerPressStart($cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    }
                } else if (state.target && state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    triggerPressEnd($cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    cancelOnPointerExit(e);
                }
            };
            let onPointerUp = (e)=>{
                if (e.pointerId === state.activePointerId && state.isPressed && e.button === 0 && state.target) {
                    if ($cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd($cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    else if (state.isOverTarget && state.pointerType != null) triggerPressEnd($cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    state.isPressed = false;
                    state.isOverTarget = false;
                    state.activePointerId = null;
                    state.pointerType = null;
                    removeAllGlobalListeners();
                    if (!allowTextSelectionOnPress) (0, $b3d8de24accd3f58$export$b0d6fa1ab32e3295)(state.target);
                }
            };
            let onPointerCancel = (e)=>{
                cancel(e);
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                // Safari does not call onPointerCancel when a drag starts, whereas Chrome and Firefox do.
                cancel(e);
            };
        } else {
            pressProps.onMouseDown = (e)=>{
                // Only handle left clicks
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on mouse down and handle focusing the pressable element ourselves.
                if ($cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                if (state.ignoreEmulatedMouseEvents) {
                    e.stopPropagation();
                    return;
                }
                state.isPressed = true;
                state.isOverTarget = true;
                state.target = e.currentTarget;
                state.pointerType = (0, $7uYIl.isVirtualClick)(e.nativeEvent) ? "virtual" : "mouse";
                if (!isDisabled && !preventFocusOnPress) (0, $61nPD.focusWithoutScrolling)(e.currentTarget);
                let shouldStopPropagation = triggerPressStart(e, state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, $ld26B.getOwnerDocument)(e.currentTarget), "mouseup", onMouseUp, false);
            };
            pressProps.onMouseEnter = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = true;
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseLeave = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                    cancelOnPointerExit(e);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseUp = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.ignoreEmulatedMouseEvents && e.button === 0) triggerPressUp(e, state.pointerType || "mouse");
            };
            let onMouseUp = (e)=>{
                // Only handle left clicks
                if (e.button !== 0) return;
                state.isPressed = false;
                removeAllGlobalListeners();
                if (state.ignoreEmulatedMouseEvents) {
                    state.ignoreEmulatedMouseEvents = false;
                    return;
                }
                if (state.target && $cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd($cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                else if (state.target && state.isOverTarget && state.pointerType != null) triggerPressEnd($cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                state.isOverTarget = false;
            };
            pressProps.onTouchStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let touch = $cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$getTouchFromEvent(e.nativeEvent);
                if (!touch) return;
                state.activePointerId = touch.identifier;
                state.ignoreEmulatedMouseEvents = true;
                state.isOverTarget = true;
                state.isPressed = true;
                state.target = e.currentTarget;
                state.pointerType = "touch";
                // Due to browser inconsistencies, especially on mobile browsers, we prevent default
                // on the emulated mouse event and handle focusing the pressable element ourselves.
                if (!isDisabled && !preventFocusOnPress) (0, $61nPD.focusWithoutScrolling)(e.currentTarget);
                if (!allowTextSelectionOnPress) (0, $b3d8de24accd3f58$export$16a4697467175487)(state.target);
                let shouldStopPropagation = triggerPressStart(e, state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, $ld26B.getOwnerWindow)(e.currentTarget), "scroll", onScroll, true);
            };
            pressProps.onTouchMove = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                let touch = $cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                let shouldStopPropagation = true;
                if (touch && $cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    }
                } else if (state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                    cancelOnPointerExit(e);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onTouchEnd = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                let touch = $cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                let shouldStopPropagation = true;
                if (touch && $cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget) && state.pointerType != null) {
                    triggerPressUp(e, state.pointerType);
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType);
                } else if (state.isOverTarget && state.pointerType != null) shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                if (shouldStopPropagation) e.stopPropagation();
                state.isPressed = false;
                state.activePointerId = null;
                state.isOverTarget = false;
                state.ignoreEmulatedMouseEvents = true;
                if (state.target && !allowTextSelectionOnPress) (0, $b3d8de24accd3f58$export$b0d6fa1ab32e3295)(state.target);
                removeAllGlobalListeners();
            };
            pressProps.onTouchCancel = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (state.isPressed) cancel(e);
            };
            let onScroll = (e)=>{
                if (state.isPressed && e.target.contains(state.target)) cancel({
                    currentTarget: state.target,
                    shiftKey: false,
                    ctrlKey: false,
                    metaKey: false,
                    altKey: false
                });
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                cancel(e);
            };
        }
        return pressProps;
    }, [
        addGlobalListener,
        isDisabled,
        preventFocusOnPress,
        removeAllGlobalListeners,
        allowTextSelectionOnPress,
        cancel,
        cancelOnPointerExit,
        triggerPressEnd,
        triggerPressStart,
        triggerPressUp
    ]);
    (0, $bh6RR.useEffect)(()=>{
        return ()=>{
            var _ref_current_target;
            if (!allowTextSelectionOnPress) (0, $b3d8de24accd3f58$export$b0d6fa1ab32e3295)((_ref_current_target = ref.current.target) !== null && _ref_current_target !== void 0 ? _ref_current_target : undefined);
        };
    }, [
        allowTextSelectionOnPress
    ]);
    return {
        isPressed: isPressedProp || isPressed,
        pressProps: (0, $dCyIs.mergeProps)(domProps, pressProps)
    };
}
function $cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target) {
    return target.tagName === "A" && target.hasAttribute("href");
}
function $cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(event, currentTarget) {
    const { key: key, code: code } = event;
    const element = currentTarget;
    const role = element.getAttribute("role");
    // Accessibility for keyboards. Space and Enter only.
    // "Spacebar" is for IE 11
    return (key === "Enter" || key === " " || key === "Spacebar" || code === "Space") && !(element instanceof (0, $ld26B.getOwnerWindow)(element).HTMLInputElement && !$cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$isValidInputKey(element, key) || element instanceof (0, $ld26B.getOwnerWindow)(element).HTMLTextAreaElement || element.isContentEditable) && // Links should only trigger with Enter key
    !((role === "link" || !role && $cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(element)) && key !== "Enter");
}
function $cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$getTouchFromEvent(event) {
    const { targetTouches: targetTouches } = event;
    if (targetTouches.length > 0) return targetTouches[0];
    return null;
}
function $cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$getTouchById(event, pointerId) {
    const changedTouches = event.changedTouches;
    for(let i = 0; i < changedTouches.length; i++){
        const touch = changedTouches[i];
        if (touch.identifier === pointerId) return touch;
    }
    return null;
}
function $cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$createEvent(target, e) {
    return {
        currentTarget: target,
        shiftKey: e.shiftKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        altKey: e.altKey
    };
}
function $cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$getPointClientRect(point) {
    let offsetX = 0;
    let offsetY = 0;
    if (point.width !== undefined) offsetX = point.width / 2;
    else if (point.radiusX !== undefined) offsetX = point.radiusX;
    if (point.height !== undefined) offsetY = point.height / 2;
    else if (point.radiusY !== undefined) offsetY = point.radiusY;
    return {
        top: point.clientY - offsetY,
        right: point.clientX + offsetX,
        bottom: point.clientY + offsetY,
        left: point.clientX - offsetX
    };
}
function $cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(a, b) {
    // check if they cannot overlap on x axis
    if (a.left > b.right || b.left > a.right) return false;
    // check if they cannot overlap on y axis
    if (a.top > b.bottom || b.top > a.bottom) return false;
    return true;
}
function $cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$isOverTarget(point, target) {
    let rect = target.getBoundingClientRect();
    let pointRect = $cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$getPointClientRect(point);
    return $cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(rect, pointRect);
}
function $cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$shouldPreventDefault(target) {
    // We cannot prevent default if the target is a draggable element.
    return !(target instanceof HTMLElement) || !target.hasAttribute("draggable");
}
function $cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(target, key) {
    if (target instanceof HTMLInputElement) return !$cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$isValidInputKey(target, key);
    if (target instanceof HTMLButtonElement) return target.type !== "submit" && target.type !== "reset";
    if ($cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target)) return false;
    return true;
}
const $cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
function $cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$isValidInputKey(target, key) {
    // Only space should toggle checkboxes and radios, not enter.
    return target.type === "checkbox" || target.type === "radio" ? key === " " : $cbf892c24e1f47ab$var$$f6c31cce2adf654f$var$nonTextInputTypes.has(target.type);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $22f7df6f3de797b6$export$ea18c227d4417cc3(props, ref) {
    let { elementType: elementType = "button", isDisabled: isDisabled, onPress: onPress, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressUp: onPressUp, onPressChange: onPressChange, preventFocusOnPress: preventFocusOnPress, allowFocusWhenDisabled: allowFocusWhenDisabled, onClick: deprecatedOnClick, href: href, target: target, rel: rel, type: type = "button" } = props;
    let additionalProps;
    if (elementType === "button") additionalProps = {
        type: type,
        disabled: isDisabled
    };
    else additionalProps = {
        role: "button",
        tabIndex: isDisabled ? undefined : 0,
        href: elementType === "a" && isDisabled ? undefined : href,
        target: elementType === "a" ? target : undefined,
        type: elementType === "input" ? type : undefined,
        disabled: elementType === "input" ? isDisabled : undefined,
        "aria-disabled": !isDisabled || elementType === "input" ? undefined : isDisabled,
        rel: elementType === "a" ? rel : undefined
    };
    let { pressProps: pressProps, isPressed: isPressed } = (0, $cbf892c24e1f47ab$export$45712eceda6fad21)({
        onPressStart: onPressStart,
        onPressEnd: onPressEnd,
        onPressChange: onPressChange,
        onPress: onPress,
        onPressUp: onPressUp,
        isDisabled: isDisabled,
        preventFocusOnPress: preventFocusOnPress,
        ref: ref
    });
    let { focusableProps: focusableProps } = (0, $d84515fe59f4eafa$export$4c014de7c8940b4c)(props, ref);
    if (allowFocusWhenDisabled) focusableProps.tabIndex = isDisabled ? -1 : focusableProps.tabIndex;
    let buttonProps = (0, $dCyIs.mergeProps)(focusableProps, pressProps, (0, $leZvJ.filterDOMProps)(props, {
        labelable: true
    }));
    return {
        isPressed: isPressed,
        buttonProps: (0, $dCyIs.mergeProps)(additionalProps, buttonProps, {
            "aria-haspopup": props["aria-haspopup"],
            "aria-expanded": props["aria-expanded"],
            "aria-controls": props["aria-controls"],
            "aria-pressed": props["aria-pressed"],
            onClick: (e)=>{
                if (deprecatedOnClick) {
                    deprecatedOnClick(e);
                    console.warn("onClick is deprecated, please use onPress");
                }
            }
        })
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $22f7df6f3de797b6$export$51e84d46ca0bc451(props, state, ref) {
    const { isSelected: isSelected } = state;
    const { isPressed: isPressed, buttonProps: buttonProps } = $22f7df6f3de797b6$export$ea18c227d4417cc3({
        ...props,
        onPress: (0, $i65Wu.chain)(state.toggle, props.onPress)
    }, ref);
    return {
        isPressed: isPressed,
        buttonProps: (0, $dCyIs.mergeProps)(buttonProps, {
            "aria-pressed": isSelected
        })
    };
}


function $01cbf276d53a4ffc$export$5eac54fb98d58cea(props, state, ref) {
    let { item: item, isDisabled: isDisabledProp } = props;
    let key = item.key;
    let manager = state.selectionManager;
    let buttonId = (0, $bh6RR.useId)();
    let regionId = (0, $bh6RR.useId)();
    let isDisabled = state.disabledKeys.has(item.key) || isDisabledProp;
    (0, $bh6RR.useEffect)(()=>{
        let isFocused = key === state.focusedKey;
        if (isFocused && document.activeElement !== ref.current) ref.current && (0, $3HS2q.focusSafely)(ref.current);
    }, [
        ref,
        key,
        state.focusedKey
    ]);
    let onSelect = (0, $bh6RR.useCallback)((e)=>{
        if (!manager.canSelectItem(key)) return;
        manager.select(key, e);
        state.toggleKey(key);
    }, [
        key,
        manager
    ]);
    const extendFocusSelection = (0, $bh6RR.useCallback)((toKey)=>{
        if (manager.selectionBehavior === "replace") manager.extendSelection(toKey);
        manager.setFocusedKey(toKey);
    }, [
        manager
    ]);
    const onKeyDown = (0, $bh6RR.useCallback)((event)=>{
        const keyMap = {
            ArrowDown: ()=>{
                const nextKey = state.collection.getKeyAfter(key);
                if (nextKey && state.disabledKeys.has(nextKey)) {
                    const nextEnabledKey = state.collection.getKeyAfter(nextKey);
                    nextEnabledKey && extendFocusSelection(nextEnabledKey);
                } else nextKey && extendFocusSelection(nextKey);
            },
            ArrowUp: ()=>{
                const prevKey = state.collection.getKeyBefore(key);
                if (prevKey && state.disabledKeys.has(prevKey)) {
                    const prevEnabledKey = state.collection.getKeyBefore(prevKey);
                    prevEnabledKey && extendFocusSelection(prevEnabledKey);
                } else prevKey && extendFocusSelection(prevKey);
            },
            Home: ()=>{
                const firstKey = state.collection.getFirstKey();
                firstKey && extendFocusSelection(firstKey);
            },
            End: ()=>{
                const lastKey = state.collection.getLastKey();
                lastKey && extendFocusSelection(lastKey);
            }
        };
        const action = keyMap[event.key];
        if (action) {
            event.preventDefault();
            if (manager.canSelectItem(key)) action(event);
        }
    }, [
        key,
        manager
    ]);
    let { buttonProps: buttonProps } = (0, $22f7df6f3de797b6$export$ea18c227d4417cc3)({
        id: buttonId,
        elementType: "button",
        isDisabled: isDisabled,
        onKeyDown: onKeyDown,
        onPress: onSelect
    }, ref);
    let isExpanded = state.selectionManager.isSelected(item.key);
    return {
        buttonProps: {
            ...buttonProps,
            "aria-expanded": isExpanded,
            "aria-controls": isExpanded ? regionId : void 0
        },
        regionProps: {
            id: regionId,
            role: "region",
            "aria-labelledby": buttonId
        }
    };
}



var $bh6RR = parcelRequire("bh6RR");

var $i65Wu = parcelRequire("i65Wu");
var $dCyIs = parcelRequire("dCyIs");

var $fvnOt = parcelRequire("fvnOt");
"use client";
function $fa1da2ab66b09c06$export$dfe72e7a237bd184(props) {
    var _a, _b;
    const globalContext = (0, $gSab4.useProviderContext)();
    const { ref: ref, as: as, item: item, onFocusChange: onFocusChange } = props;
    const { state: state, className: className, indicator: indicator, children: children, title: title, subtitle: subtitle, startContent: startContent, motionProps: motionProps, focusedKey: focusedKey, isCompact: isCompact = false, classNames: classNamesProp = {}, isDisabled: isDisabledProp = false, hideIndicator: hideIndicator = false, disableAnimation: disableAnimation = (_a = globalContext == null ? void 0 : globalContext.disableAnimation) != null ? _a : false, keepContentMounted: keepContentMounted = false, disableIndicatorAnimation: disableIndicatorAnimation = false, HeadingComponent: HeadingComponent = as || "h2", onPress: onPress, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressChange: onPressChange, onPressUp: onPressUp, onClick: onClick, ...otherProps } = props;
    const Component = as || "div";
    const shouldFilterDOMProps = typeof Component === "string";
    const domRef = (0, $gedB5.useDOMRef)(ref);
    const isDisabled = state.disabledKeys.has(item.key) || isDisabledProp;
    const isOpen = state.selectionManager.isSelected(item.key);
    const { buttonProps: buttonCompleteProps, regionProps: regionProps } = (0, $01cbf276d53a4ffc$export$5eac54fb98d58cea)({
        item: item,
        isDisabled: isDisabled
    }, {
        ...state,
        focusedKey: focusedKey
    }, domRef);
    const { onFocus: onFocusButton, onBlur: onBlurButton, ...buttonProps } = buttonCompleteProps;
    const { isFocused: isFocused, isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $3HS2q.useFocusRing)({
        autoFocus: (_b = item.props) == null ? void 0 : _b.autoFocus
    });
    const { isHovered: isHovered, hoverProps: hoverProps } = (0, $fvnOt.useHover)({
        isDisabled: isDisabled
    });
    const { pressProps: pressProps, isPressed: isPressed } = (0, $fvnOt.usePress)({
        ref: domRef,
        isDisabled: isDisabled,
        onPress: onPress,
        onPressStart: onPressStart,
        onPressEnd: onPressEnd,
        onPressChange: onPressChange,
        onPressUp: onPressUp
    });
    const handleFocus = (0, $bh6RR.useCallback)(()=>{
        onFocusChange == null || onFocusChange(true, item.key);
    }, []);
    const handleBlur = (0, $bh6RR.useCallback)(()=>{
        onFocusChange == null || onFocusChange(false, item.key);
    }, []);
    const classNames = (0, $bh6RR.useMemo)(()=>({
            ...classNamesProp
        }), [
        (0, $6N9Z9.objectToDeps)(classNamesProp)
    ]);
    const slots = (0, $bh6RR.useMemo)(()=>(0, $4c008118e645dd87$export$b0ae97173709dbd3)({
            isCompact: isCompact,
            isDisabled: isDisabled,
            hideIndicator: hideIndicator,
            disableAnimation: disableAnimation,
            disableIndicatorAnimation: disableIndicatorAnimation
        }), [
        isCompact,
        isDisabled,
        hideIndicator,
        disableAnimation,
        disableIndicatorAnimation
    ]);
    const baseStyles = (0, $3xP29.clsx)(classNames == null ? void 0 : classNames.base, className);
    const getBaseProps = (0, $bh6RR.useCallback)((props2 = {})=>{
        return {
            "data-open": (0, $6G4gc.dataAttr)(isOpen),
            "data-disabled": (0, $6G4gc.dataAttr)(isDisabled),
            className: slots.base({
                class: baseStyles
            }),
            ...(0, $dCyIs.mergeProps)((0, $bIkcs.filterDOMProps)(otherProps, {
                enabled: shouldFilterDOMProps
            }), props2)
        };
    }, [
        baseStyles,
        shouldFilterDOMProps,
        otherProps,
        slots,
        item.props,
        isOpen,
        isDisabled
    ]);
    const getButtonProps = (props2 = {})=>{
        var _a2, _b2;
        return {
            ref: domRef,
            "data-open": (0, $6G4gc.dataAttr)(isOpen),
            "data-focus": (0, $6G4gc.dataAttr)(isFocused),
            "data-focus-visible": (0, $6G4gc.dataAttr)(isFocusVisible),
            "data-disabled": (0, $6G4gc.dataAttr)(isDisabled),
            "data-hover": (0, $6G4gc.dataAttr)(isHovered),
            "data-pressed": (0, $6G4gc.dataAttr)(isPressed),
            className: slots.trigger({
                class: classNames == null ? void 0 : classNames.trigger
            }),
            onFocus: (0, $6N9Z9.callAllHandlers)(handleFocus, onFocusButton, focusProps.onFocus, otherProps.onFocus, (_a2 = item.props) == null ? void 0 : _a2.onFocus),
            onBlur: (0, $6N9Z9.callAllHandlers)(handleBlur, onBlurButton, focusProps.onBlur, otherProps.onBlur, (_b2 = item.props) == null ? void 0 : _b2.onBlur),
            ...(0, $dCyIs.mergeProps)(buttonProps, hoverProps, pressProps, props2, {
                onClick: (0, $i65Wu.chain)(pressProps.onClick, onClick)
            })
        };
    };
    const getContentProps = (0, $bh6RR.useCallback)((props2 = {})=>{
        return {
            "data-open": (0, $6G4gc.dataAttr)(isOpen),
            "data-disabled": (0, $6G4gc.dataAttr)(isDisabled),
            className: slots.content({
                class: classNames == null ? void 0 : classNames.content
            }),
            ...(0, $dCyIs.mergeProps)(regionProps, props2)
        };
    }, [
        slots,
        classNames,
        regionProps,
        isOpen,
        isDisabled,
        classNames == null ? void 0 : classNames.content
    ]);
    const getIndicatorProps = (0, $bh6RR.useCallback)((props2 = {})=>{
        return {
            "aria-hidden": (0, $6G4gc.dataAttr)(true),
            "data-open": (0, $6G4gc.dataAttr)(isOpen),
            "data-disabled": (0, $6G4gc.dataAttr)(isDisabled),
            className: slots.indicator({
                class: classNames == null ? void 0 : classNames.indicator
            }),
            ...props2
        };
    }, [
        slots,
        classNames == null ? void 0 : classNames.indicator,
        isOpen,
        isDisabled,
        classNames == null ? void 0 : classNames.indicator
    ]);
    const getHeadingProps = (0, $bh6RR.useCallback)((props2 = {})=>{
        return {
            "data-open": (0, $6G4gc.dataAttr)(isOpen),
            "data-disabled": (0, $6G4gc.dataAttr)(isDisabled),
            className: slots.heading({
                class: classNames == null ? void 0 : classNames.heading
            }),
            ...props2
        };
    }, [
        slots,
        classNames == null ? void 0 : classNames.heading,
        isOpen,
        isDisabled,
        classNames == null ? void 0 : classNames.heading
    ]);
    const getTitleProps = (0, $bh6RR.useCallback)((props2 = {})=>{
        return {
            "data-open": (0, $6G4gc.dataAttr)(isOpen),
            "data-disabled": (0, $6G4gc.dataAttr)(isDisabled),
            className: slots.title({
                class: classNames == null ? void 0 : classNames.title
            }),
            ...props2
        };
    }, [
        slots,
        classNames == null ? void 0 : classNames.title,
        isOpen,
        isDisabled,
        classNames == null ? void 0 : classNames.title
    ]);
    const getSubtitleProps = (0, $bh6RR.useCallback)((props2 = {})=>{
        return {
            "data-open": (0, $6G4gc.dataAttr)(isOpen),
            "data-disabled": (0, $6G4gc.dataAttr)(isDisabled),
            className: slots.subtitle({
                class: classNames == null ? void 0 : classNames.subtitle
            }),
            ...props2
        };
    }, [
        slots,
        classNames,
        isOpen,
        isDisabled,
        classNames == null ? void 0 : classNames.subtitle
    ]);
    return {
        Component: Component,
        HeadingComponent: HeadingComponent,
        item: item,
        slots: slots,
        classNames: classNames,
        domRef: domRef,
        indicator: indicator,
        children: children,
        title: title,
        subtitle: subtitle,
        startContent: startContent,
        isOpen: isOpen,
        isDisabled: isDisabled,
        hideIndicator: hideIndicator,
        keepContentMounted: keepContentMounted,
        disableAnimation: disableAnimation,
        motionProps: motionProps,
        getBaseProps: getBaseProps,
        getHeadingProps: getHeadingProps,
        getButtonProps: getButtonProps,
        getContentProps: getContentProps,
        getIndicatorProps: getIndicatorProps,
        getTitleProps: getTitleProps,
        getSubtitleProps: getSubtitleProps
    };
}



var $hN2BG = parcelRequire("hN2BG");

var $bh6RR = parcelRequire("bh6RR");
// src/chevron.tsx

var $ih19M = parcelRequire("ih19M");
var $b7e92007f3acc56f$export$ae15c545ca677b81 = (props)=>/* @__PURE__ */ (0, $ih19M.jsx)("svg", {
        "aria-hidden": "true",
        fill: "none",
        focusable: "false",
        height: "1em",
        role: "presentation",
        viewBox: "0 0 24 24",
        width: "1em",
        ...props,
        children: /* @__PURE__ */ (0, $ih19M.jsx)("path", {
            d: "M15.5 19l-7-7 7-7",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "1.5"
        })
    });



var $lTq24 = parcelRequire("lTq24");
var $6Vrqz = parcelRequire("6Vrqz");
var $k87FL = parcelRequire("k87FL");
var $dqffP = parcelRequire("dqffP");
var $lB8dT = parcelRequire("lB8dT");

var $4LMqa = parcelRequire("4LMqa");

var $jgfKC = parcelRequire("jgfKC");

var $4I9GC = parcelRequire("4I9GC");

var $Fxl2f = parcelRequire("Fxl2f");

var $1UgmA = parcelRequire("1UgmA");
class $3265e3e4ddaa4ab8$export$3fe5fa490af65f85 extends (0, $Fxl2f.MotionValue) {
    constructor(){
        super(...arguments);
        this.members = [];
        this.transforms = new Set();
    }
    add(name) {
        let memberName;
        if ((0, $4LMqa.transformProps).has(name)) {
            this.transforms.add(name);
            memberName = "transform";
        } else if (!name.startsWith("origin") && !(0, $lB8dT.isCSSVariableName)(name) && name !== "willChange") memberName = (0, $1UgmA.camelToDash)(name);
        if (memberName) {
            (0, $jgfKC.addUniqueItem)(this.members, memberName);
            this.update();
        }
    }
    remove(name) {
        if ((0, $4LMqa.transformProps).has(name)) {
            this.transforms.delete(name);
            if (!this.transforms.size) (0, $jgfKC.removeItem)(this.members, "transform");
        } else (0, $jgfKC.removeItem)(this.members, (0, $1UgmA.camelToDash)(name));
        this.update();
    }
    update() {
        this.set(this.members.length ? this.members.join(", ") : "auto");
    }
}
function $3265e3e4ddaa4ab8$export$384afe146fc0c056() {
    return (0, $4I9GC.useConstant)(()=>new $3265e3e4ddaa4ab8$export$3fe5fa490af65f85("auto"));
}



var $6ujp5 = parcelRequire("6ujp5");

var $ih19M = parcelRequire("ih19M");
"use client";
var $a0b066c6374625da$var$AccordionItem = (0, $hN2BG.forwardRef)((props, ref)=>{
    const { Component: Component, HeadingComponent: HeadingComponent, classNames: classNames, slots: slots, indicator: indicator, children: children, title: title, subtitle: subtitle, startContent: startContent, isOpen: isOpen, isDisabled: isDisabled, hideIndicator: hideIndicator, keepContentMounted: keepContentMounted, disableAnimation: disableAnimation, motionProps: motionProps, getBaseProps: getBaseProps, getHeadingProps: getHeadingProps, getButtonProps: getButtonProps, getTitleProps: getTitleProps, getSubtitleProps: getSubtitleProps, getContentProps: getContentProps, getIndicatorProps: getIndicatorProps } = (0, $fa1da2ab66b09c06$export$dfe72e7a237bd184)({
        ...props,
        ref: ref
    });
    const willChange = (0, $3265e3e4ddaa4ab8$export$384afe146fc0c056)();
    const indicatorContent = (0, $bh6RR.useMemo)(()=>{
        if (typeof indicator === "function") return indicator({
            indicator: /* @__PURE__ */ (0, $ih19M.jsx)((0, $b7e92007f3acc56f$export$ae15c545ca677b81), {}),
            isOpen: isOpen,
            isDisabled: isDisabled
        });
        if (indicator) return indicator;
        return null;
    }, [
        indicator,
        isOpen,
        isDisabled
    ]);
    const indicatorComponent = indicatorContent || /* @__PURE__ */ (0, $ih19M.jsx)((0, $b7e92007f3acc56f$export$ae15c545ca677b81), {});
    const content = (0, $bh6RR.useMemo)(()=>{
        if (disableAnimation) return /* @__PURE__ */ (0, $ih19M.jsx)("div", {
            ...getContentProps(),
            children: children
        });
        return keepContentMounted ? /* @__PURE__ */ (0, $ih19M.jsx)((0, $k87FL.LazyMotion), {
            features: (0, $6Vrqz.domAnimation),
            children: /* @__PURE__ */ (0, $ih19M.jsx)((0, $dqffP.m).section, {
                animate: isOpen ? "enter" : "exit",
                exit: "exit",
                initial: "exit",
                style: {
                    overflowY: "hidden",
                    willChange: willChange
                },
                variants: (0, $6ujp5.TRANSITION_VARIANTS).collapse,
                ...motionProps,
                children: /* @__PURE__ */ (0, $ih19M.jsx)("div", {
                    ...getContentProps(),
                    children: children
                })
            }, "accordion-content")
        }) : /* @__PURE__ */ (0, $ih19M.jsx)((0, $lTq24.AnimatePresence), {
            initial: false,
            children: isOpen && /* @__PURE__ */ (0, $ih19M.jsx)((0, $k87FL.LazyMotion), {
                features: (0, $6Vrqz.domAnimation),
                children: /* @__PURE__ */ (0, $ih19M.jsx)((0, $dqffP.m).section, {
                    animate: "enter",
                    exit: "exit",
                    initial: "exit",
                    style: {
                        overflowY: "hidden",
                        willChange: willChange
                    },
                    variants: (0, $6ujp5.TRANSITION_VARIANTS).collapse,
                    ...motionProps,
                    children: /* @__PURE__ */ (0, $ih19M.jsx)("div", {
                        ...getContentProps(),
                        children: children
                    })
                }, "accordion-content")
            })
        });
    }, [
        isOpen,
        disableAnimation,
        keepContentMounted,
        children,
        motionProps
    ]);
    return /* @__PURE__ */ (0, $ih19M.jsxs)(Component, {
        ...getBaseProps(),
        children: [
            /* @__PURE__ */ (0, $ih19M.jsx)(HeadingComponent, {
                ...getHeadingProps(),
                children: /* @__PURE__ */ (0, $ih19M.jsxs)("button", {
                    ...getButtonProps(),
                    children: [
                        startContent && /* @__PURE__ */ (0, $ih19M.jsx)("div", {
                            className: slots.startContent({
                                class: classNames == null ? void 0 : classNames.startContent
                            }),
                            children: startContent
                        }),
                        /* @__PURE__ */ (0, $ih19M.jsxs)("div", {
                            className: slots.titleWrapper({
                                class: classNames == null ? void 0 : classNames.titleWrapper
                            }),
                            children: [
                                title && /* @__PURE__ */ (0, $ih19M.jsx)("span", {
                                    ...getTitleProps(),
                                    children: title
                                }),
                                subtitle && /* @__PURE__ */ (0, $ih19M.jsx)("span", {
                                    ...getSubtitleProps(),
                                    children: subtitle
                                })
                            ]
                        }),
                        !hideIndicator && indicatorComponent && /* @__PURE__ */ (0, $ih19M.jsx)("span", {
                            ...getIndicatorProps(),
                            children: indicatorComponent
                        })
                    ]
                })
            }),
            content
        ]
    });
});
$a0b066c6374625da$var$AccordionItem.displayName = "NextUI.AccordionItem";
var $a0b066c6374625da$export$5ef1f4ac978cb89a = $a0b066c6374625da$var$AccordionItem;



var $gSab4 = parcelRequire("gSab4");

var $bIkcs = parcelRequire("bIkcs");
var $gedB5 = parcelRequire("gedB5");

var $bh6RR = parcelRequire("bh6RR");

var $52VKi = parcelRequire("52VKi");
var $mPpgr = parcelRequire("mPpgr");

var $bh6RR = parcelRequire("bh6RR");

var $1OXFU = parcelRequire("1OXFU");

var $6YdNt = parcelRequire("6YdNt");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $2eb53f72fa5c6dbd$export$863faf230ee2118a {
    *[Symbol.iterator]() {
        yield* this.iterable;
    }
    get size() {
        return this.keyMap.size;
    }
    getKeys() {
        return this.keyMap.keys();
    }
    getKeyBefore(key) {
        let node = this.keyMap.get(key);
        return node ? node.prevKey : null;
    }
    getKeyAfter(key) {
        let node = this.keyMap.get(key);
        return node ? node.nextKey : null;
    }
    getFirstKey() {
        return this.firstKey;
    }
    getLastKey() {
        return this.lastKey;
    }
    getItem(key) {
        return this.keyMap.get(key);
    }
    at(idx) {
        const keys = [
            ...this.getKeys()
        ];
        return this.getItem(keys[idx]);
    }
    constructor(nodes, { expandedKeys: expandedKeys } = {}){
        this.keyMap = new Map();
        this.iterable = nodes;
        expandedKeys = expandedKeys || new Set();
        let visit = (node)=>{
            this.keyMap.set(node.key, node);
            if (node.childNodes && (node.type === "section" || expandedKeys.has(node.key))) for (let child of node.childNodes)visit(child);
        };
        for (let node of nodes)visit(node);
        let last;
        let index = 0;
        for (let [key, node] of this.keyMap){
            if (last) {
                last.nextKey = key;
                node.prevKey = last.key;
            } else {
                this.firstKey = key;
                node.prevKey = undefined;
            }
            if (node.type === "item") node.index = index++;
            last = node;
            // Set nextKey as undefined since this might be the last node
            // If it isn't the last node, last.nextKey will properly set at start of new loop
            last.nextKey = undefined;
        }
        this.lastKey = last === null || last === void 0 ? void 0 : last.key;
    }
}
function $2eb53f72fa5c6dbd$export$728d6ba534403756(props) {
    let [expandedKeys, setExpandedKeys] = (0, $6YdNt.useControlledState)(props.expandedKeys ? new Set(props.expandedKeys) : undefined, props.defaultExpandedKeys ? new Set(props.defaultExpandedKeys) : new Set(), props.onExpandedChange);
    let selectionState = (0, $mPpgr.useMultipleSelectionState)(props);
    let disabledKeys = (0, $bh6RR.useMemo)(()=>props.disabledKeys ? new Set(props.disabledKeys) : new Set(), [
        props.disabledKeys
    ]);
    let tree = (0, $1OXFU.useCollection)(props, (0, $bh6RR.useCallback)((nodes)=>new $2eb53f72fa5c6dbd$export$863faf230ee2118a(nodes, {
            expandedKeys: expandedKeys
        }), [
        expandedKeys
    ]), null);
    (0, $bh6RR.useEffect)(()=>{
        if (selectionState.focusedKey != null && !tree.getItem(selectionState.focusedKey)) selectionState.setFocusedKey(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tree,
        selectionState.focusedKey
    ]);
    let onToggle = (key)=>{
        setExpandedKeys($2eb53f72fa5c6dbd$var$$875d6693e12af071$var$toggleKey(expandedKeys, key));
    };
    return {
        collection: tree,
        expandedKeys: expandedKeys,
        disabledKeys: disabledKeys,
        toggleKey: onToggle,
        setExpandedKeys: setExpandedKeys,
        selectionManager: new (0, $52VKi.SelectionManager)(tree, selectionState)
    };
}
function $2eb53f72fa5c6dbd$var$$875d6693e12af071$var$toggleKey(set, key) {
    let res = new Set(set);
    if (res.has(key)) res.delete(key);
    else res.add(key);
    return res;
}



var $dCyIs = parcelRequire("dCyIs");

// src/use-accordion.ts

var $6afFj = parcelRequire("6afFj");

var $bh6RR = parcelRequire("bh6RR");

var $61nPD = parcelRequire("61nPD");
var $ld26B = parcelRequire("ld26B");
var $8l8s9 = parcelRequire("8l8s9");

var $ld26B = parcelRequire("ld26B");
var $kI2if = parcelRequire("kI2if");
var $7uYIl = parcelRequire("7uYIl");

var $bh6RR = parcelRequire("bh6RR");

var $2GhkT = parcelRequire("2GhkT");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $5f09b245b1b78407$var$$507fabe10e71c6fb$var$currentModality = null;
let $5f09b245b1b78407$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $5f09b245b1b78407$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $5f09b245b1b78407$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $5f09b245b1b78407$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $5f09b245b1b78407$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $5f09b245b1b78407$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $5f09b245b1b78407$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $5f09b245b1b78407$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $kI2if.isMac)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $5f09b245b1b78407$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $5f09b245b1b78407$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($5f09b245b1b78407$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $5f09b245b1b78407$var$$507fabe10e71c6fb$var$currentModality = "keyboard";
        $5f09b245b1b78407$var$$507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $5f09b245b1b78407$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $5f09b245b1b78407$var$$507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $5f09b245b1b78407$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $5f09b245b1b78407$var$$507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $5f09b245b1b78407$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $7uYIl.isVirtualClick)(e)) {
        $5f09b245b1b78407$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $5f09b245b1b78407$var$$507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $5f09b245b1b78407$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$5f09b245b1b78407$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$5f09b245b1b78407$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $5f09b245b1b78407$var$$507fabe10e71c6fb$var$currentModality = "virtual";
        $5f09b245b1b78407$var$$507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $5f09b245b1b78407$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $5f09b245b1b78407$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $5f09b245b1b78407$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $5f09b245b1b78407$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $5f09b245b1b78407$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $5f09b245b1b78407$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === "undefined" || $5f09b245b1b78407$export$d90243b58daecda7.get((0, $ld26B.getOwnerWindow)(element))) return;
    const windowObject = (0, $ld26B.getOwnerWindow)(element);
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $5f09b245b1b78407$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener("keydown", $5f09b245b1b78407$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("keyup", $5f09b245b1b78407$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("click", $5f09b245b1b78407$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener("focus", $5f09b245b1b78407$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener("blur", $5f09b245b1b78407$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.addEventListener("pointerdown", $5f09b245b1b78407$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointermove", $5f09b245b1b78407$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointerup", $5f09b245b1b78407$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener("mousedown", $5f09b245b1b78407$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mousemove", $5f09b245b1b78407$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mouseup", $5f09b245b1b78407$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener("beforeunload", ()=>{
        $5f09b245b1b78407$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $5f09b245b1b78407$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $5f09b245b1b78407$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $ld26B.getOwnerWindow)(element);
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
    if (!$5f09b245b1b78407$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $5f09b245b1b78407$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener("keydown", $5f09b245b1b78407$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("keyup", $5f09b245b1b78407$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("click", $5f09b245b1b78407$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener("focus", $5f09b245b1b78407$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener("blur", $5f09b245b1b78407$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.removeEventListener("pointerdown", $5f09b245b1b78407$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointermove", $5f09b245b1b78407$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointerup", $5f09b245b1b78407$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener("mousedown", $5f09b245b1b78407$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mousemove", $5f09b245b1b78407$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mouseup", $5f09b245b1b78407$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $5f09b245b1b78407$export$d90243b58daecda7.delete(windowObject);
};
function $5f09b245b1b78407$export$2f1888112f558a7d(element) {
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    let loadListener;
    if (documentObject.readyState !== "loading") $5f09b245b1b78407$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $5f09b245b1b78407$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener("DOMContentLoaded", loadListener);
    }
    return ()=>$5f09b245b1b78407$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== "undefined") $5f09b245b1b78407$export$2f1888112f558a7d();
function $5f09b245b1b78407$export$b9b3dfddab17db27() {
    return $5f09b245b1b78407$var$$507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $5f09b245b1b78407$export$630ff653c5ada6a9() {
    return $5f09b245b1b78407$var$$507fabe10e71c6fb$var$currentModality;
}
function $5f09b245b1b78407$export$8397ddfc504fdb9a(modality) {
    $5f09b245b1b78407$var$$507fabe10e71c6fb$var$currentModality = modality;
    $5f09b245b1b78407$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $5f09b245b1b78407$export$98e20ec92f614cfe() {
    $5f09b245b1b78407$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $bh6RR.useState)($5f09b245b1b78407$var$$507fabe10e71c6fb$var$currentModality);
    (0, $bh6RR.useEffect)(()=>{
        let handler = ()=>{
            setModality($5f09b245b1b78407$var$$507fabe10e71c6fb$var$currentModality);
        };
        $5f09b245b1b78407$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $5f09b245b1b78407$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $2GhkT.useIsSSR)() ? null : modality;
}
const $5f09b245b1b78407$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $5f09b245b1b78407$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    const IHTMLInputElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$5f09b245b1b78407$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === "keyboard" && e instanceof IKeyboardEvent && !$5f09b245b1b78407$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $5f09b245b1b78407$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $bh6RR.useState)(autoFocus || $5f09b245b1b78407$export$b9b3dfddab17db27());
    $5f09b245b1b78407$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $5f09b245b1b78407$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $5f09b245b1b78407$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $bh6RR.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$5f09b245b1b78407$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($5f09b245b1b78407$export$b9b3dfddab17db27());
        };
        $5f09b245b1b78407$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $5f09b245b1b78407$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $8c68352ee20b4e72$export$80f3e147d781571c(element) {
    // If the user is interacting with a virtual cursor, e.g. screen reader, then
    // wait until after any animated transitions that are currently occurring on
    // the page before shifting focus. This avoids issues with VoiceOver on iOS
    // causing the page to scroll when moving focus if the element is transitioning
    // from off the screen.
    const ownerDocument = (0, $ld26B.getOwnerDocument)(element);
    if ((0, $5f09b245b1b78407$export$630ff653c5ada6a9)() === "virtual") {
        let lastFocusedElement = ownerDocument.activeElement;
        (0, $8l8s9.runAfterTransition)(()=>{
            // If focus did not move and the element is still in the document, focus it.
            if (ownerDocument.activeElement === lastFocusedElement && element.isConnected) (0, $61nPD.focusWithoutScrolling)(element);
        });
    } else (0, $61nPD.focusWithoutScrolling)(element);
}



var $ld26B = parcelRequire("ld26B");
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $df81c44924425398$var$$645f2e67b85a24c9$var$isStyleVisible(element) {
    const windowObject = (0, $ld26B.getOwnerWindow)(element);
    if (!(element instanceof windowObject.HTMLElement) && !(element instanceof windowObject.SVGElement)) return false;
    let { display: display, visibility: visibility } = element.style;
    let isVisible = display !== "none" && visibility !== "hidden" && visibility !== "collapse";
    if (isVisible) {
        const { getComputedStyle: getComputedStyle } = element.ownerDocument.defaultView;
        let { display: computedDisplay, visibility: computedVisibility } = getComputedStyle(element);
        isVisible = computedDisplay !== "none" && computedVisibility !== "hidden" && computedVisibility !== "collapse";
    }
    return isVisible;
}
function $df81c44924425398$var$$645f2e67b85a24c9$var$isAttributeVisible(element, childElement) {
    return !element.hasAttribute("hidden") && // Ignore HiddenSelect when tree walking.
    !element.hasAttribute("data-react-aria-prevent-focus") && (element.nodeName === "DETAILS" && childElement && childElement.nodeName !== "SUMMARY" ? element.hasAttribute("open") : true);
}
function $df81c44924425398$export$e989c0fffaa6b27a(element, childElement) {
    return element.nodeName !== "#comment" && $df81c44924425398$var$$645f2e67b85a24c9$var$isStyleVisible(element) && $df81c44924425398$var$$645f2e67b85a24c9$var$isAttributeVisible(element, childElement) && (!element.parentElement || $df81c44924425398$export$e989c0fffaa6b27a(element.parentElement, element));
}



var $ld26B = parcelRequire("ld26B");
var $1nsPC = parcelRequire("1nsPC");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$FocusContext = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(null);
let $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$activeScope = null;
function $c3df6e3815e9c56f$export$20e40289641fbbb6(props) {
    let { children: children, contain: contain, restoreFocus: restoreFocus, autoFocus: autoFocus } = props;
    let startRef = (0, $bh6RR.useRef)(null);
    let endRef = (0, $bh6RR.useRef)(null);
    let scopeRef = (0, $bh6RR.useRef)([]);
    let { parentNode: parentNode } = (0, $bh6RR.useContext)($c3df6e3815e9c56f$var$$9bf71ea28793e738$var$FocusContext) || {};
    // Create a tree node here so we can add children to it even before it is added to the tree.
    let node = (0, $bh6RR.useMemo)(()=>new $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: scopeRef
        }), [
        scopeRef
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        // If a new scope mounts outside the active scope, (e.g. DialogContainer launched from a menu),
        // use the active scope as the parent instead of the parent from context. Layout effects run bottom
        // up, so if the parent is not yet added to the tree, don't do this. Only the outer-most FocusScope
        // that is being added should get the activeScope as its parent.
        let parent = parentNode || $c3df6e3815e9c56f$export$d06fae2ee68b101e.root;
        if ($c3df6e3815e9c56f$export$d06fae2ee68b101e.getTreeNode(parent.scopeRef) && $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$activeScope && !$c3df6e3815e9c56f$var$$9bf71ea28793e738$var$isAncestorScope($c3df6e3815e9c56f$var$$9bf71ea28793e738$var$activeScope, parent.scopeRef)) {
            let activeNode = $c3df6e3815e9c56f$export$d06fae2ee68b101e.getTreeNode($c3df6e3815e9c56f$var$$9bf71ea28793e738$var$activeScope);
            if (activeNode) parent = activeNode;
        }
        // Add the node to the parent, and to the tree.
        parent.addChild(node);
        $c3df6e3815e9c56f$export$d06fae2ee68b101e.addNode(node);
    }, [
        node,
        parentNode
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        let node = $c3df6e3815e9c56f$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (node) node.contain = !!contain;
    }, [
        contain
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        var _startRef_current;
        // Find all rendered nodes between the sentinels and add them to the scope.
        let node = (_startRef_current = startRef.current) === null || _startRef_current === void 0 ? void 0 : _startRef_current.nextSibling;
        let nodes = [];
        while(node && node !== endRef.current){
            nodes.push(node);
            node = node.nextSibling;
        }
        scopeRef.current = nodes;
    }, [
        children
    ]);
    $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restoreFocus, contain);
    $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$useFocusContainment(scopeRef, contain);
    $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain);
    $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus);
    (0, $bh6RR.useEffect)(()=>{
        const activeElement = (0, $ld26B.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined).activeElement;
        let scope = null;
        if ($c3df6e3815e9c56f$var$$9bf71ea28793e738$var$isElementInScope(activeElement, scopeRef.current)) {
            // We need to traverse the focusScope tree and find the bottom most scope that
            // contains the active element and set that as the activeScope.
            for (let node of $c3df6e3815e9c56f$export$d06fae2ee68b101e.traverse())if (node.scopeRef && $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$isElementInScope(activeElement, node.scopeRef.current)) scope = node;
            if (scope === $c3df6e3815e9c56f$export$d06fae2ee68b101e.getTreeNode(scopeRef)) $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$activeScope = scope.scopeRef;
        }
    }, [
        scopeRef
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        return ()=>{
            var _focusScopeTree_getTreeNode_parent, _focusScopeTree_getTreeNode;
            var _focusScopeTree_getTreeNode_parent_scopeRef;
            // Scope may have been re-parented.
            let parentScope = (_focusScopeTree_getTreeNode_parent_scopeRef = (_focusScopeTree_getTreeNode = $c3df6e3815e9c56f$export$d06fae2ee68b101e.getTreeNode(scopeRef)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : (_focusScopeTree_getTreeNode_parent = _focusScopeTree_getTreeNode.parent) === null || _focusScopeTree_getTreeNode_parent === void 0 ? void 0 : _focusScopeTree_getTreeNode_parent.scopeRef) !== null && _focusScopeTree_getTreeNode_parent_scopeRef !== void 0 ? _focusScopeTree_getTreeNode_parent_scopeRef : null;
            if ((scopeRef === $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$activeScope || $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$isAncestorScope(scopeRef, $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$activeScope)) && (!parentScope || $c3df6e3815e9c56f$export$d06fae2ee68b101e.getTreeNode(parentScope))) $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$activeScope = parentScope;
            $c3df6e3815e9c56f$export$d06fae2ee68b101e.removeTreeNode(scopeRef);
        };
    }, [
        scopeRef
    ]);
    let focusManager = (0, $bh6RR.useMemo)(()=>$c3df6e3815e9c56f$var$$9bf71ea28793e738$var$createFocusManagerForScope(scopeRef), []);
    let value = (0, $bh6RR.useMemo)(()=>({
            focusManager: focusManager,
            parentNode: node
        }), [
        node,
        focusManager
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($c3df6e3815e9c56f$var$$9bf71ea28793e738$var$FocusContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("span", {
        "data-focus-scope-start": true,
        hidden: true,
        ref: startRef
    }), children, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("span", {
        "data-focus-scope-end": true,
        hidden: true,
        ref: endRef
    }));
}
function $c3df6e3815e9c56f$export$10c5169755ce7bd7() {
    var _useContext;
    return (_useContext = (0, $bh6RR.useContext)($c3df6e3815e9c56f$var$$9bf71ea28793e738$var$FocusContext)) === null || _useContext === void 0 ? void 0 : _useContext.focusManager;
}
function $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$createFocusManagerForScope(scopeRef) {
    return {
        focusNext (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            let node = from || (0, $ld26B.getOwnerDocument)(scope[0]).activeElement;
            let sentinel = scope[0].previousElementSibling;
            let scopeRoot = $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $c3df6e3815e9c56f$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = sentinel;
                nextNode = walker.nextNode();
            }
            if (nextNode) $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            let node = from || (0, $ld26B.getOwnerDocument)(scope[0]).activeElement;
            let sentinel = scope[scope.length - 1].nextElementSibling;
            let scopeRoot = $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $c3df6e3815e9c56f$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = sentinel;
                previousNode = walker.previousNode();
            }
            if (previousNode) $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        },
        focusFirst (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let scopeRoot = $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $c3df6e3815e9c56f$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[0].previousElementSibling;
            let nextNode = walker.nextNode();
            if (nextNode) $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let scopeRoot = $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $c3df6e3815e9c56f$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[scope.length - 1].nextElementSibling;
            let previousNode = walker.previousNode();
            if (previousNode) $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        }
    };
}
const $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$focusableElements = [
    "input:not([disabled]):not([type=hidden])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    "a[href]",
    "area[href]",
    "summary",
    "iframe",
    "object",
    "embed",
    "audio[controls]",
    "video[controls]",
    "[contenteditable]"
];
const $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR = $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$focusableElements.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
$c3df6e3815e9c56f$var$$9bf71ea28793e738$var$focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR = $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$focusableElements.join(':not([hidden]):not([tabindex="-1"]),');
function $c3df6e3815e9c56f$export$4c063cf1350e6fed(element) {
    return element.matches($c3df6e3815e9c56f$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR);
}
function $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$getScopeRoot(scope) {
    return scope[0].parentElement;
}
function $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) {
    let scope = $c3df6e3815e9c56f$export$d06fae2ee68b101e.getTreeNode($c3df6e3815e9c56f$var$$9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.contain) return false;
        scope = scope.parent;
    }
    return true;
}
function $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$useFocusContainment(scopeRef, contain) {
    let focusedNode = (0, $bh6RR.useRef)();
    let raf = (0, $bh6RR.useRef)();
    (0, $1nsPC.useLayoutEffect)(()=>{
        let scope = scopeRef.current;
        if (!contain) {
            // if contain was changed, then we should cancel any ongoing waits to pull focus back into containment
            if (raf.current) {
                cancelAnimationFrame(raf.current);
                raf.current = undefined;
            }
            return;
        }
        const ownerDocument = (0, $ld26B.getOwnerDocument)(scope ? scope[0] : undefined);
        // Handle the Tab key to contain focus within the scope
        let onKeyDown = (e)=>{
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !$c3df6e3815e9c56f$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) || e.isComposing) return;
            let focusedElement = ownerDocument.activeElement;
            let scope = scopeRef.current;
            if (!scope || !$c3df6e3815e9c56f$var$$9bf71ea28793e738$var$isElementInScope(focusedElement, scope)) return;
            let scopeRoot = $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $c3df6e3815e9c56f$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: true
            }, scope);
            if (!focusedElement) return;
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nextElement) {
                walker.currentNode = e.shiftKey ? scope[scope.length - 1].nextElementSibling : scope[0].previousElementSibling;
                nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            }
            e.preventDefault();
            if (nextElement) $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$focusElement(nextElement, true);
        };
        let onFocus = (e)=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$c3df6e3815e9c56f$var$$9bf71ea28793e738$var$activeScope || $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$isAncestorScope($c3df6e3815e9c56f$var$$9bf71ea28793e738$var$activeScope, scopeRef)) && $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$isElementInScope(e.target, scopeRef.current)) {
                $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$activeScope = scopeRef;
                focusedNode.current = e.target;
            } else if ($c3df6e3815e9c56f$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$c3df6e3815e9c56f$var$$9bf71ea28793e738$var$isElementInChildScope(e.target, scopeRef)) {
                // If a focus event occurs outside the active scope (e.g. user tabs from browser location bar),
                // restore focus to the previously focused node or the first tabbable element in the active scope.
                if (focusedNode.current) focusedNode.current.focus();
                else if ($c3df6e3815e9c56f$var$$9bf71ea28793e738$var$activeScope && $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$activeScope.current) $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$focusFirstInScope($c3df6e3815e9c56f$var$$9bf71ea28793e738$var$activeScope.current);
            } else if ($c3df6e3815e9c56f$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef)) focusedNode.current = e.target;
        };
        let onBlur = (e)=>{
            // Firefox doesn't shift focus back to the Dialog properly without this
            if (raf.current) cancelAnimationFrame(raf.current);
            raf.current = requestAnimationFrame(()=>{
                // Use document.activeElement instead of e.relatedTarget so we can tell if user clicked into iframe
                if (ownerDocument.activeElement && $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$c3df6e3815e9c56f$var$$9bf71ea28793e738$var$isElementInChildScope(ownerDocument.activeElement, scopeRef)) {
                    $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$activeScope = scopeRef;
                    if (ownerDocument.body.contains(e.target)) {
                        var _focusedNode_current;
                        focusedNode.current = e.target;
                        (_focusedNode_current = focusedNode.current) === null || _focusedNode_current === void 0 || _focusedNode_current.focus();
                    } else if ($c3df6e3815e9c56f$var$$9bf71ea28793e738$var$activeScope.current) $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$focusFirstInScope($c3df6e3815e9c56f$var$$9bf71ea28793e738$var$activeScope.current);
                }
            });
        };
        ownerDocument.addEventListener("keydown", onKeyDown, false);
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusout", onBlur, false));
        return ()=>{
            ownerDocument.removeEventListener("keydown", onKeyDown, false);
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusout", onBlur, false));
        };
    }, [
        scopeRef,
        contain
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        return ()=>{
            if (raf.current) cancelAnimationFrame(raf.current);
        };
    }, [
        raf
    ]);
}
function $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$isElementInAnyScope(element) {
    return $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$isElementInChildScope(element);
}
function $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$isElementInScope(element, scope) {
    if (!element) return false;
    if (!scope) return false;
    return scope.some((node)=>node.contains(element));
}
function $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$isElementInChildScope(element, scope = null) {
    // If the element is within a top layer element (e.g. toasts), always allow moving focus there.
    if (element instanceof Element && element.closest("[data-react-aria-top-layer]")) return true;
    // node.contains in isElementInScope covers child scopes that are also DOM children,
    // but does not cover child scopes in portals.
    for (let { scopeRef: s } of $c3df6e3815e9c56f$export$d06fae2ee68b101e.traverse($c3df6e3815e9c56f$export$d06fae2ee68b101e.getTreeNode(scope))){
        if (s && $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$isElementInScope(element, s.current)) return true;
    }
    return false;
}
function $c3df6e3815e9c56f$export$1258395f99bf9cbf(element) {
    return $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$isElementInChildScope(element, $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$activeScope);
}
function $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$isAncestorScope(ancestor, scope) {
    var _focusScopeTree_getTreeNode;
    let parent = (_focusScopeTree_getTreeNode = $c3df6e3815e9c56f$export$d06fae2ee68b101e.getTreeNode(scope)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : _focusScopeTree_getTreeNode.parent;
    while(parent){
        if (parent.scopeRef === ancestor) return true;
        parent = parent.parent;
    }
    return false;
}
function $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$focusElement(element, scroll = false) {
    if (element != null && !scroll) try {
        (0, $8c68352ee20b4e72$export$80f3e147d781571c)(element);
    } catch (err) {
    // ignore
    }
    else if (element != null) try {
        element.focus();
    } catch (err) {
    // ignore
    }
}
function $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$focusFirstInScope(scope, tabbable = true) {
    let sentinel = scope[0].previousElementSibling;
    let scopeRoot = $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$getScopeRoot(scope);
    let walker = $c3df6e3815e9c56f$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable: tabbable
    }, scope);
    walker.currentNode = sentinel;
    let nextNode = walker.nextNode();
    // If the scope does not contain a tabbable element, use the first focusable element.
    if (tabbable && !nextNode) {
        scopeRoot = $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$getScopeRoot(scope);
        walker = $c3df6e3815e9c56f$export$2d6ec8fc375ceafa(scopeRoot, {
            tabbable: false
        }, scope);
        walker.currentNode = sentinel;
        nextNode = walker.nextNode();
    }
    $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$focusElement(nextNode);
}
function $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus) {
    const autoFocusRef = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(autoFocus);
    (0, $bh6RR.useEffect)(()=>{
        if (autoFocusRef.current) {
            $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$activeScope = scopeRef;
            const ownerDocument = (0, $ld26B.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
            if (!$c3df6e3815e9c56f$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$activeScope.current) && scopeRef.current) $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$focusFirstInScope(scopeRef.current);
        }
        autoFocusRef.current = false;
    }, [
        scopeRef
    ]);
}
function $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restore, contain) {
    (0, $1nsPC.useLayoutEffect)(()=>{
        if (restore || contain) return;
        let scope = scopeRef.current;
        const ownerDocument = (0, $ld26B.getOwnerDocument)(scope ? scope[0] : undefined);
        let onFocus = (e)=>{
            let target = e.target;
            if ($c3df6e3815e9c56f$var$$9bf71ea28793e738$var$isElementInScope(target, scopeRef.current)) $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$activeScope = scopeRef;
            else if (!$c3df6e3815e9c56f$var$$9bf71ea28793e738$var$isElementInAnyScope(target)) $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$activeScope = null;
        };
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        return ()=>{
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
        };
    }, [
        scopeRef,
        restore,
        contain
    ]);
}
function $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef) {
    let scope = $c3df6e3815e9c56f$export$d06fae2ee68b101e.getTreeNode($c3df6e3815e9c56f$var$$9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.nodeToRestore) return false;
        scope = scope.parent;
    }
    return (scope === null || scope === void 0 ? void 0 : scope.scopeRef) === scopeRef;
}
function $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain) {
    // create a ref during render instead of useLayoutEffect so the active element is saved before a child with autoFocus=true mounts.
    // eslint-disable-next-line no-restricted-globals
    const nodeToRestoreRef = (0, $bh6RR.useRef)(typeof document !== "undefined" ? (0, $ld26B.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined).activeElement : null);
    (0, $1nsPC.useLayoutEffect)(()=>{
        let scope = scopeRef.current;
        const ownerDocument = (0, $ld26B.getOwnerDocument)(scope ? scope[0] : undefined);
        if (!restoreFocus || contain) return;
        let onFocus = ()=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$c3df6e3815e9c56f$var$$9bf71ea28793e738$var$activeScope || $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$isAncestorScope($c3df6e3815e9c56f$var$$9bf71ea28793e738$var$activeScope, scopeRef)) && $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, scopeRef.current)) $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$activeScope = scopeRef;
        };
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        return ()=>{
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        scopeRef,
        contain
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        const ownerDocument = (0, $ld26B.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        // Handle the Tab key so that tabbing out of the scope goes to the next element
        // after the node that had focus when the scope mounted. This is important when
        // using portals for overlays, so that focus goes to the expected element when
        // tabbing out of the overlay.
        let onKeyDown = (e)=>{
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !$c3df6e3815e9c56f$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) || e.isComposing) return;
            let focusedElement = ownerDocument.activeElement;
            if (!$c3df6e3815e9c56f$var$$9bf71ea28793e738$var$isElementInScope(focusedElement, scopeRef.current)) return;
            let treeNode = $c3df6e3815e9c56f$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // Create a DOM tree walker that matches all tabbable elements
            let walker = $c3df6e3815e9c56f$export$2d6ec8fc375ceafa(ownerDocument.body, {
                tabbable: true
            });
            // Find the next tabbable element after the currently focused element
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nodeToRestore || !ownerDocument.body.contains(nodeToRestore) || nodeToRestore === ownerDocument.body) {
                nodeToRestore = undefined;
                treeNode.nodeToRestore = undefined;
            }
            // If there is no next element, or it is outside the current scope, move focus to the
            // next element after the node to restore to instead.
            if ((!nextElement || !$c3df6e3815e9c56f$var$$9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current)) && nodeToRestore) {
                walker.currentNode = nodeToRestore;
                // Skip over elements within the scope, in case the scope immediately follows the node to restore.
                do nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
                while ($c3df6e3815e9c56f$var$$9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current));
                e.preventDefault();
                e.stopPropagation();
                if (nextElement) $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$focusElement(nextElement, true);
                else // then move focus to the body.
                // Otherwise restore focus to the nodeToRestore (e.g menu within a popover -> tabbing to close the menu should move focus to menu trigger)
                if (!$c3df6e3815e9c56f$var$$9bf71ea28793e738$var$isElementInAnyScope(nodeToRestore)) focusedElement.blur();
                else $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$focusElement(nodeToRestore, true);
            }
        };
        if (!contain) ownerDocument.addEventListener("keydown", onKeyDown, true);
        return ()=>{
            if (!contain) ownerDocument.removeEventListener("keydown", onKeyDown, true);
        };
    }, [
        scopeRef,
        restoreFocus,
        contain
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        const ownerDocument = (0, $ld26B.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        let treeNode = $c3df6e3815e9c56f$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (!treeNode) return;
        var _nodeToRestoreRef_current;
        treeNode.nodeToRestore = (_nodeToRestoreRef_current = nodeToRestoreRef.current) !== null && _nodeToRestoreRef_current !== void 0 ? _nodeToRestoreRef_current : undefined;
        return ()=>{
            let treeNode = $c3df6e3815e9c56f$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // if we already lost focus to the body and this was the active scope, then we should attempt to restore
            if (restoreFocus && nodeToRestore && // eslint-disable-next-line react-hooks/exhaustive-deps
            ($c3df6e3815e9c56f$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, scopeRef.current) || ownerDocument.activeElement === ownerDocument.body && $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef))) {
                // freeze the focusScopeTree so it persists after the raf, otherwise during unmount nodes are removed from it
                let clonedTree = $c3df6e3815e9c56f$export$d06fae2ee68b101e.clone();
                requestAnimationFrame(()=>{
                    // Only restore focus if we've lost focus to the body, the alternative is that focus has been purposefully moved elsewhere
                    if (ownerDocument.activeElement === ownerDocument.body) {
                        // look up the tree starting with our scope to find a nodeToRestore still in the DOM
                        let treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.nodeToRestore && treeNode.nodeToRestore.isConnected) {
                                $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$focusElement(treeNode.nodeToRestore);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                        // If no nodeToRestore was found, focus the first element in the nearest
                        // ancestor scope that is still in the tree.
                        treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.scopeRef && treeNode.scopeRef.current && $c3df6e3815e9c56f$export$d06fae2ee68b101e.getTreeNode(treeNode.scopeRef)) {
                                $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$focusFirstInScope(treeNode.scopeRef.current, true);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                    }
                });
            }
        };
    }, [
        scopeRef,
        restoreFocus
    ]);
}
function $c3df6e3815e9c56f$export$2d6ec8fc375ceafa(root, opts, scope) {
    let selector = (opts === null || opts === void 0 ? void 0 : opts.tabbable) ? $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR : $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR;
    let walker = (0, $ld26B.getOwnerDocument)(root).createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
        acceptNode (node) {
            var _opts_from;
            // Skip nodes inside the starting node.
            if (opts === null || opts === void 0 ? void 0 : (_opts_from = opts.from) === null || _opts_from === void 0 ? void 0 : _opts_from.contains(node)) return NodeFilter.FILTER_REJECT;
            if (node.matches(selector) && (0, $df81c44924425398$export$e989c0fffaa6b27a)(node) && (!scope || $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$isElementInScope(node, scope)) && (!(opts === null || opts === void 0 ? void 0 : opts.accept) || opts.accept(node))) return NodeFilter.FILTER_ACCEPT;
            return NodeFilter.FILTER_SKIP;
        }
    });
    if (opts === null || opts === void 0 ? void 0 : opts.from) walker.currentNode = opts.from;
    return walker;
}
function $c3df6e3815e9c56f$export$c5251b9e124bf29(ref, defaultOptions = {}) {
    return {
        focusNext (opts = {}) {
            let root = ref.current;
            if (!root) return null;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || (0, $ld26B.getOwnerDocument)(root).activeElement;
            let walker = $c3df6e3815e9c56f$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = root;
                nextNode = walker.nextNode();
            }
            if (nextNode) $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || (0, $ld26B.getOwnerDocument)(root).activeElement;
            let walker = $c3df6e3815e9c56f$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            else {
                let next = $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$last(walker);
                if (next) $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$focusElement(next, true);
                return next !== null && next !== void 0 ? next : null;
            }
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = root;
                let lastNode = $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$last(walker);
                if (!lastNode) return null;
                previousNode = lastNode;
            }
            if (previousNode) $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode !== null && previousNode !== void 0 ? previousNode : null;
        },
        focusFirst (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $c3df6e3815e9c56f$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let nextNode = walker.nextNode();
            if (nextNode) $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $c3df6e3815e9c56f$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let next = $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$last(walker);
            if (next) $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$focusElement(next, true);
            return next !== null && next !== void 0 ? next : null;
        }
    };
}
function $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$last(walker) {
    let next = undefined;
    let last;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}
class $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$Tree {
    get size() {
        return this.fastMap.size;
    }
    getTreeNode(data) {
        return this.fastMap.get(data);
    }
    addTreeNode(scopeRef, parent, nodeToRestore) {
        let parentNode = this.fastMap.get(parent !== null && parent !== void 0 ? parent : null);
        if (!parentNode) return;
        let node = new $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: scopeRef
        });
        parentNode.addChild(node);
        node.parent = parentNode;
        this.fastMap.set(scopeRef, node);
        if (nodeToRestore) node.nodeToRestore = nodeToRestore;
    }
    addNode(node) {
        this.fastMap.set(node.scopeRef, node);
    }
    removeTreeNode(scopeRef) {
        // never remove the root
        if (scopeRef === null) return;
        let node = this.fastMap.get(scopeRef);
        if (!node) return;
        let parentNode = node.parent;
        // when we remove a scope, check if any sibling scopes are trying to restore focus to something inside the scope we're removing
        // if we are, then replace the siblings restore with the restore from the scope we're removing
        for (let current of this.traverse())if (current !== node && node.nodeToRestore && current.nodeToRestore && node.scopeRef && node.scopeRef.current && $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$isElementInScope(current.nodeToRestore, node.scopeRef.current)) current.nodeToRestore = node.nodeToRestore;
        let children = node.children;
        if (parentNode) {
            parentNode.removeChild(node);
            if (children.size > 0) children.forEach((child)=>parentNode && parentNode.addChild(child));
        }
        this.fastMap.delete(node.scopeRef);
    }
    // Pre Order Depth First
    *traverse(node = this.root) {
        if (node.scopeRef != null) yield node;
        if (node.children.size > 0) for (let child of node.children)yield* this.traverse(child);
    }
    clone() {
        var _node_parent;
        let newTree = new $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$Tree();
        var _node_parent_scopeRef;
        for (let node of this.traverse())newTree.addTreeNode(node.scopeRef, (_node_parent_scopeRef = (_node_parent = node.parent) === null || _node_parent === void 0 ? void 0 : _node_parent.scopeRef) !== null && _node_parent_scopeRef !== void 0 ? _node_parent_scopeRef : null, node.nodeToRestore);
        return newTree;
    }
    constructor(){
        this.fastMap = new Map();
        this.root = new $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: null
        });
        this.fastMap.set(null, this.root);
    }
}
class $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$TreeNode {
    addChild(node) {
        this.children.add(node);
        node.parent = this;
    }
    removeChild(node) {
        this.children.delete(node);
        node.parent = undefined;
    }
    constructor(props){
        this.children = new Set();
        this.contain = false;
        this.scopeRef = props.scopeRef;
    }
}
let $c3df6e3815e9c56f$export$d06fae2ee68b101e = new $c3df6e3815e9c56f$var$$9bf71ea28793e738$var$Tree();



var $61nPD = parcelRequire("61nPD");
var $kI2if = parcelRequire("kI2if");
var $eiwoe = parcelRequire("eiwoe");
var $dCyIs = parcelRequire("dCyIs");
var $aCMC4 = parcelRequire("aCMC4");
var $h4wtR = parcelRequire("h4wtR");
var $gsEnF = parcelRequire("gsEnF");

var $ld26B = parcelRequire("ld26B");
var $kI2if = parcelRequire("kI2if");
var $8l8s9 = parcelRequire("8l8s9");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Note that state only matters here for iOS. Non-iOS gets user-select: none applied to the target element
// rather than at the document level so we just need to apply/remove user-select: none for each pressed element individually
let $54751b88dc577a4a$var$$14c0b72509d70225$var$state = "default";
let $54751b88dc577a4a$var$$14c0b72509d70225$var$savedUserSelect = "";
let $54751b88dc577a4a$var$$14c0b72509d70225$var$modifiedElementMap = new WeakMap();
function $54751b88dc577a4a$export$16a4697467175487(target) {
    if ((0, $kI2if.isIOS)()) {
        if ($54751b88dc577a4a$var$$14c0b72509d70225$var$state === "default") {
            // eslint-disable-next-line no-restricted-globals
            const documentObject = (0, $ld26B.getOwnerDocument)(target);
            $54751b88dc577a4a$var$$14c0b72509d70225$var$savedUserSelect = documentObject.documentElement.style.webkitUserSelect;
            documentObject.documentElement.style.webkitUserSelect = "none";
        }
        $54751b88dc577a4a$var$$14c0b72509d70225$var$state = "disabled";
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        // If not iOS, store the target's original user-select and change to user-select: none
        // Ignore state since it doesn't apply for non iOS
        $54751b88dc577a4a$var$$14c0b72509d70225$var$modifiedElementMap.set(target, target.style.userSelect);
        target.style.userSelect = "none";
    }
}
function $54751b88dc577a4a$export$b0d6fa1ab32e3295(target) {
    if ((0, $kI2if.isIOS)()) {
        // If the state is already default, there's nothing to do.
        // If it is restoring, then there's no need to queue a second restore.
        if ($54751b88dc577a4a$var$$14c0b72509d70225$var$state !== "disabled") return;
        $54751b88dc577a4a$var$$14c0b72509d70225$var$state = "restoring";
        // There appears to be a delay on iOS where selection still might occur
        // after pointer up, so wait a bit before removing user-select.
        setTimeout(()=>{
            (0, $8l8s9.runAfterTransition)(()=>{
                // Avoid race conditions
                if ($54751b88dc577a4a$var$$14c0b72509d70225$var$state === "restoring") {
                    // eslint-disable-next-line no-restricted-globals
                    const documentObject = (0, $ld26B.getOwnerDocument)(target);
                    if (documentObject.documentElement.style.webkitUserSelect === "none") documentObject.documentElement.style.webkitUserSelect = $54751b88dc577a4a$var$$14c0b72509d70225$var$savedUserSelect || "";
                    $54751b88dc577a4a$var$$14c0b72509d70225$var$savedUserSelect = "";
                    $54751b88dc577a4a$var$$14c0b72509d70225$var$state = "default";
                }
            });
        }, 300);
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        if (target && $54751b88dc577a4a$var$$14c0b72509d70225$var$modifiedElementMap.has(target)) {
            let targetOldUserSelect = $54751b88dc577a4a$var$$14c0b72509d70225$var$modifiedElementMap.get(target);
            if (target.style.userSelect === "none") target.style.userSelect = targetOldUserSelect;
            if (target.getAttribute("style") === "") target.removeAttribute("style");
            $54751b88dc577a4a$var$$14c0b72509d70225$var$modifiedElementMap.delete(target);
        }
    }
}



var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $4b00cefa452d1ce2$export$5165eccb35aaadb5 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext({
    register: ()=>{}
});
$4b00cefa452d1ce2$export$5165eccb35aaadb5.displayName = "PressResponderContext";



var $2iPDq = parcelRequire("2iPDq");

var $f9kyn = parcelRequire("f9kyn");

var $lgPAm = parcelRequire("lgPAm");

var $i65Wu = parcelRequire("i65Wu");
var $61nPD = parcelRequire("61nPD");
var $ld26B = parcelRequire("ld26B");
var $kI2if = parcelRequire("kI2if");
var $7uYIl = parcelRequire("7uYIl");
var $dCyIs = parcelRequire("dCyIs");
var $aCMC4 = parcelRequire("aCMC4");
var $77fRS = parcelRequire("77fRS");
var $1mw9Z = parcelRequire("1mw9Z");
var $2Cn0z = parcelRequire("2Cn0z");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$usePressResponderContext(props) {
    // Consume context from <PressResponder> and merge with props.
    let context = (0, $bh6RR.useContext)((0, $4b00cefa452d1ce2$export$5165eccb35aaadb5));
    if (context) {
        let { register: register, ...contextProps } = context;
        props = (0, $dCyIs.mergeProps)(contextProps, props);
        register();
    }
    (0, $2Cn0z.useSyncRef)(context, props.ref);
    return props;
}
var $f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$_shouldStopPropagation = /*#__PURE__*/ new WeakMap();
class $f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$PressEvent {
    continuePropagation() {
        (0, $lgPAm._)(this, $f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$_shouldStopPropagation, false);
    }
    get shouldStopPropagation() {
        return (0, $2iPDq._)(this, $f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$_shouldStopPropagation);
    }
    constructor(type, pointerType, originalEvent){
        (0, $f9kyn._)(this, $f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$_shouldStopPropagation, {
            writable: true,
            value: void 0
        });
        (0, $lgPAm._)(this, $f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$_shouldStopPropagation, true);
        this.type = type;
        this.pointerType = pointerType;
        this.target = originalEvent.currentTarget;
        this.shiftKey = originalEvent.shiftKey;
        this.metaKey = originalEvent.metaKey;
        this.ctrlKey = originalEvent.ctrlKey;
        this.altKey = originalEvent.altKey;
    }
}
const $f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$LINK_CLICKED = Symbol("linkClicked");
function $f1c2c36c3bf67162$export$45712eceda6fad21(props) {
    let { onPress: onPress, onPressChange: onPressChange, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressUp: onPressUp, isDisabled: isDisabled, isPressed: isPressedProp, preventFocusOnPress: preventFocusOnPress, shouldCancelOnPointerExit: shouldCancelOnPointerExit, allowTextSelectionOnPress: allowTextSelectionOnPress, ref: _, ...domProps } = $f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$usePressResponderContext(props);
    let [isPressed, setPressed] = (0, $bh6RR.useState)(false);
    let ref = (0, $bh6RR.useRef)({
        isPressed: false,
        ignoreEmulatedMouseEvents: false,
        ignoreClickAfterPress: false,
        didFirePressStart: false,
        isTriggeringEvent: false,
        activePointerId: null,
        target: null,
        isOverTarget: false,
        pointerType: null
    });
    let { addGlobalListener: addGlobalListener, removeAllGlobalListeners: removeAllGlobalListeners } = (0, $1mw9Z.useGlobalListeners)();
    let triggerPressStart = (0, $77fRS.useEffectEvent)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled || state.didFirePressStart) return false;
        let shouldStopPropagation = true;
        state.isTriggeringEvent = true;
        if (onPressStart) {
            let event = new $f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$PressEvent("pressstart", pointerType, originalEvent);
            onPressStart(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(true);
        state.isTriggeringEvent = false;
        state.didFirePressStart = true;
        setPressed(true);
        return shouldStopPropagation;
    });
    let triggerPressEnd = (0, $77fRS.useEffectEvent)((originalEvent, pointerType, wasPressed = true)=>{
        let state = ref.current;
        if (!state.didFirePressStart) return false;
        state.ignoreClickAfterPress = true;
        state.didFirePressStart = false;
        state.isTriggeringEvent = true;
        let shouldStopPropagation = true;
        if (onPressEnd) {
            let event = new $f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$PressEvent("pressend", pointerType, originalEvent);
            onPressEnd(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(false);
        setPressed(false);
        if (onPress && wasPressed && !isDisabled) {
            let event = new $f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$PressEvent("press", pointerType, originalEvent);
            onPress(event);
            shouldStopPropagation && (shouldStopPropagation = event.shouldStopPropagation);
        }
        state.isTriggeringEvent = false;
        return shouldStopPropagation;
    });
    let triggerPressUp = (0, $77fRS.useEffectEvent)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled) return false;
        if (onPressUp) {
            state.isTriggeringEvent = true;
            let event = new $f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$PressEvent("pressup", pointerType, originalEvent);
            onPressUp(event);
            state.isTriggeringEvent = false;
            return event.shouldStopPropagation;
        }
        return true;
    });
    let cancel = (0, $77fRS.useEffectEvent)((e)=>{
        let state = ref.current;
        if (state.isPressed && state.target) {
            if (state.isOverTarget && state.pointerType != null) triggerPressEnd($f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
            state.isPressed = false;
            state.isOverTarget = false;
            state.activePointerId = null;
            state.pointerType = null;
            removeAllGlobalListeners();
            if (!allowTextSelectionOnPress) (0, $54751b88dc577a4a$export$b0d6fa1ab32e3295)(state.target);
        }
    });
    let cancelOnPointerExit = (0, $77fRS.useEffectEvent)((e)=>{
        if (shouldCancelOnPointerExit) cancel(e);
    });
    let pressProps = (0, $bh6RR.useMemo)(()=>{
        let state = ref.current;
        let pressProps = {
            onKeyDown (e) {
                if ($f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e.nativeEvent, e.currentTarget) && e.currentTarget.contains(e.target)) {
                    var _state_metaKeyEvents;
                    if ($f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                    // If the event is repeating, it may have started on a different element
                    // after which focus moved to the current element. Ignore these events and
                    // only handle the first key down event.
                    let shouldStopPropagation = true;
                    if (!state.isPressed && !e.repeat) {
                        state.target = e.currentTarget;
                        state.isPressed = true;
                        shouldStopPropagation = triggerPressStart(e, "keyboard");
                        // Focus may move before the key up event, so register the event on the document
                        // instead of the same element where the key down event occurred. Make it capturing so that it will trigger
                        // before stopPropagation from useKeyboard on a child element may happen and thus we can still call triggerPress for the parent element.
                        let originalTarget = e.currentTarget;
                        let pressUp = (e)=>{
                            if ($f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e, originalTarget) && !e.repeat && originalTarget.contains(e.target) && state.target) triggerPressUp($f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard");
                        };
                        addGlobalListener((0, $ld26B.getOwnerDocument)(e.currentTarget), "keyup", (0, $i65Wu.chain)(pressUp, onKeyUp), true);
                    }
                    if (shouldStopPropagation) e.stopPropagation();
                    // Keep track of the keydown events that occur while the Meta (e.g. Command) key is held.
                    // macOS has a bug where keyup events are not fired while the Meta key is down.
                    // When the Meta key itself is released we will get an event for that, and we'll act as if
                    // all of these other keys were released as well.
                    // https://bugs.chromium.org/p/chromium/issues/detail?id=1393524
                    // https://bugs.webkit.org/show_bug.cgi?id=55291
                    // https://bugzilla.mozilla.org/show_bug.cgi?id=1299553
                    if (e.metaKey && (0, $kI2if.isMac)()) (_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 || _state_metaKeyEvents.set(e.key, e.nativeEvent);
                } else if (e.key === "Meta") state.metaKeyEvents = new Map();
            },
            onClick (e) {
                if (e && !e.currentTarget.contains(e.target)) return;
                if (e && e.button === 0 && !state.isTriggeringEvent && !(0, $aCMC4.openLink).isOpening) {
                    let shouldStopPropagation = true;
                    if (isDisabled) e.preventDefault();
                    // If triggered from a screen reader or by using element.click(),
                    // trigger as if it were a keyboard click.
                    if (!state.ignoreClickAfterPress && !state.ignoreEmulatedMouseEvents && !state.isPressed && (state.pointerType === "virtual" || (0, $7uYIl.isVirtualClick)(e.nativeEvent))) {
                        // Ensure the element receives focus (VoiceOver on iOS does not do this)
                        if (!isDisabled && !preventFocusOnPress) (0, $61nPD.focusWithoutScrolling)(e.currentTarget);
                        let stopPressStart = triggerPressStart(e, "virtual");
                        let stopPressUp = triggerPressUp(e, "virtual");
                        let stopPressEnd = triggerPressEnd(e, "virtual");
                        shouldStopPropagation = stopPressStart && stopPressUp && stopPressEnd;
                    }
                    state.ignoreEmulatedMouseEvents = false;
                    state.ignoreClickAfterPress = false;
                    if (shouldStopPropagation) e.stopPropagation();
                }
            }
        };
        let onKeyUp = (e)=>{
            var _state_metaKeyEvents;
            if (state.isPressed && state.target && $f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e, state.target)) {
                var _state_metaKeyEvents1;
                if ($f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                let target = e.target;
                triggerPressEnd($f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard", state.target.contains(target));
                removeAllGlobalListeners();
                // If a link was triggered with a key other than Enter, open the URL ourselves.
                // This means the link has a role override, and the default browser behavior
                // only applies when using the Enter key.
                if (e.key !== "Enter" && $f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(state.target) && state.target.contains(target) && !e[$f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$LINK_CLICKED]) {
                    // Store a hidden property on the event so we only trigger link click once,
                    // even if there are multiple usePress instances attached to the element.
                    e[$f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$LINK_CLICKED] = true;
                    (0, $aCMC4.openLink)(state.target, e, false);
                }
                state.isPressed = false;
                (_state_metaKeyEvents1 = state.metaKeyEvents) === null || _state_metaKeyEvents1 === void 0 || _state_metaKeyEvents1.delete(e.key);
            } else if (e.key === "Meta" && ((_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 ? void 0 : _state_metaKeyEvents.size)) {
                var _state_target;
                // If we recorded keydown events that occurred while the Meta key was pressed,
                // and those haven't received keyup events already, fire keyup events ourselves.
                // See comment above for more info about the macOS bug causing this.
                let events = state.metaKeyEvents;
                state.metaKeyEvents = undefined;
                for (let event of events.values())(_state_target = state.target) === null || _state_target === void 0 || _state_target.dispatchEvent(new KeyboardEvent("keyup", event));
            }
        };
        if (typeof PointerEvent !== "undefined") {
            pressProps.onPointerDown = (e)=>{
                // Only handle left clicks, and ignore events that bubbled through portals.
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // iOS safari fires pointer events from VoiceOver with incorrect coordinates/target.
                // Ignore and let the onClick handler take care of it instead.
                // https://bugs.webkit.org/show_bug.cgi?id=222627
                // https://bugs.webkit.org/show_bug.cgi?id=223202
                if ((0, $7uYIl.isVirtualPointerEvent)(e.nativeEvent)) {
                    state.pointerType = "virtual";
                    return;
                }
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on pointer down and handle focusing the pressable element ourselves.
                if ($f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                state.pointerType = e.pointerType;
                let shouldStopPropagation = true;
                if (!state.isPressed) {
                    state.isPressed = true;
                    state.isOverTarget = true;
                    state.activePointerId = e.pointerId;
                    state.target = e.currentTarget;
                    if (!isDisabled && !preventFocusOnPress) (0, $61nPD.focusWithoutScrolling)(e.currentTarget);
                    if (!allowTextSelectionOnPress) (0, $54751b88dc577a4a$export$16a4697467175487)(state.target);
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    addGlobalListener((0, $ld26B.getOwnerDocument)(e.currentTarget), "pointermove", onPointerMove, false);
                    addGlobalListener((0, $ld26B.getOwnerDocument)(e.currentTarget), "pointerup", onPointerUp, false);
                    addGlobalListener((0, $ld26B.getOwnerDocument)(e.currentTarget), "pointercancel", onPointerCancel, false);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseDown = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (e.button === 0) {
                    // Chrome and Firefox on touch Windows devices require mouse down events
                    // to be canceled in addition to pointer events, or an extra asynchronous
                    // focus event will be fired.
                    if ($f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                    e.stopPropagation();
                }
            };
            pressProps.onPointerUp = (e)=>{
                // iOS fires pointerup with zero width and height, so check the pointerType recorded during pointerdown.
                if (!e.currentTarget.contains(e.target) || state.pointerType === "virtual") return;
                // Only handle left clicks
                // Safari on iOS sometimes fires pointerup events, even
                // when the touch isn't over the target, so double check.
                if (e.button === 0 && $f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$isOverTarget(e, e.currentTarget)) triggerPressUp(e, state.pointerType || e.pointerType);
            };
            // Safari on iOS < 13.2 does not implement pointerenter/pointerleave events correctly.
            // Use pointer move events instead to implement our own hit testing.
            // See https://bugs.webkit.org/show_bug.cgi?id=199803
            let onPointerMove = (e)=>{
                if (e.pointerId !== state.activePointerId) return;
                if (state.target && $f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        triggerPressStart($f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    }
                } else if (state.target && state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    triggerPressEnd($f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    cancelOnPointerExit(e);
                }
            };
            let onPointerUp = (e)=>{
                if (e.pointerId === state.activePointerId && state.isPressed && e.button === 0 && state.target) {
                    if ($f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd($f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    else if (state.isOverTarget && state.pointerType != null) triggerPressEnd($f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    state.isPressed = false;
                    state.isOverTarget = false;
                    state.activePointerId = null;
                    state.pointerType = null;
                    removeAllGlobalListeners();
                    if (!allowTextSelectionOnPress) (0, $54751b88dc577a4a$export$b0d6fa1ab32e3295)(state.target);
                }
            };
            let onPointerCancel = (e)=>{
                cancel(e);
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                // Safari does not call onPointerCancel when a drag starts, whereas Chrome and Firefox do.
                cancel(e);
            };
        } else {
            pressProps.onMouseDown = (e)=>{
                // Only handle left clicks
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on mouse down and handle focusing the pressable element ourselves.
                if ($f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                if (state.ignoreEmulatedMouseEvents) {
                    e.stopPropagation();
                    return;
                }
                state.isPressed = true;
                state.isOverTarget = true;
                state.target = e.currentTarget;
                state.pointerType = (0, $7uYIl.isVirtualClick)(e.nativeEvent) ? "virtual" : "mouse";
                if (!isDisabled && !preventFocusOnPress) (0, $61nPD.focusWithoutScrolling)(e.currentTarget);
                let shouldStopPropagation = triggerPressStart(e, state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, $ld26B.getOwnerDocument)(e.currentTarget), "mouseup", onMouseUp, false);
            };
            pressProps.onMouseEnter = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = true;
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseLeave = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                    cancelOnPointerExit(e);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseUp = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.ignoreEmulatedMouseEvents && e.button === 0) triggerPressUp(e, state.pointerType || "mouse");
            };
            let onMouseUp = (e)=>{
                // Only handle left clicks
                if (e.button !== 0) return;
                state.isPressed = false;
                removeAllGlobalListeners();
                if (state.ignoreEmulatedMouseEvents) {
                    state.ignoreEmulatedMouseEvents = false;
                    return;
                }
                if (state.target && $f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd($f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                else if (state.target && state.isOverTarget && state.pointerType != null) triggerPressEnd($f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                state.isOverTarget = false;
            };
            pressProps.onTouchStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let touch = $f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$getTouchFromEvent(e.nativeEvent);
                if (!touch) return;
                state.activePointerId = touch.identifier;
                state.ignoreEmulatedMouseEvents = true;
                state.isOverTarget = true;
                state.isPressed = true;
                state.target = e.currentTarget;
                state.pointerType = "touch";
                // Due to browser inconsistencies, especially on mobile browsers, we prevent default
                // on the emulated mouse event and handle focusing the pressable element ourselves.
                if (!isDisabled && !preventFocusOnPress) (0, $61nPD.focusWithoutScrolling)(e.currentTarget);
                if (!allowTextSelectionOnPress) (0, $54751b88dc577a4a$export$16a4697467175487)(state.target);
                let shouldStopPropagation = triggerPressStart(e, state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, $ld26B.getOwnerWindow)(e.currentTarget), "scroll", onScroll, true);
            };
            pressProps.onTouchMove = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                let touch = $f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                let shouldStopPropagation = true;
                if (touch && $f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    }
                } else if (state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                    cancelOnPointerExit(e);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onTouchEnd = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                let touch = $f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                let shouldStopPropagation = true;
                if (touch && $f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget) && state.pointerType != null) {
                    triggerPressUp(e, state.pointerType);
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType);
                } else if (state.isOverTarget && state.pointerType != null) shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                if (shouldStopPropagation) e.stopPropagation();
                state.isPressed = false;
                state.activePointerId = null;
                state.isOverTarget = false;
                state.ignoreEmulatedMouseEvents = true;
                if (state.target && !allowTextSelectionOnPress) (0, $54751b88dc577a4a$export$b0d6fa1ab32e3295)(state.target);
                removeAllGlobalListeners();
            };
            pressProps.onTouchCancel = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (state.isPressed) cancel(e);
            };
            let onScroll = (e)=>{
                if (state.isPressed && e.target.contains(state.target)) cancel({
                    currentTarget: state.target,
                    shiftKey: false,
                    ctrlKey: false,
                    metaKey: false,
                    altKey: false
                });
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                cancel(e);
            };
        }
        return pressProps;
    }, [
        addGlobalListener,
        isDisabled,
        preventFocusOnPress,
        removeAllGlobalListeners,
        allowTextSelectionOnPress,
        cancel,
        cancelOnPointerExit,
        triggerPressEnd,
        triggerPressStart,
        triggerPressUp
    ]);
    (0, $bh6RR.useEffect)(()=>{
        return ()=>{
            var _ref_current_target;
            if (!allowTextSelectionOnPress) (0, $54751b88dc577a4a$export$b0d6fa1ab32e3295)((_ref_current_target = ref.current.target) !== null && _ref_current_target !== void 0 ? _ref_current_target : undefined);
        };
    }, [
        allowTextSelectionOnPress
    ]);
    return {
        isPressed: isPressedProp || isPressed,
        pressProps: (0, $dCyIs.mergeProps)(domProps, pressProps)
    };
}
function $f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target) {
    return target.tagName === "A" && target.hasAttribute("href");
}
function $f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(event, currentTarget) {
    const { key: key, code: code } = event;
    const element = currentTarget;
    const role = element.getAttribute("role");
    // Accessibility for keyboards. Space and Enter only.
    // "Spacebar" is for IE 11
    return (key === "Enter" || key === " " || key === "Spacebar" || code === "Space") && !(element instanceof (0, $ld26B.getOwnerWindow)(element).HTMLInputElement && !$f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$isValidInputKey(element, key) || element instanceof (0, $ld26B.getOwnerWindow)(element).HTMLTextAreaElement || element.isContentEditable) && // Links should only trigger with Enter key
    !((role === "link" || !role && $f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(element)) && key !== "Enter");
}
function $f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$getTouchFromEvent(event) {
    const { targetTouches: targetTouches } = event;
    if (targetTouches.length > 0) return targetTouches[0];
    return null;
}
function $f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$getTouchById(event, pointerId) {
    const changedTouches = event.changedTouches;
    for(let i = 0; i < changedTouches.length; i++){
        const touch = changedTouches[i];
        if (touch.identifier === pointerId) return touch;
    }
    return null;
}
function $f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$createEvent(target, e) {
    return {
        currentTarget: target,
        shiftKey: e.shiftKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        altKey: e.altKey
    };
}
function $f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$getPointClientRect(point) {
    let offsetX = 0;
    let offsetY = 0;
    if (point.width !== undefined) offsetX = point.width / 2;
    else if (point.radiusX !== undefined) offsetX = point.radiusX;
    if (point.height !== undefined) offsetY = point.height / 2;
    else if (point.radiusY !== undefined) offsetY = point.radiusY;
    return {
        top: point.clientY - offsetY,
        right: point.clientX + offsetX,
        bottom: point.clientY + offsetY,
        left: point.clientX - offsetX
    };
}
function $f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(a, b) {
    // check if they cannot overlap on x axis
    if (a.left > b.right || b.left > a.right) return false;
    // check if they cannot overlap on y axis
    if (a.top > b.bottom || b.top > a.bottom) return false;
    return true;
}
function $f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$isOverTarget(point, target) {
    let rect = target.getBoundingClientRect();
    let pointRect = $f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$getPointClientRect(point);
    return $f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(rect, pointRect);
}
function $f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$shouldPreventDefault(target) {
    // We cannot prevent default if the target is a draggable element.
    return !(target instanceof HTMLElement) || !target.hasAttribute("draggable");
}
function $f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(target, key) {
    if (target instanceof HTMLInputElement) return !$f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$isValidInputKey(target, key);
    if (target instanceof HTMLButtonElement) return target.type !== "submit" && target.type !== "reset";
    if ($f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target)) return false;
    return true;
}
const $f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
function $f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$isValidInputKey(target, key) {
    // Only space should toggle checkboxes and radios, not enter.
    return target.type === "checkbox" || target.type === "radio" ? key === " " : $f1c2c36c3bf67162$var$$f6c31cce2adf654f$var$nonTextInputTypes.has(target.type);
}



var $dCyIs = parcelRequire("dCyIs");
var $9IUYG = parcelRequire("9IUYG");
var $1mw9Z = parcelRequire("1mw9Z");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $b474ca2e51320d7f$var$$8a26561d2877236e$var$DEFAULT_THRESHOLD = 500;
function $b474ca2e51320d7f$export$c24ed0104d07eab9(props) {
    let { isDisabled: isDisabled, onLongPressStart: onLongPressStart, onLongPressEnd: onLongPressEnd, onLongPress: onLongPress, threshold: threshold = $b474ca2e51320d7f$var$$8a26561d2877236e$var$DEFAULT_THRESHOLD, accessibilityDescription: accessibilityDescription } = props;
    const timeRef = (0, $bh6RR.useRef)();
    let { addGlobalListener: addGlobalListener, removeGlobalListener: removeGlobalListener } = (0, $1mw9Z.useGlobalListeners)();
    let { pressProps: pressProps } = (0, $f1c2c36c3bf67162$export$45712eceda6fad21)({
        isDisabled: isDisabled,
        onPressStart (e) {
            e.continuePropagation();
            if (e.pointerType === "mouse" || e.pointerType === "touch") {
                if (onLongPressStart) onLongPressStart({
                    ...e,
                    type: "longpressstart"
                });
                timeRef.current = setTimeout(()=>{
                    // Prevent other usePress handlers from also handling this event.
                    e.target.dispatchEvent(new PointerEvent("pointercancel", {
                        bubbles: true
                    }));
                    if (onLongPress) onLongPress({
                        ...e,
                        type: "longpress"
                    });
                    timeRef.current = undefined;
                }, threshold);
                // Prevent context menu, which may be opened on long press on touch devices
                if (e.pointerType === "touch") {
                    let onContextMenu = (e)=>{
                        e.preventDefault();
                    };
                    addGlobalListener(e.target, "contextmenu", onContextMenu, {
                        once: true
                    });
                    addGlobalListener(window, "pointerup", ()=>{
                        // If no contextmenu event is fired quickly after pointerup, remove the handler
                        // so future context menu events outside a long press are not prevented.
                        setTimeout(()=>{
                            removeGlobalListener(e.target, "contextmenu", onContextMenu);
                        }, 30);
                    }, {
                        once: true
                    });
                }
            }
        },
        onPressEnd (e) {
            if (timeRef.current) clearTimeout(timeRef.current);
            if (onLongPressEnd && (e.pointerType === "mouse" || e.pointerType === "touch")) onLongPressEnd({
                ...e,
                type: "longpressend"
            });
        }
    });
    let descriptionProps = (0, $9IUYG.useDescription)(onLongPress && !isDisabled ? accessibilityDescription : undefined);
    return {
        longPressProps: (0, $dCyIs.mergeProps)(pressProps, descriptionProps)
    };
}



var $i6bwP = parcelRequire("i6bwP");
var $dG3Oc = parcelRequire("dG3Oc");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $72b2d936d76f9ffe$var$$feb5ffebff200149$export$d3e3bd3e26688c04(e) {
    // Ctrl + Arrow Up/Arrow Down has a system wide meaning on macOS, so use Alt instead.
    // On Windows and Ubuntu, Alt + Space has a system wide meaning.
    return (0, $kI2if.isAppleDevice)() ? e.altKey : e.ctrlKey;
}
function $72b2d936d76f9ffe$var$$feb5ffebff200149$export$16792effe837dba3(e) {
    if ((0, $kI2if.isMac)()) return e.metaKey;
    return e.ctrlKey;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Controls how long to wait before clearing the typeahead buffer.
 */ const $72b2d936d76f9ffe$var$$fb3050f43d946246$var$TYPEAHEAD_DEBOUNCE_WAIT_MS = 1000; // 1 second
function $72b2d936d76f9ffe$export$e32c88dfddc6e1d8(options) {
    let { keyboardDelegate: keyboardDelegate, selectionManager: selectionManager, onTypeSelect: onTypeSelect } = options;
    let state = (0, $bh6RR.useRef)({
        search: "",
        timeout: null
    }).current;
    let onKeyDown = (e)=>{
        let character = $72b2d936d76f9ffe$var$$fb3050f43d946246$var$getStringForKey(e.key);
        if (!character || e.ctrlKey || e.metaKey || !e.currentTarget.contains(e.target)) return;
        // Do not propagate the Spacebar event if it's meant to be part of the search.
        // When we time out, the search term becomes empty, hence the check on length.
        // Trimming is to account for the case of pressing the Spacebar more than once,
        // which should cycle through the selection/deselection of the focused item.
        if (character === " " && state.search.trim().length > 0) {
            e.preventDefault();
            if (!("continuePropagation" in e)) e.stopPropagation();
        }
        state.search += character;
        // Use the delegate to find a key to focus.
        // Prioritize items after the currently focused item, falling back to searching the whole list.
        let key = keyboardDelegate.getKeyForSearch(state.search, selectionManager.focusedKey);
        // If no key found, search from the top.
        if (key == null) key = keyboardDelegate.getKeyForSearch(state.search);
        if (key != null) {
            selectionManager.setFocusedKey(key);
            if (onTypeSelect) onTypeSelect(key);
        }
        clearTimeout(state.timeout);
        state.timeout = setTimeout(()=>{
            state.search = "";
        }, $72b2d936d76f9ffe$var$$fb3050f43d946246$var$TYPEAHEAD_DEBOUNCE_WAIT_MS);
    };
    return {
        typeSelectProps: {
            // Using a capturing listener to catch the keydown event before
            // other hooks in order to handle the Spacebar event.
            onKeyDownCapture: keyboardDelegate.getKeyForSearch ? onKeyDown : null
        }
    };
}
function $72b2d936d76f9ffe$var$$fb3050f43d946246$var$getStringForKey(key) {
    // If the key is of length 1, it is an ASCII value.
    // Otherwise, if there are no ASCII characters in the key name,
    // it is a Unicode character.
    // See https://www.w3.org/TR/uievents-key/
    if (key.length === 1 || !/^[A-Z]/i.test(key)) return key;
    return "";
}
function $72b2d936d76f9ffe$export$d6daf82dcd84e87c(options) {
    let { selectionManager: manager, keyboardDelegate: delegate, ref: ref, autoFocus: autoFocus = false, shouldFocusWrap: shouldFocusWrap = false, disallowEmptySelection: disallowEmptySelection = false, disallowSelectAll: disallowSelectAll = false, selectOnFocus: selectOnFocus = manager.selectionBehavior === "replace", disallowTypeAhead: disallowTypeAhead = false, shouldUseVirtualFocus: shouldUseVirtualFocus, allowsTabNavigation: allowsTabNavigation = false, isVirtualized: isVirtualized, scrollRef: scrollRef = ref, linkBehavior: linkBehavior = "action" } = options;
    let { direction: direction } = (0, $dG3Oc.useLocale)();
    let router = (0, $aCMC4.useRouter)();
    let onKeyDown = (e)=>{
        // Prevent option + tab from doing anything since it doesn't move focus to the cells, only buttons/checkboxes
        if (e.altKey && e.key === "Tab") e.preventDefault();
        // Keyboard events bubble through portals. Don't handle keyboard events
        // for elements outside the collection (e.g. menus).
        if (!ref.current.contains(e.target)) return;
        const navigateToKey = (key, childFocus)=>{
            if (key != null) {
                if (manager.isLink(key) && linkBehavior === "selection" && selectOnFocus && !$72b2d936d76f9ffe$var$$feb5ffebff200149$export$d3e3bd3e26688c04(e)) {
                    (0, $6afFj.flushSync)(()=>{
                        manager.setFocusedKey(key, childFocus);
                    });
                    let item = scrollRef.current.querySelector(`[data-key="${CSS.escape(key.toString())}"]`);
                    router.open(item, e);
                    return;
                }
                manager.setFocusedKey(key, childFocus);
                if (manager.isLink(key) && linkBehavior === "override") return;
                if (e.shiftKey && manager.selectionMode === "multiple") manager.extendSelection(key);
                else if (selectOnFocus && !$72b2d936d76f9ffe$var$$feb5ffebff200149$export$d3e3bd3e26688c04(e)) manager.replaceSelection(key);
            }
        };
        switch(e.key){
            case "ArrowDown":
                if (delegate.getKeyBelow) {
                    var _delegate_getFirstKey, _delegate_getFirstKey1;
                    e.preventDefault();
                    let nextKey = manager.focusedKey != null ? delegate.getKeyBelow(manager.focusedKey) : (_delegate_getFirstKey = delegate.getFirstKey) === null || _delegate_getFirstKey === void 0 ? void 0 : _delegate_getFirstKey.call(delegate);
                    if (nextKey == null && shouldFocusWrap) nextKey = (_delegate_getFirstKey1 = delegate.getFirstKey) === null || _delegate_getFirstKey1 === void 0 ? void 0 : _delegate_getFirstKey1.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "ArrowUp":
                if (delegate.getKeyAbove) {
                    var _delegate_getLastKey, _delegate_getLastKey1;
                    e.preventDefault();
                    let nextKey = manager.focusedKey != null ? delegate.getKeyAbove(manager.focusedKey) : (_delegate_getLastKey = delegate.getLastKey) === null || _delegate_getLastKey === void 0 ? void 0 : _delegate_getLastKey.call(delegate);
                    if (nextKey == null && shouldFocusWrap) nextKey = (_delegate_getLastKey1 = delegate.getLastKey) === null || _delegate_getLastKey1 === void 0 ? void 0 : _delegate_getLastKey1.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "ArrowLeft":
                if (delegate.getKeyLeftOf) {
                    var _delegate_getFirstKey2, _delegate_getLastKey2;
                    e.preventDefault();
                    let nextKey = delegate.getKeyLeftOf(manager.focusedKey);
                    if (nextKey == null && shouldFocusWrap) nextKey = direction === "rtl" ? (_delegate_getFirstKey2 = delegate.getFirstKey) === null || _delegate_getFirstKey2 === void 0 ? void 0 : _delegate_getFirstKey2.call(delegate, manager.focusedKey) : (_delegate_getLastKey2 = delegate.getLastKey) === null || _delegate_getLastKey2 === void 0 ? void 0 : _delegate_getLastKey2.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey, direction === "rtl" ? "first" : "last");
                }
                break;
            case "ArrowRight":
                if (delegate.getKeyRightOf) {
                    var _delegate_getLastKey3, _delegate_getFirstKey3;
                    e.preventDefault();
                    let nextKey = delegate.getKeyRightOf(manager.focusedKey);
                    if (nextKey == null && shouldFocusWrap) nextKey = direction === "rtl" ? (_delegate_getLastKey3 = delegate.getLastKey) === null || _delegate_getLastKey3 === void 0 ? void 0 : _delegate_getLastKey3.call(delegate, manager.focusedKey) : (_delegate_getFirstKey3 = delegate.getFirstKey) === null || _delegate_getFirstKey3 === void 0 ? void 0 : _delegate_getFirstKey3.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey, direction === "rtl" ? "last" : "first");
                }
                break;
            case "Home":
                if (delegate.getFirstKey) {
                    e.preventDefault();
                    let firstKey = delegate.getFirstKey(manager.focusedKey, $72b2d936d76f9ffe$var$$feb5ffebff200149$export$16792effe837dba3(e));
                    manager.setFocusedKey(firstKey);
                    if ($72b2d936d76f9ffe$var$$feb5ffebff200149$export$16792effe837dba3(e) && e.shiftKey && manager.selectionMode === "multiple") manager.extendSelection(firstKey);
                    else if (selectOnFocus) manager.replaceSelection(firstKey);
                }
                break;
            case "End":
                if (delegate.getLastKey) {
                    e.preventDefault();
                    let lastKey = delegate.getLastKey(manager.focusedKey, $72b2d936d76f9ffe$var$$feb5ffebff200149$export$16792effe837dba3(e));
                    manager.setFocusedKey(lastKey);
                    if ($72b2d936d76f9ffe$var$$feb5ffebff200149$export$16792effe837dba3(e) && e.shiftKey && manager.selectionMode === "multiple") manager.extendSelection(lastKey);
                    else if (selectOnFocus) manager.replaceSelection(lastKey);
                }
                break;
            case "PageDown":
                if (delegate.getKeyPageBelow) {
                    e.preventDefault();
                    let nextKey = delegate.getKeyPageBelow(manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "PageUp":
                if (delegate.getKeyPageAbove) {
                    e.preventDefault();
                    let nextKey = delegate.getKeyPageAbove(manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "a":
                if ($72b2d936d76f9ffe$var$$feb5ffebff200149$export$16792effe837dba3(e) && manager.selectionMode === "multiple" && disallowSelectAll !== true) {
                    e.preventDefault();
                    manager.selectAll();
                }
                break;
            case "Escape":
                e.preventDefault();
                if (!disallowEmptySelection) manager.clearSelection();
                break;
            case "Tab":
                if (!allowsTabNavigation) {
                    // There may be elements that are "tabbable" inside a collection (e.g. in a grid cell).
                    // However, collections should be treated as a single tab stop, with arrow key navigation internally.
                    // We don't control the rendering of these, so we can't override the tabIndex to prevent tabbing.
                    // Instead, we handle the Tab key, and move focus manually to the first/last tabbable element
                    // in the collection, so that the browser default behavior will apply starting from that element
                    // rather than the currently focused one.
                    if (e.shiftKey) ref.current.focus();
                    else {
                        let walker = (0, $c3df6e3815e9c56f$export$2d6ec8fc375ceafa)(ref.current, {
                            tabbable: true
                        });
                        let next;
                        let last;
                        do {
                            last = walker.lastChild();
                            if (last) next = last;
                        }while (last);
                        if (next && !next.contains(document.activeElement)) (0, $61nPD.focusWithoutScrolling)(next);
                    }
                    break;
                }
        }
    };
    // Store the scroll position so we can restore it later.
    let scrollPos = (0, $bh6RR.useRef)({
        top: 0,
        left: 0
    });
    (0, $gsEnF.useEvent)(scrollRef, "scroll", isVirtualized ? null : ()=>{
        scrollPos.current = {
            top: scrollRef.current.scrollTop,
            left: scrollRef.current.scrollLeft
        };
    });
    let onFocus = (e)=>{
        if (manager.isFocused) {
            // If a focus event bubbled through a portal, reset focus state.
            if (!e.currentTarget.contains(e.target)) manager.setFocused(false);
            return;
        }
        // Focus events can bubble through portals. Ignore these events.
        if (!e.currentTarget.contains(e.target)) return;
        manager.setFocused(true);
        if (manager.focusedKey == null) {
            let navigateToFirstKey = (key)=>{
                if (key != null) {
                    manager.setFocusedKey(key);
                    if (selectOnFocus) manager.replaceSelection(key);
                }
            };
            // If the user hasn't yet interacted with the collection, there will be no focusedKey set.
            // Attempt to detect whether the user is tabbing forward or backward into the collection
            // and either focus the first or last item accordingly.
            let relatedTarget = e.relatedTarget;
            var _manager_lastSelectedKey, _manager_firstSelectedKey;
            if (relatedTarget && e.currentTarget.compareDocumentPosition(relatedTarget) & Node.DOCUMENT_POSITION_FOLLOWING) navigateToFirstKey((_manager_lastSelectedKey = manager.lastSelectedKey) !== null && _manager_lastSelectedKey !== void 0 ? _manager_lastSelectedKey : delegate.getLastKey());
            else navigateToFirstKey((_manager_firstSelectedKey = manager.firstSelectedKey) !== null && _manager_firstSelectedKey !== void 0 ? _manager_firstSelectedKey : delegate.getFirstKey());
        } else if (!isVirtualized) {
            // Restore the scroll position to what it was before.
            scrollRef.current.scrollTop = scrollPos.current.top;
            scrollRef.current.scrollLeft = scrollPos.current.left;
        }
        if (!isVirtualized && manager.focusedKey != null) {
            // Refocus and scroll the focused item into view if it exists within the scrollable region.
            let element = scrollRef.current.querySelector(`[data-key="${CSS.escape(manager.focusedKey.toString())}"]`);
            if (element) {
                // This prevents a flash of focus on the first/last element in the collection, or the collection itself.
                if (!element.contains(document.activeElement)) (0, $61nPD.focusWithoutScrolling)(element);
                let modality = (0, $5f09b245b1b78407$export$630ff653c5ada6a9)();
                if (modality === "keyboard") (0, $h4wtR.scrollIntoViewport)(element, {
                    containingElement: ref.current
                });
            }
        }
    };
    let onBlur = (e)=>{
        // Don't set blurred and then focused again if moving focus within the collection.
        if (!e.currentTarget.contains(e.relatedTarget)) manager.setFocused(false);
    };
    const autoFocusRef = (0, $bh6RR.useRef)(autoFocus);
    (0, $bh6RR.useEffect)(()=>{
        if (autoFocusRef.current) {
            let focusedKey = null;
            // Check focus strategy to determine which item to focus
            if (autoFocus === "first") focusedKey = delegate.getFirstKey();
            if (autoFocus === "last") focusedKey = delegate.getLastKey();
            // If there are any selected keys, make the first one the new focus target
            let selectedKeys = manager.selectedKeys;
            if (selectedKeys.size) {
                for (let key of selectedKeys)if (manager.canSelectItem(key)) {
                    focusedKey = key;
                    break;
                }
            }
            manager.setFocused(true);
            manager.setFocusedKey(focusedKey);
            // If no default focus key is selected, focus the collection itself.
            if (focusedKey == null && !shouldUseVirtualFocus) (0, $8c68352ee20b4e72$export$80f3e147d781571c)(ref.current);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // If not virtualized, scroll the focused element into view when the focusedKey changes.
    // When virtualized, Virtualizer handles this internally.
    let lastFocusedKey = (0, $bh6RR.useRef)(manager.focusedKey);
    (0, $bh6RR.useEffect)(()=>{
        let modality = (0, $5f09b245b1b78407$export$630ff653c5ada6a9)();
        if (manager.isFocused && manager.focusedKey != null && (scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current)) {
            let element = scrollRef.current.querySelector(`[data-key="${CSS.escape(manager.focusedKey.toString())}"]`);
            if (element && (modality === "keyboard" || autoFocusRef.current)) {
                if (!isVirtualized) (0, $h4wtR.scrollIntoView)(scrollRef.current, element);
                // Avoid scroll in iOS VO, since it may cause overlay to close (i.e. RAC submenu)
                if (modality !== "virtual") (0, $h4wtR.scrollIntoViewport)(element, {
                    containingElement: ref.current
                });
            }
        }
        // If the focused key becomes null (e.g. the last item is deleted), focus the whole collection.
        if (manager.isFocused && manager.focusedKey == null && lastFocusedKey.current != null) (0, $8c68352ee20b4e72$export$80f3e147d781571c)(ref.current);
        lastFocusedKey.current = manager.focusedKey;
        autoFocusRef.current = false;
    }, [
        isVirtualized,
        scrollRef,
        manager.focusedKey,
        manager.isFocused,
        ref
    ]);
    let handlers = {
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur,
        onMouseDown (e) {
            // Ignore events that bubbled through portals.
            if (scrollRef.current === e.target) e.preventDefault();
        }
    };
    let { typeSelectProps: typeSelectProps } = $72b2d936d76f9ffe$export$e32c88dfddc6e1d8({
        keyboardDelegate: delegate,
        selectionManager: manager
    });
    if (!disallowTypeAhead) handlers = (0, $dCyIs.mergeProps)(typeSelectProps, handlers);
    // If nothing is focused within the collection, make the collection itself tabbable.
    // This will be marshalled to either the first or last item depending on where focus came from.
    // If using virtual focus, don't set a tabIndex at all so that VoiceOver on iOS 14 doesn't try
    // to move real DOM focus to the element anyway.
    let tabIndex;
    if (!shouldUseVirtualFocus) tabIndex = manager.focusedKey == null ? 0 : -1;
    return {
        collectionProps: {
            ...handlers,
            tabIndex: tabIndex
        }
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $72b2d936d76f9ffe$export$ecf600387e221c37(options) {
    let { selectionManager: manager, key: key, ref: ref, shouldSelectOnPressUp: shouldSelectOnPressUp, shouldUseVirtualFocus: shouldUseVirtualFocus, focus: focus, isDisabled: isDisabled, onAction: onAction, allowsDifferentPressOrigin: allowsDifferentPressOrigin, linkBehavior: linkBehavior = "action" } = options;
    let router = (0, $aCMC4.useRouter)();
    let onSelect = (e)=>{
        if (e.pointerType === "keyboard" && $72b2d936d76f9ffe$var$$feb5ffebff200149$export$d3e3bd3e26688c04(e)) manager.toggleSelection(key);
        else {
            if (manager.selectionMode === "none") return;
            if (manager.isLink(key)) {
                if (linkBehavior === "selection") {
                    router.open(ref.current, e);
                    // Always set selected keys back to what they were so that select and combobox close.
                    manager.setSelectedKeys(manager.selectedKeys);
                    return;
                } else if (linkBehavior === "override" || linkBehavior === "none") return;
            }
            if (manager.selectionMode === "single") {
                if (manager.isSelected(key) && !manager.disallowEmptySelection) manager.toggleSelection(key);
                else manager.replaceSelection(key);
            } else if (e && e.shiftKey) manager.extendSelection(key);
            else if (manager.selectionBehavior === "toggle" || e && ($72b2d936d76f9ffe$var$$feb5ffebff200149$export$16792effe837dba3(e) || e.pointerType === "touch" || e.pointerType === "virtual")) manager.toggleSelection(key);
            else manager.replaceSelection(key);
        }
    };
    (0, $bh6RR.useEffect)(()=>{
        let isFocused = key === manager.focusedKey;
        if (isFocused && manager.isFocused && !shouldUseVirtualFocus) {
            if (focus) focus();
            else if (document.activeElement !== ref.current) (0, $8c68352ee20b4e72$export$80f3e147d781571c)(ref.current);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ref,
        key,
        manager.focusedKey,
        manager.childFocusStrategy,
        manager.isFocused,
        shouldUseVirtualFocus
    ]);
    isDisabled = isDisabled || manager.isDisabled(key);
    // Set tabIndex to 0 if the element is focused, or -1 otherwise so that only the last focused
    // item is tabbable.  If using virtual focus, don't set a tabIndex at all so that VoiceOver
    // on iOS 14 doesn't try to move real DOM focus to the item anyway.
    let itemProps = {};
    if (!shouldUseVirtualFocus && !isDisabled) itemProps = {
        tabIndex: key === manager.focusedKey ? 0 : -1,
        onFocus (e) {
            if (e.target === ref.current) manager.setFocusedKey(key);
        }
    };
    else if (isDisabled) itemProps.onMouseDown = (e)=>{
        // Prevent focus going to the body when clicking on a disabled item.
        e.preventDefault();
    };
    // With checkbox selection, onAction (i.e. navigation) becomes primary, and occurs on a single click of the row.
    // Clicking the checkbox enters selection mode, after which clicking anywhere on any row toggles selection for that row.
    // With highlight selection, onAction is secondary, and occurs on double click. Single click selects the row.
    // With touch, onAction occurs on single tap, and long press enters selection mode.
    let isLinkOverride = manager.isLink(key) && linkBehavior === "override";
    let hasLinkAction = manager.isLink(key) && linkBehavior !== "selection" && linkBehavior !== "none";
    let allowsSelection = !isDisabled && manager.canSelectItem(key) && !isLinkOverride;
    let allowsActions = (onAction || hasLinkAction) && !isDisabled;
    let hasPrimaryAction = allowsActions && (manager.selectionBehavior === "replace" ? !allowsSelection : !allowsSelection || manager.isEmpty);
    let hasSecondaryAction = allowsActions && allowsSelection && manager.selectionBehavior === "replace";
    let hasAction = hasPrimaryAction || hasSecondaryAction;
    let modality = (0, $bh6RR.useRef)(null);
    let longPressEnabled = hasAction && allowsSelection;
    let longPressEnabledOnPressStart = (0, $bh6RR.useRef)(false);
    let hadPrimaryActionOnPressStart = (0, $bh6RR.useRef)(false);
    let performAction = (e)=>{
        if (onAction) onAction();
        if (hasLinkAction) router.open(ref.current, e);
    };
    // By default, selection occurs on pointer down. This can be strange if selecting an
    // item causes the UI to disappear immediately (e.g. menus).
    // If shouldSelectOnPressUp is true, we use onPressUp instead of onPressStart.
    // onPress requires a pointer down event on the same element as pointer up. For menus,
    // we want to be able to have the pointer down on the trigger that opens the menu and
    // the pointer up on the menu item rather than requiring a separate press.
    // For keyboard events, selection still occurs on key down.
    let itemPressProps = {};
    if (shouldSelectOnPressUp) {
        itemPressProps.onPressStart = (e)=>{
            modality.current = e.pointerType;
            longPressEnabledOnPressStart.current = longPressEnabled;
            if (e.pointerType === "keyboard" && (!hasAction || $72b2d936d76f9ffe$var$$880e95eb8b93ba9a$var$isSelectionKey())) onSelect(e);
        };
        // If allowsDifferentPressOrigin, make selection happen on pressUp (e.g. open menu on press down, selection on menu item happens on press up.)
        // Otherwise, have selection happen onPress (prevents listview row selection when clicking on interactable elements in the row)
        if (!allowsDifferentPressOrigin) itemPressProps.onPress = (e)=>{
            if (hasPrimaryAction || hasSecondaryAction && e.pointerType !== "mouse") {
                if (e.pointerType === "keyboard" && !$72b2d936d76f9ffe$var$$880e95eb8b93ba9a$var$isActionKey()) return;
                performAction(e);
            } else if (e.pointerType !== "keyboard" && allowsSelection) onSelect(e);
        };
        else {
            itemPressProps.onPressUp = hasPrimaryAction ? null : (e)=>{
                if (e.pointerType !== "keyboard" && allowsSelection) onSelect(e);
            };
            itemPressProps.onPress = hasPrimaryAction ? performAction : null;
        }
    } else {
        itemPressProps.onPressStart = (e)=>{
            modality.current = e.pointerType;
            longPressEnabledOnPressStart.current = longPressEnabled;
            hadPrimaryActionOnPressStart.current = hasPrimaryAction;
            // Select on mouse down unless there is a primary action which will occur on mouse up.
            // For keyboard, select on key down. If there is an action, the Space key selects on key down,
            // and the Enter key performs onAction on key up.
            if (allowsSelection && (e.pointerType === "mouse" && !hasPrimaryAction || e.pointerType === "keyboard" && (!allowsActions || $72b2d936d76f9ffe$var$$880e95eb8b93ba9a$var$isSelectionKey()))) onSelect(e);
        };
        itemPressProps.onPress = (e)=>{
            // Selection occurs on touch up. Primary actions always occur on pointer up.
            // Both primary and secondary actions occur on Enter key up. The only exception
            // is secondary actions, which occur on double click with a mouse.
            if (e.pointerType === "touch" || e.pointerType === "pen" || e.pointerType === "virtual" || e.pointerType === "keyboard" && hasAction && $72b2d936d76f9ffe$var$$880e95eb8b93ba9a$var$isActionKey() || e.pointerType === "mouse" && hadPrimaryActionOnPressStart.current) {
                if (hasAction) performAction(e);
                else if (allowsSelection) onSelect(e);
            }
        };
    }
    itemProps["data-key"] = key;
    itemPressProps.preventFocusOnPress = shouldUseVirtualFocus;
    let { pressProps: pressProps, isPressed: isPressed } = (0, $f1c2c36c3bf67162$export$45712eceda6fad21)(itemPressProps);
    // Double clicking with a mouse with selectionBehavior = 'replace' performs an action.
    let onDoubleClick = hasSecondaryAction ? (e)=>{
        if (modality.current === "mouse") {
            e.stopPropagation();
            e.preventDefault();
            performAction(e);
        }
    } : undefined;
    // Long pressing an item with touch when selectionBehavior = 'replace' switches the selection behavior
    // to 'toggle'. This changes the single tap behavior from performing an action (i.e. navigating) to
    // selecting, and may toggle the appearance of a UI affordance like checkboxes on each item.
    let { longPressProps: longPressProps } = (0, $b474ca2e51320d7f$export$c24ed0104d07eab9)({
        isDisabled: !longPressEnabled,
        onLongPress (e) {
            if (e.pointerType === "touch") {
                onSelect(e);
                manager.setSelectionBehavior("toggle");
            }
        }
    });
    // Prevent native drag and drop on long press if we also select on long press.
    // Once the user is in selection mode, they can long press again to drag.
    // Use a capturing listener to ensure this runs before useDrag, regardless of
    // the order the props get merged.
    let onDragStartCapture = (e)=>{
        if (modality.current === "touch" && longPressEnabledOnPressStart.current) e.preventDefault();
    };
    // Prevent default on link clicks so that we control exactly
    // when they open (to match selection behavior).
    let onClick = manager.isLink(key) ? (e)=>{
        if (!(0, $aCMC4.openLink).isOpening) e.preventDefault();
    } : undefined;
    return {
        itemProps: (0, $dCyIs.mergeProps)(itemProps, allowsSelection || hasPrimaryAction ? pressProps : {}, longPressEnabled ? longPressProps : {}, {
            onDoubleClick: onDoubleClick,
            onDragStartCapture: onDragStartCapture,
            onClick: onClick
        }),
        isPressed: isPressed,
        isSelected: manager.isSelected(key),
        isFocused: manager.isFocused && manager.focusedKey === key,
        isDisabled: isDisabled,
        allowsSelection: allowsSelection,
        hasAction: hasAction
    };
}
function $72b2d936d76f9ffe$var$$880e95eb8b93ba9a$var$isActionKey() {
    let event = window.event;
    return (event === null || event === void 0 ? void 0 : event.key) === "Enter";
}
function $72b2d936d76f9ffe$var$$880e95eb8b93ba9a$var$isSelectionKey() {
    let event = window.event;
    return (event === null || event === void 0 ? void 0 : event.key) === " " || (event === null || event === void 0 ? void 0 : event.code) === "Space";
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $72b2d936d76f9ffe$export$a05409b8bb224a5a {
    getNextKey(key) {
        key = this.collection.getKeyAfter(key);
        while(key != null){
            let item = this.collection.getItem(key);
            if (item.type === "item" && !this.disabledKeys.has(key)) return key;
            key = this.collection.getKeyAfter(key);
        }
        return null;
    }
    getPreviousKey(key) {
        key = this.collection.getKeyBefore(key);
        while(key != null){
            let item = this.collection.getItem(key);
            if (item.type === "item" && !this.disabledKeys.has(key)) return key;
            key = this.collection.getKeyBefore(key);
        }
        return null;
    }
    findKey(key, nextKey, shouldSkip) {
        let item = this.getItem(key);
        if (!item) return null;
        // Find the item above or below in the same column.
        let prevRect = item.getBoundingClientRect();
        do {
            key = nextKey(key);
            item = this.getItem(key);
        }while (item && shouldSkip(prevRect, item.getBoundingClientRect()));
        return key;
    }
    isSameRow(prevRect, itemRect) {
        return prevRect.top === itemRect.top || prevRect.left !== itemRect.left;
    }
    isSameColumn(prevRect, itemRect) {
        return prevRect.left === itemRect.left || prevRect.top !== itemRect.top;
    }
    getKeyBelow(key) {
        if (this.layout === "grid" && this.orientation === "vertical") return this.findKey(key, (key)=>this.getNextKey(key), this.isSameRow);
        else return this.getNextKey(key);
    }
    getKeyAbove(key) {
        if (this.layout === "grid" && this.orientation === "vertical") return this.findKey(key, (key)=>this.getPreviousKey(key), this.isSameRow);
        else return this.getPreviousKey(key);
    }
    getNextColumn(key, right) {
        return right ? this.getPreviousKey(key) : this.getNextKey(key);
    }
    getKeyRightOf(key) {
        if (this.layout === "grid") {
            if (this.orientation === "vertical") return this.getNextColumn(key, this.direction === "rtl");
            else return this.findKey(key, (key)=>this.getNextColumn(key, this.direction === "rtl"), this.isSameColumn);
        } else if (this.orientation === "horizontal") return this.getNextColumn(key, this.direction === "rtl");
        return null;
    }
    getKeyLeftOf(key) {
        if (this.layout === "grid") {
            if (this.orientation === "vertical") return this.getNextColumn(key, this.direction === "ltr");
            else return this.findKey(key, (key)=>this.getNextColumn(key, this.direction === "ltr"), this.isSameColumn);
        } else if (this.orientation === "horizontal") return this.getNextColumn(key, this.direction === "ltr");
        return null;
    }
    getFirstKey() {
        let key = this.collection.getFirstKey();
        while(key != null){
            let item = this.collection.getItem(key);
            if ((item === null || item === void 0 ? void 0 : item.type) === "item" && !this.disabledKeys.has(key)) return key;
            key = this.collection.getKeyAfter(key);
        }
        return null;
    }
    getLastKey() {
        let key = this.collection.getLastKey();
        while(key != null){
            let item = this.collection.getItem(key);
            if (item.type === "item" && !this.disabledKeys.has(key)) return key;
            key = this.collection.getKeyBefore(key);
        }
        return null;
    }
    getItem(key) {
        return this.ref.current.querySelector(`[data-key="${CSS.escape(key.toString())}"]`);
    }
    getKeyPageAbove(key) {
        let menu = this.ref.current;
        let item = this.getItem(key);
        if (!item) return null;
        if (!(0, $eiwoe.isScrollable)(menu)) return this.getFirstKey();
        let containerRect = menu.getBoundingClientRect();
        let itemRect = item.getBoundingClientRect();
        if (this.orientation === "horizontal") {
            let containerX = containerRect.x - menu.scrollLeft;
            let pageX = Math.max(0, itemRect.x - containerX + itemRect.width - containerRect.width);
            while(item && itemRect.x - containerX > pageX){
                key = this.getKeyAbove(key);
                item = key == null ? null : this.getItem(key);
                itemRect = item === null || item === void 0 ? void 0 : item.getBoundingClientRect();
            }
        } else {
            let containerY = containerRect.y - menu.scrollTop;
            let pageY = Math.max(0, itemRect.y - containerY + itemRect.height - containerRect.height);
            while(item && itemRect.y - containerY > pageY){
                key = this.getKeyAbove(key);
                item = key == null ? null : this.getItem(key);
                itemRect = item === null || item === void 0 ? void 0 : item.getBoundingClientRect();
            }
        }
        return key !== null && key !== void 0 ? key : this.getFirstKey();
    }
    getKeyPageBelow(key) {
        let menu = this.ref.current;
        let item = this.getItem(key);
        if (!item) return null;
        if (!(0, $eiwoe.isScrollable)(menu)) return this.getLastKey();
        let containerRect = menu.getBoundingClientRect();
        let itemRect = item.getBoundingClientRect();
        if (this.orientation === "horizontal") {
            let containerX = containerRect.x - menu.scrollLeft;
            let pageX = Math.min(menu.scrollWidth, itemRect.x - containerX - itemRect.width + containerRect.width);
            while(item && itemRect.x - containerX < pageX){
                key = this.getKeyBelow(key);
                item = key == null ? null : this.getItem(key);
                itemRect = item === null || item === void 0 ? void 0 : item.getBoundingClientRect();
            }
        } else {
            let containerY = containerRect.y - menu.scrollTop;
            let pageY = Math.min(menu.scrollHeight, itemRect.y - containerY - itemRect.height + containerRect.height);
            while(item && itemRect.y - containerY < pageY){
                key = this.getKeyBelow(key);
                item = key == null ? null : this.getItem(key);
                itemRect = item === null || item === void 0 ? void 0 : item.getBoundingClientRect();
            }
        }
        return key !== null && key !== void 0 ? key : this.getLastKey();
    }
    getKeyForSearch(search, fromKey) {
        if (!this.collator) return null;
        let collection = this.collection;
        let key = fromKey || this.getFirstKey();
        while(key != null){
            let item = collection.getItem(key);
            let substring = item.textValue.slice(0, search.length);
            if (item.textValue && this.collator.compare(substring, search) === 0) return key;
            key = this.getKeyBelow(key);
        }
        return null;
    }
    constructor(...args){
        if (args.length === 1) {
            let opts = args[0];
            this.collection = opts.collection;
            this.ref = opts.ref;
            this.collator = opts.collator;
            this.disabledKeys = opts.disabledKeys || new Set();
            this.orientation = opts.orientation;
            this.direction = opts.direction;
            this.layout = opts.layout || "stack";
        } else {
            this.collection = args[0];
            this.disabledKeys = args[1];
            this.ref = args[2];
            this.collator = args[3];
            this.layout = "stack";
            this.orientation = "vertical";
        }
        // If this is a vertical stack, remove the left/right methods completely
        // so they aren't called by useDroppableCollection.
        if (this.layout === "stack" && this.orientation === "vertical") {
            this.getKeyLeftOf = undefined;
            this.getKeyRightOf = undefined;
        }
    }
}
function $72b2d936d76f9ffe$export$b95089534ab7c1fd(props) {
    let { selectionManager: selectionManager, collection: collection, disabledKeys: disabledKeys, ref: ref, keyboardDelegate: keyboardDelegate } = props;
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    let collator = (0, $i6bwP.useCollator)({
        usage: "search",
        sensitivity: "base"
    });
    let disabledBehavior = selectionManager.disabledBehavior;
    let delegate = (0, $bh6RR.useMemo)(()=>keyboardDelegate || new $72b2d936d76f9ffe$export$a05409b8bb224a5a(collection, disabledBehavior === "selection" ? new Set() : disabledKeys, ref, collator), [
        keyboardDelegate,
        collection,
        disabledKeys,
        ref,
        collator,
        disabledBehavior
    ]);
    let { collectionProps: collectionProps } = $72b2d936d76f9ffe$export$d6daf82dcd84e87c({
        ...props,
        ref: ref,
        selectionManager: selectionManager,
        keyboardDelegate: delegate
    });
    return {
        listProps: collectionProps
    };
}


function $732838971a185c00$export$5820155232c5a02(props, state, ref) {
    let { listProps: listProps } = (0, $72b2d936d76f9ffe$export$b95089534ab7c1fd)({
        ...props,
        ...state,
        allowsTabNavigation: true,
        disallowSelectAll: true,
        ref: ref
    });
    delete listProps.onKeyDownCapture;
    return {
        accordionProps: {
            ...listProps,
            tabIndex: void 0
        }
    };
}


"use client";
function $2ad8dcaa68fa02d2$export$35e88b08325f7140(props) {
    var _a;
    const globalContext = (0, $gSab4.useProviderContext)();
    const { ref: ref, as: as, className: className, items: items, variant: variant, motionProps: motionProps, expandedKeys: expandedKeys, disabledKeys: disabledKeys, selectedKeys: selectedKeys, children: childrenProp, defaultExpandedKeys: defaultExpandedKeys, selectionMode: selectionMode = "single", selectionBehavior: selectionBehavior = "toggle", keepContentMounted: keepContentMounted = false, disallowEmptySelection: disallowEmptySelection, defaultSelectedKeys: defaultSelectedKeys, onExpandedChange: onExpandedChange, onSelectionChange: onSelectionChange, dividerProps: dividerProps = {}, isCompact: isCompact = false, isDisabled: isDisabled = false, showDivider: showDivider = true, hideIndicator: hideIndicator = false, disableAnimation: disableAnimation = (_a = globalContext == null ? void 0 : globalContext.disableAnimation) != null ? _a : false, disableIndicatorAnimation: disableIndicatorAnimation = false, itemClasses: itemClasses, ...otherProps } = props;
    const [focusedKey, setFocusedKey] = (0, $bh6RR.useState)(null);
    const Component = as || "div";
    const shouldFilterDOMProps = typeof Component === "string";
    const domRef = (0, $gedB5.useDOMRef)(ref);
    const classNames = (0, $bh6RR.useMemo)(()=>(0, $4c008118e645dd87$export$77f5744dadf9dca6)({
            variant: variant,
            className: className
        }), [
        variant,
        className
    ]);
    const children = (0, $bh6RR.useMemo)(()=>{
        let treeChildren = [];
        (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Children.map(childrenProp, (child)=>{
            var _a2;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).isValidElement(child) && typeof ((_a2 = child.props) == null ? void 0 : _a2.children) !== "string") {
                const clonedChild = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).cloneElement(child, {
                    hasChildItems: false
                });
                treeChildren.push(clonedChild);
            } else treeChildren.push(child);
        });
        return treeChildren;
    }, [
        childrenProp
    ]);
    const commonProps = {
        children: children,
        items: items
    };
    const expandableProps = {
        expandedKeys: expandedKeys,
        defaultExpandedKeys: defaultExpandedKeys,
        onExpandedChange: onExpandedChange
    };
    const treeProps = {
        disabledKeys: disabledKeys,
        selectedKeys: selectedKeys,
        selectionMode: selectionMode,
        selectionBehavior: selectionBehavior,
        disallowEmptySelection: disallowEmptySelection,
        defaultSelectedKeys: defaultSelectedKeys != null ? defaultSelectedKeys : defaultExpandedKeys,
        onSelectionChange: onSelectionChange,
        ...commonProps,
        ...expandableProps
    };
    const state = (0, $2eb53f72fa5c6dbd$export$728d6ba534403756)(treeProps);
    state.selectionManager.setFocusedKey = (key)=>{
        setFocusedKey(key);
    };
    const { accordionProps: accordionProps } = (0, $732838971a185c00$export$5820155232c5a02)({
        ...commonProps,
        ...expandableProps
    }, state, domRef);
    const values = (0, $bh6RR.useMemo)(()=>({
            state: state,
            focusedKey: focusedKey,
            motionProps: motionProps,
            isCompact: isCompact,
            isDisabled: isDisabled,
            hideIndicator: hideIndicator,
            disableAnimation: disableAnimation,
            keepContentMounted: keepContentMounted,
            disableIndicatorAnimation: disableIndicatorAnimation
        }), [
        focusedKey,
        isCompact,
        isDisabled,
        hideIndicator,
        selectedKeys,
        disableAnimation,
        keepContentMounted,
        state == null ? void 0 : state.expandedKeys.values,
        disableIndicatorAnimation,
        state.expandedKeys.size,
        state.disabledKeys.size,
        motionProps
    ]);
    const getBaseProps = (0, $bh6RR.useCallback)((props2 = {})=>{
        return {
            ref: domRef,
            className: classNames,
            "data-orientation": "vertical",
            ...(0, $dCyIs.mergeProps)(accordionProps, (0, $bIkcs.filterDOMProps)(otherProps, {
                enabled: shouldFilterDOMProps
            }), props2)
        };
    }, []);
    const handleFocusChanged = (0, $bh6RR.useCallback)((isFocused, key)=>{
        isFocused && setFocusedKey(key);
    }, []);
    return {
        Component: Component,
        values: values,
        state: state,
        focusedKey: focusedKey,
        getBaseProps: getBaseProps,
        isSplitted: variant === "splitted",
        classNames: classNames,
        showDivider: showDivider,
        dividerProps: dividerProps,
        disableAnimation: disableAnimation,
        handleFocusChanged: handleFocusChanged,
        itemClasses: itemClasses
    };
}



var $hN2BG = parcelRequire("hN2BG");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $2JU6p = parcelRequire("2JU6p");

var $bh6RR = parcelRequire("bh6RR");
/**
 * Note: Still used by components generated by old versions of Framer
 *
 * @deprecated
 */ const $01b6592cc49933c5$export$f3b8df5418bf8d44 = (0, $bh6RR.createContext)(null);



var $kIcmp = parcelRequire("kIcmp");
const $ee05b06512be977f$var$notify = (node)=>!node.isLayoutDirty && node.willUpdate(false);
function $ee05b06512be977f$export$df39f9da6f278ce7() {
    const nodes = new Set();
    const subscriptions = new WeakMap();
    const dirtyAll = ()=>nodes.forEach($ee05b06512be977f$var$notify);
    return {
        add: (node)=>{
            nodes.add(node);
            subscriptions.set(node, node.addEventListener("willUpdate", dirtyAll));
        },
        remove: (node)=>{
            nodes.delete(node);
            const unsubscribe = subscriptions.get(node);
            if (unsubscribe) {
                unsubscribe();
                subscriptions.delete(node);
            }
            dirtyAll();
        },
        dirty: dirtyAll
    };
}


const $820ec76912211d3a$var$shouldInheritGroup = (inherit)=>inherit === true;
const $820ec76912211d3a$var$shouldInheritId = (inherit)=>$820ec76912211d3a$var$shouldInheritGroup(inherit === true) || inherit === "id";
const $820ec76912211d3a$export$7fe0cbe305f29bb4 = ({ children: children, id: id, inherit: inherit = true })=>{
    const layoutGroupContext = (0, $bh6RR.useContext)((0, $2JU6p.LayoutGroupContext));
    const deprecatedLayoutGroupContext = (0, $bh6RR.useContext)((0, $01b6592cc49933c5$export$f3b8df5418bf8d44));
    const [forceRender, key] = (0, $kIcmp.useForceUpdate)();
    const context = (0, $bh6RR.useRef)(null);
    const upstreamId = layoutGroupContext.id || deprecatedLayoutGroupContext;
    if (context.current === null) {
        if ($820ec76912211d3a$var$shouldInheritId(inherit) && upstreamId) id = id ? upstreamId + "-" + id : upstreamId;
        context.current = {
            id: id,
            group: $820ec76912211d3a$var$shouldInheritGroup(inherit) ? layoutGroupContext.group || (0, $ee05b06512be977f$export$df39f9da6f278ce7)() : (0, $ee05b06512be977f$export$df39f9da6f278ce7)()
        };
    }
    const memoizedContext = (0, $bh6RR.useMemo)(()=>({
            ...context.current,
            forceRender: forceRender
        }), [
        key
    ]);
    return (0, $ih19M.jsx)((0, $2JU6p.LayoutGroupContext).Provider, {
        value: memoizedContext,
        children: children
    });
};



var $1Bn3l = parcelRequire("1Bn3l");

var $bh6RR = parcelRequire("bh6RR");

var $ih19M = parcelRequire("ih19M");
"use client";
var $4e54f759c6d6bd3e$var$AccordionGroup = (0, $hN2BG.forwardRef)((props, ref)=>{
    const { Component: Component, values: values, state: state, isSplitted: isSplitted, showDivider: showDivider, getBaseProps: getBaseProps, disableAnimation: disableAnimation, handleFocusChanged: handleFocusChangedProps, itemClasses: itemClasses } = (0, $2ad8dcaa68fa02d2$export$35e88b08325f7140)({
        ...props,
        ref: ref
    });
    const handleFocusChanged = (0, $bh6RR.useCallback)((isFocused, key)=>handleFocusChangedProps(isFocused, key), [
        handleFocusChangedProps
    ]);
    const content = (0, $bh6RR.useMemo)(()=>{
        return [
            ...state.collection
        ].map((item, index)=>{
            const classNames = {
                ...itemClasses,
                ...item.props.classNames || {}
            };
            return /* @__PURE__ */ (0, $ih19M.jsxs)((0, $bh6RR.Fragment), {
                children: [
                    /* @__PURE__ */ (0, $ih19M.jsx)((0, $a0b066c6374625da$export$5ef1f4ac978cb89a), {
                        item: item,
                        onFocusChange: handleFocusChanged,
                        ...values,
                        ...item.props,
                        classNames: classNames
                    }),
                    !item.props.hidden && !isSplitted && showDivider && index < state.collection.size - 1 && /* @__PURE__ */ (0, $ih19M.jsx)((0, $1Bn3l.divider_default), {})
                ]
            }, item.key);
        });
    }, [
        values,
        itemClasses,
        handleFocusChanged,
        isSplitted,
        showDivider,
        state.collection
    ]);
    return /* @__PURE__ */ (0, $ih19M.jsx)(Component, {
        ...getBaseProps(),
        children: disableAnimation ? content : /* @__PURE__ */ (0, $ih19M.jsx)((0, $820ec76912211d3a$export$7fe0cbe305f29bb4), {
            children: content
        })
    });
});
$4e54f759c6d6bd3e$var$AccordionGroup.displayName = "NextUI.Accordion";
var $4e54f759c6d6bd3e$export$c4b5f538249c1147 = $4e54f759c6d6bd3e$var$AccordionGroup;


var $cTO50 = parcelRequire("cTO50");
"use client";
var $c7696c16791d5195$var$AccordionItemBase = (0, $cTO50.Item);
var $c7696c16791d5195$export$8a1014f5852fad66 = $c7696c16791d5195$var$AccordionItemBase;


var $6ujkL = parcelRequire("6ujkL");

var $g2NHD = parcelRequire("g2NHD");
// src/components/link.ts
var $63b3dc4cdca591ba$export$9c30223ca0a664fb = (0, $6ujkL.tv)({
    base: [
        "relative inline-flex items-center outline-none tap-highlight-transparent",
        ...(0, $g2NHD.dataFocusVisibleClasses)
    ],
    variants: {
        size: {
            sm: "text-small",
            md: "text-medium",
            lg: "text-large"
        },
        color: {
            foreground: "text-foreground",
            primary: "text-primary",
            secondary: "text-secondary",
            success: "text-success",
            warning: "text-warning",
            danger: "text-danger"
        },
        underline: {
            none: "no-underline",
            hover: "hover:underline",
            always: "underline",
            active: "active:underline",
            focus: "focus:underline"
        },
        isBlock: {
            true: [
                "px-2",
                "py-1",
                "hover:after:opacity-100",
                "after:content-['']",
                "after:inset-0",
                "after:opacity-0",
                "after:w-full",
                "after:h-full",
                "after:rounded-xl",
                "after:transition-background",
                "after:absolute"
            ],
            false: "hover:opacity-80 active:opacity-disabled transition-opacity"
        },
        isDisabled: {
            true: "opacity-disabled cursor-default pointer-events-none"
        },
        disableAnimation: {
            true: "after:transition-none transition-none"
        }
    },
    compoundVariants: [
        {
            isBlock: true,
            color: "foreground",
            class: "hover:after:bg-foreground/10"
        },
        {
            isBlock: true,
            color: "primary",
            class: "hover:after:bg-primary/20"
        },
        {
            isBlock: true,
            color: "secondary",
            class: "hover:after:bg-secondary/20"
        },
        {
            isBlock: true,
            color: "success",
            class: "hover:after:bg-success/20"
        },
        {
            isBlock: true,
            color: "warning",
            class: "hover:after:bg-warning/20"
        },
        {
            isBlock: true,
            color: "danger",
            class: "hover:after:bg-danger/20"
        },
        {
            underline: [
                "hover",
                "always",
                "active",
                "focus"
            ],
            class: "underline-offset-4"
        }
    ],
    defaultVariants: {
        color: "primary",
        size: "md",
        isBlock: false,
        underline: "none",
        isDisabled: false
    }
});
var $63b3dc4cdca591ba$export$1d42287988367e45 = "flex mx-1 text-current self-center";



var $leZvJ = parcelRequire("leZvJ");
var $dCyIs = parcelRequire("dCyIs");
var $aCMC4 = parcelRequire("aCMC4");

var $61nPD = parcelRequire("61nPD");
var $ld26B = parcelRequire("ld26B");
var $8l8s9 = parcelRequire("8l8s9");

var $ld26B = parcelRequire("ld26B");
var $kI2if = parcelRequire("kI2if");
var $7uYIl = parcelRequire("7uYIl");

var $bh6RR = parcelRequire("bh6RR");

var $2GhkT = parcelRequire("2GhkT");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $65fac60056f56f87$var$$507fabe10e71c6fb$var$currentModality = null;
let $65fac60056f56f87$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $65fac60056f56f87$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $65fac60056f56f87$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $65fac60056f56f87$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $65fac60056f56f87$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $65fac60056f56f87$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $65fac60056f56f87$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $65fac60056f56f87$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $kI2if.isMac)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $65fac60056f56f87$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $65fac60056f56f87$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($65fac60056f56f87$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $65fac60056f56f87$var$$507fabe10e71c6fb$var$currentModality = "keyboard";
        $65fac60056f56f87$var$$507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $65fac60056f56f87$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $65fac60056f56f87$var$$507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $65fac60056f56f87$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $65fac60056f56f87$var$$507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $65fac60056f56f87$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $7uYIl.isVirtualClick)(e)) {
        $65fac60056f56f87$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $65fac60056f56f87$var$$507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $65fac60056f56f87$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$65fac60056f56f87$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$65fac60056f56f87$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $65fac60056f56f87$var$$507fabe10e71c6fb$var$currentModality = "virtual";
        $65fac60056f56f87$var$$507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $65fac60056f56f87$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $65fac60056f56f87$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $65fac60056f56f87$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $65fac60056f56f87$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $65fac60056f56f87$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $65fac60056f56f87$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === "undefined" || $65fac60056f56f87$export$d90243b58daecda7.get((0, $ld26B.getOwnerWindow)(element))) return;
    const windowObject = (0, $ld26B.getOwnerWindow)(element);
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $65fac60056f56f87$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener("keydown", $65fac60056f56f87$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("keyup", $65fac60056f56f87$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("click", $65fac60056f56f87$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener("focus", $65fac60056f56f87$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener("blur", $65fac60056f56f87$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.addEventListener("pointerdown", $65fac60056f56f87$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointermove", $65fac60056f56f87$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointerup", $65fac60056f56f87$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener("mousedown", $65fac60056f56f87$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mousemove", $65fac60056f56f87$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mouseup", $65fac60056f56f87$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener("beforeunload", ()=>{
        $65fac60056f56f87$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $65fac60056f56f87$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $65fac60056f56f87$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $ld26B.getOwnerWindow)(element);
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
    if (!$65fac60056f56f87$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $65fac60056f56f87$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener("keydown", $65fac60056f56f87$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("keyup", $65fac60056f56f87$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("click", $65fac60056f56f87$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener("focus", $65fac60056f56f87$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener("blur", $65fac60056f56f87$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.removeEventListener("pointerdown", $65fac60056f56f87$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointermove", $65fac60056f56f87$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointerup", $65fac60056f56f87$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener("mousedown", $65fac60056f56f87$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mousemove", $65fac60056f56f87$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mouseup", $65fac60056f56f87$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $65fac60056f56f87$export$d90243b58daecda7.delete(windowObject);
};
function $65fac60056f56f87$export$2f1888112f558a7d(element) {
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    let loadListener;
    if (documentObject.readyState !== "loading") $65fac60056f56f87$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $65fac60056f56f87$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener("DOMContentLoaded", loadListener);
    }
    return ()=>$65fac60056f56f87$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== "undefined") $65fac60056f56f87$export$2f1888112f558a7d();
function $65fac60056f56f87$export$b9b3dfddab17db27() {
    return $65fac60056f56f87$var$$507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $65fac60056f56f87$export$630ff653c5ada6a9() {
    return $65fac60056f56f87$var$$507fabe10e71c6fb$var$currentModality;
}
function $65fac60056f56f87$export$8397ddfc504fdb9a(modality) {
    $65fac60056f56f87$var$$507fabe10e71c6fb$var$currentModality = modality;
    $65fac60056f56f87$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $65fac60056f56f87$export$98e20ec92f614cfe() {
    $65fac60056f56f87$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $bh6RR.useState)($65fac60056f56f87$var$$507fabe10e71c6fb$var$currentModality);
    (0, $bh6RR.useEffect)(()=>{
        let handler = ()=>{
            setModality($65fac60056f56f87$var$$507fabe10e71c6fb$var$currentModality);
        };
        $65fac60056f56f87$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $65fac60056f56f87$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $2GhkT.useIsSSR)() ? null : modality;
}
const $65fac60056f56f87$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $65fac60056f56f87$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    const IHTMLInputElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$65fac60056f56f87$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === "keyboard" && e instanceof IKeyboardEvent && !$65fac60056f56f87$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $65fac60056f56f87$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $bh6RR.useState)(autoFocus || $65fac60056f56f87$export$b9b3dfddab17db27());
    $65fac60056f56f87$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $65fac60056f56f87$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $65fac60056f56f87$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $bh6RR.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$65fac60056f56f87$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($65fac60056f56f87$export$b9b3dfddab17db27());
        };
        $65fac60056f56f87$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $65fac60056f56f87$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $2a881f417c85c5bd$export$80f3e147d781571c(element) {
    // If the user is interacting with a virtual cursor, e.g. screen reader, then
    // wait until after any animated transitions that are currently occurring on
    // the page before shifting focus. This avoids issues with VoiceOver on iOS
    // causing the page to scroll when moving focus if the element is transitioning
    // from off the screen.
    const ownerDocument = (0, $ld26B.getOwnerDocument)(element);
    if ((0, $65fac60056f56f87$export$630ff653c5ada6a9)() === "virtual") {
        let lastFocusedElement = ownerDocument.activeElement;
        (0, $8l8s9.runAfterTransition)(()=>{
            // If focus did not move and the element is still in the document, focus it.
            if (ownerDocument.activeElement === lastFocusedElement && element.isConnected) (0, $61nPD.focusWithoutScrolling)(element);
        });
    } else (0, $61nPD.focusWithoutScrolling)(element);
}



var $dCyIs = parcelRequire("dCyIs");
var $99EP5 = parcelRequire("99EP5");
var $2Cn0z = parcelRequire("2Cn0z");

var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");

var $77fRS = parcelRequire("77fRS");
var $1nsPC = parcelRequire("1nsPC");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $1a599dbf110b855a$export$905e7fc544a71f36 {
    isDefaultPrevented() {
        return this.nativeEvent.defaultPrevented;
    }
    preventDefault() {
        this.defaultPrevented = true;
        this.nativeEvent.preventDefault();
    }
    stopPropagation() {
        this.nativeEvent.stopPropagation();
        this.isPropagationStopped = ()=>true;
    }
    isPropagationStopped() {
        return false;
    }
    persist() {}
    constructor(type, nativeEvent){
        this.nativeEvent = nativeEvent;
        this.target = nativeEvent.target;
        this.currentTarget = nativeEvent.currentTarget;
        this.relatedTarget = nativeEvent.relatedTarget;
        this.bubbles = nativeEvent.bubbles;
        this.cancelable = nativeEvent.cancelable;
        this.defaultPrevented = nativeEvent.defaultPrevented;
        this.eventPhase = nativeEvent.eventPhase;
        this.isTrusted = nativeEvent.isTrusted;
        this.timeStamp = nativeEvent.timeStamp;
        this.type = type;
    }
}
function $1a599dbf110b855a$export$715c682d09d639cc(onBlur) {
    let stateRef = (0, $bh6RR.useRef)({
        isFocused: false,
        observer: null
    });
    (0, $1nsPC.useLayoutEffect)(()=>{
        const state = stateRef.current;
        return ()=>{
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    let dispatchBlur = (0, $77fRS.useEffectEvent)((e)=>{
        onBlur === null || onBlur === void 0 || onBlur(e);
    });
    // This function is called during a React onFocus event.
    return (0, $bh6RR.useCallback)((e)=>{
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            let target = e.target;
            let onBlurHandler = (e)=>{
                stateRef.current.isFocused = false;
                if (target.disabled) dispatchBlur(new $1a599dbf110b855a$export$905e7fc544a71f36("blur", e));
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener("focusout", onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(()=>{
                if (stateRef.current.isFocused && target.disabled) {
                    var _stateRef_current_observer;
                    (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 || _stateRef_current_observer.disconnect();
                    let relatedTargetEl = target === document.activeElement ? null : document.activeElement;
                    target.dispatchEvent(new FocusEvent("blur", {
                        relatedTarget: relatedTargetEl
                    }));
                    target.dispatchEvent(new FocusEvent("focusout", {
                        bubbles: true,
                        relatedTarget: relatedTargetEl
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    "disabled"
                ]
            });
        }
    }, [
        dispatchBlur
    ]);
}



var $bh6RR = parcelRequire("bh6RR");

var $ld26B = parcelRequire("ld26B");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $ec51641e6fb7a3d8$export$f8168d8dd8fd66e6(props) {
    let { isDisabled: isDisabled, onFocus: onFocusProp, onBlur: onBlurProp, onFocusChange: onFocusChange } = props;
    const onBlur = (0, $bh6RR.useCallback)((e)=>{
        if (e.target === e.currentTarget) {
            if (onBlurProp) onBlurProp(e);
            if (onFocusChange) onFocusChange(false);
            return true;
        }
    }, [
        onBlurProp,
        onFocusChange
    ]);
    const onSyntheticFocus = (0, $1a599dbf110b855a$export$715c682d09d639cc)(onBlur);
    const onFocus = (0, $bh6RR.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        const ownerDocument = (0, $ld26B.getOwnerDocument)(e.target);
        if (e.target === e.currentTarget && ownerDocument.activeElement === e.target) {
            if (onFocusProp) onFocusProp(e);
            if (onFocusChange) onFocusChange(true);
            onSyntheticFocus(e);
        }
    }, [
        onFocusChange,
        onFocusProp,
        onSyntheticFocus
    ]);
    return {
        focusProps: {
            onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : undefined,
            onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : undefined
        }
    };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $98185ddf6b6f6f24$export$48d1ea6320830260(handler) {
    if (!handler) return undefined;
    let shouldStopPropagation = true;
    return (e)=>{
        let event = {
            ...e,
            preventDefault () {
                e.preventDefault();
            },
            isDefaultPrevented () {
                return e.isDefaultPrevented();
            },
            stopPropagation () {
                console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.");
            },
            continuePropagation () {
                shouldStopPropagation = false;
            }
        };
        handler(event);
        if (shouldStopPropagation) e.stopPropagation();
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $750eda29c7fbdfca$export$8f71654801c2f7cd(props) {
    return {
        keyboardProps: props.isDisabled ? {} : {
            onKeyDown: (0, $98185ddf6b6f6f24$export$48d1ea6320830260)(props.onKeyDown),
            onKeyUp: (0, $98185ddf6b6f6f24$export$48d1ea6320830260)(props.onKeyUp)
        }
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $a49c9d1e29111bf4$var$$e6afbd83fe6ebbd2$var$FocusableContext = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(null);
function $a49c9d1e29111bf4$var$$e6afbd83fe6ebbd2$var$useFocusableContext(ref) {
    let context = (0, $bh6RR.useContext)($a49c9d1e29111bf4$var$$e6afbd83fe6ebbd2$var$FocusableContext) || {};
    (0, $2Cn0z.useSyncRef)(context, ref);
    // eslint-disable-next-line
    let { ref: _, ...otherProps } = context;
    return otherProps;
}
/**
 * Provides DOM props to the nearest focusable child.
 */ function $a49c9d1e29111bf4$var$$e6afbd83fe6ebbd2$var$FocusableProvider(props, ref) {
    let { children: children, ...otherProps } = props;
    let objRef = (0, $99EP5.useObjectRef)(ref);
    let context = {
        ...otherProps,
        ref: objRef
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($a49c9d1e29111bf4$var$$e6afbd83fe6ebbd2$var$FocusableContext.Provider, {
        value: context
    }, children);
}
let $a49c9d1e29111bf4$export$13f3202a3e5ddd5 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef($a49c9d1e29111bf4$var$$e6afbd83fe6ebbd2$var$FocusableProvider);
function $a49c9d1e29111bf4$export$4c014de7c8940b4c(props, domRef) {
    let { focusProps: focusProps } = (0, $ec51641e6fb7a3d8$export$f8168d8dd8fd66e6)(props);
    let { keyboardProps: keyboardProps } = (0, $750eda29c7fbdfca$export$8f71654801c2f7cd)(props);
    let interactions = (0, $dCyIs.mergeProps)(focusProps, keyboardProps);
    let domProps = $a49c9d1e29111bf4$var$$e6afbd83fe6ebbd2$var$useFocusableContext(domRef);
    let interactionProps = props.isDisabled ? {} : domProps;
    let autoFocusRef = (0, $bh6RR.useRef)(props.autoFocus);
    (0, $bh6RR.useEffect)(()=>{
        if (autoFocusRef.current && domRef.current) (0, $2a881f417c85c5bd$export$80f3e147d781571c)(domRef.current);
        autoFocusRef.current = false;
    }, [
        domRef
    ]);
    return {
        focusableProps: (0, $dCyIs.mergeProps)({
            ...interactions,
            tabIndex: props.excludeFromTabOrder && !props.isDisabled ? -1 : undefined
        }, interactionProps)
    };
}



var $ld26B = parcelRequire("ld26B");
var $kI2if = parcelRequire("kI2if");
var $8l8s9 = parcelRequire("8l8s9");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Note that state only matters here for iOS. Non-iOS gets user-select: none applied to the target element
// rather than at the document level so we just need to apply/remove user-select: none for each pressed element individually
let $ff38e19e007ac345$var$$14c0b72509d70225$var$state = "default";
let $ff38e19e007ac345$var$$14c0b72509d70225$var$savedUserSelect = "";
let $ff38e19e007ac345$var$$14c0b72509d70225$var$modifiedElementMap = new WeakMap();
function $ff38e19e007ac345$export$16a4697467175487(target) {
    if ((0, $kI2if.isIOS)()) {
        if ($ff38e19e007ac345$var$$14c0b72509d70225$var$state === "default") {
            // eslint-disable-next-line no-restricted-globals
            const documentObject = (0, $ld26B.getOwnerDocument)(target);
            $ff38e19e007ac345$var$$14c0b72509d70225$var$savedUserSelect = documentObject.documentElement.style.webkitUserSelect;
            documentObject.documentElement.style.webkitUserSelect = "none";
        }
        $ff38e19e007ac345$var$$14c0b72509d70225$var$state = "disabled";
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        // If not iOS, store the target's original user-select and change to user-select: none
        // Ignore state since it doesn't apply for non iOS
        $ff38e19e007ac345$var$$14c0b72509d70225$var$modifiedElementMap.set(target, target.style.userSelect);
        target.style.userSelect = "none";
    }
}
function $ff38e19e007ac345$export$b0d6fa1ab32e3295(target) {
    if ((0, $kI2if.isIOS)()) {
        // If the state is already default, there's nothing to do.
        // If it is restoring, then there's no need to queue a second restore.
        if ($ff38e19e007ac345$var$$14c0b72509d70225$var$state !== "disabled") return;
        $ff38e19e007ac345$var$$14c0b72509d70225$var$state = "restoring";
        // There appears to be a delay on iOS where selection still might occur
        // after pointer up, so wait a bit before removing user-select.
        setTimeout(()=>{
            (0, $8l8s9.runAfterTransition)(()=>{
                // Avoid race conditions
                if ($ff38e19e007ac345$var$$14c0b72509d70225$var$state === "restoring") {
                    // eslint-disable-next-line no-restricted-globals
                    const documentObject = (0, $ld26B.getOwnerDocument)(target);
                    if (documentObject.documentElement.style.webkitUserSelect === "none") documentObject.documentElement.style.webkitUserSelect = $ff38e19e007ac345$var$$14c0b72509d70225$var$savedUserSelect || "";
                    $ff38e19e007ac345$var$$14c0b72509d70225$var$savedUserSelect = "";
                    $ff38e19e007ac345$var$$14c0b72509d70225$var$state = "default";
                }
            });
        }, 300);
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        if (target && $ff38e19e007ac345$var$$14c0b72509d70225$var$modifiedElementMap.has(target)) {
            let targetOldUserSelect = $ff38e19e007ac345$var$$14c0b72509d70225$var$modifiedElementMap.get(target);
            if (target.style.userSelect === "none") target.style.userSelect = targetOldUserSelect;
            if (target.getAttribute("style") === "") target.removeAttribute("style");
            $ff38e19e007ac345$var$$14c0b72509d70225$var$modifiedElementMap.delete(target);
        }
    }
}



var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $6f7d4a38ac5940ee$export$5165eccb35aaadb5 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext({
    register: ()=>{}
});
$6f7d4a38ac5940ee$export$5165eccb35aaadb5.displayName = "PressResponderContext";



var $2iPDq = parcelRequire("2iPDq");

var $f9kyn = parcelRequire("f9kyn");

var $lgPAm = parcelRequire("lgPAm");

var $i65Wu = parcelRequire("i65Wu");
var $61nPD = parcelRequire("61nPD");
var $ld26B = parcelRequire("ld26B");
var $kI2if = parcelRequire("kI2if");
var $7uYIl = parcelRequire("7uYIl");
var $dCyIs = parcelRequire("dCyIs");
var $aCMC4 = parcelRequire("aCMC4");
var $77fRS = parcelRequire("77fRS");
var $1mw9Z = parcelRequire("1mw9Z");
var $2Cn0z = parcelRequire("2Cn0z");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $b28f596898fd4eac$var$$f6c31cce2adf654f$var$usePressResponderContext(props) {
    // Consume context from <PressResponder> and merge with props.
    let context = (0, $bh6RR.useContext)((0, $6f7d4a38ac5940ee$export$5165eccb35aaadb5));
    if (context) {
        let { register: register, ...contextProps } = context;
        props = (0, $dCyIs.mergeProps)(contextProps, props);
        register();
    }
    (0, $2Cn0z.useSyncRef)(context, props.ref);
    return props;
}
var $b28f596898fd4eac$var$$f6c31cce2adf654f$var$_shouldStopPropagation = /*#__PURE__*/ new WeakMap();
class $b28f596898fd4eac$var$$f6c31cce2adf654f$var$PressEvent {
    continuePropagation() {
        (0, $lgPAm._)(this, $b28f596898fd4eac$var$$f6c31cce2adf654f$var$_shouldStopPropagation, false);
    }
    get shouldStopPropagation() {
        return (0, $2iPDq._)(this, $b28f596898fd4eac$var$$f6c31cce2adf654f$var$_shouldStopPropagation);
    }
    constructor(type, pointerType, originalEvent){
        (0, $f9kyn._)(this, $b28f596898fd4eac$var$$f6c31cce2adf654f$var$_shouldStopPropagation, {
            writable: true,
            value: void 0
        });
        (0, $lgPAm._)(this, $b28f596898fd4eac$var$$f6c31cce2adf654f$var$_shouldStopPropagation, true);
        this.type = type;
        this.pointerType = pointerType;
        this.target = originalEvent.currentTarget;
        this.shiftKey = originalEvent.shiftKey;
        this.metaKey = originalEvent.metaKey;
        this.ctrlKey = originalEvent.ctrlKey;
        this.altKey = originalEvent.altKey;
    }
}
const $b28f596898fd4eac$var$$f6c31cce2adf654f$var$LINK_CLICKED = Symbol("linkClicked");
function $b28f596898fd4eac$export$45712eceda6fad21(props) {
    let { onPress: onPress, onPressChange: onPressChange, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressUp: onPressUp, isDisabled: isDisabled, isPressed: isPressedProp, preventFocusOnPress: preventFocusOnPress, shouldCancelOnPointerExit: shouldCancelOnPointerExit, allowTextSelectionOnPress: allowTextSelectionOnPress, ref: _, ...domProps } = $b28f596898fd4eac$var$$f6c31cce2adf654f$var$usePressResponderContext(props);
    let [isPressed, setPressed] = (0, $bh6RR.useState)(false);
    let ref = (0, $bh6RR.useRef)({
        isPressed: false,
        ignoreEmulatedMouseEvents: false,
        ignoreClickAfterPress: false,
        didFirePressStart: false,
        isTriggeringEvent: false,
        activePointerId: null,
        target: null,
        isOverTarget: false,
        pointerType: null
    });
    let { addGlobalListener: addGlobalListener, removeAllGlobalListeners: removeAllGlobalListeners } = (0, $1mw9Z.useGlobalListeners)();
    let triggerPressStart = (0, $77fRS.useEffectEvent)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled || state.didFirePressStart) return false;
        let shouldStopPropagation = true;
        state.isTriggeringEvent = true;
        if (onPressStart) {
            let event = new $b28f596898fd4eac$var$$f6c31cce2adf654f$var$PressEvent("pressstart", pointerType, originalEvent);
            onPressStart(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(true);
        state.isTriggeringEvent = false;
        state.didFirePressStart = true;
        setPressed(true);
        return shouldStopPropagation;
    });
    let triggerPressEnd = (0, $77fRS.useEffectEvent)((originalEvent, pointerType, wasPressed = true)=>{
        let state = ref.current;
        if (!state.didFirePressStart) return false;
        state.ignoreClickAfterPress = true;
        state.didFirePressStart = false;
        state.isTriggeringEvent = true;
        let shouldStopPropagation = true;
        if (onPressEnd) {
            let event = new $b28f596898fd4eac$var$$f6c31cce2adf654f$var$PressEvent("pressend", pointerType, originalEvent);
            onPressEnd(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(false);
        setPressed(false);
        if (onPress && wasPressed && !isDisabled) {
            let event = new $b28f596898fd4eac$var$$f6c31cce2adf654f$var$PressEvent("press", pointerType, originalEvent);
            onPress(event);
            shouldStopPropagation && (shouldStopPropagation = event.shouldStopPropagation);
        }
        state.isTriggeringEvent = false;
        return shouldStopPropagation;
    });
    let triggerPressUp = (0, $77fRS.useEffectEvent)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled) return false;
        if (onPressUp) {
            state.isTriggeringEvent = true;
            let event = new $b28f596898fd4eac$var$$f6c31cce2adf654f$var$PressEvent("pressup", pointerType, originalEvent);
            onPressUp(event);
            state.isTriggeringEvent = false;
            return event.shouldStopPropagation;
        }
        return true;
    });
    let cancel = (0, $77fRS.useEffectEvent)((e)=>{
        let state = ref.current;
        if (state.isPressed && state.target) {
            if (state.isOverTarget && state.pointerType != null) triggerPressEnd($b28f596898fd4eac$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
            state.isPressed = false;
            state.isOverTarget = false;
            state.activePointerId = null;
            state.pointerType = null;
            removeAllGlobalListeners();
            if (!allowTextSelectionOnPress) (0, $ff38e19e007ac345$export$b0d6fa1ab32e3295)(state.target);
        }
    });
    let cancelOnPointerExit = (0, $77fRS.useEffectEvent)((e)=>{
        if (shouldCancelOnPointerExit) cancel(e);
    });
    let pressProps = (0, $bh6RR.useMemo)(()=>{
        let state = ref.current;
        let pressProps = {
            onKeyDown (e) {
                if ($b28f596898fd4eac$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e.nativeEvent, e.currentTarget) && e.currentTarget.contains(e.target)) {
                    var _state_metaKeyEvents;
                    if ($b28f596898fd4eac$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                    // If the event is repeating, it may have started on a different element
                    // after which focus moved to the current element. Ignore these events and
                    // only handle the first key down event.
                    let shouldStopPropagation = true;
                    if (!state.isPressed && !e.repeat) {
                        state.target = e.currentTarget;
                        state.isPressed = true;
                        shouldStopPropagation = triggerPressStart(e, "keyboard");
                        // Focus may move before the key up event, so register the event on the document
                        // instead of the same element where the key down event occurred. Make it capturing so that it will trigger
                        // before stopPropagation from useKeyboard on a child element may happen and thus we can still call triggerPress for the parent element.
                        let originalTarget = e.currentTarget;
                        let pressUp = (e)=>{
                            if ($b28f596898fd4eac$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e, originalTarget) && !e.repeat && originalTarget.contains(e.target) && state.target) triggerPressUp($b28f596898fd4eac$var$$f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard");
                        };
                        addGlobalListener((0, $ld26B.getOwnerDocument)(e.currentTarget), "keyup", (0, $i65Wu.chain)(pressUp, onKeyUp), true);
                    }
                    if (shouldStopPropagation) e.stopPropagation();
                    // Keep track of the keydown events that occur while the Meta (e.g. Command) key is held.
                    // macOS has a bug where keyup events are not fired while the Meta key is down.
                    // When the Meta key itself is released we will get an event for that, and we'll act as if
                    // all of these other keys were released as well.
                    // https://bugs.chromium.org/p/chromium/issues/detail?id=1393524
                    // https://bugs.webkit.org/show_bug.cgi?id=55291
                    // https://bugzilla.mozilla.org/show_bug.cgi?id=1299553
                    if (e.metaKey && (0, $kI2if.isMac)()) (_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 || _state_metaKeyEvents.set(e.key, e.nativeEvent);
                } else if (e.key === "Meta") state.metaKeyEvents = new Map();
            },
            onClick (e) {
                if (e && !e.currentTarget.contains(e.target)) return;
                if (e && e.button === 0 && !state.isTriggeringEvent && !(0, $aCMC4.openLink).isOpening) {
                    let shouldStopPropagation = true;
                    if (isDisabled) e.preventDefault();
                    // If triggered from a screen reader or by using element.click(),
                    // trigger as if it were a keyboard click.
                    if (!state.ignoreClickAfterPress && !state.ignoreEmulatedMouseEvents && !state.isPressed && (state.pointerType === "virtual" || (0, $7uYIl.isVirtualClick)(e.nativeEvent))) {
                        // Ensure the element receives focus (VoiceOver on iOS does not do this)
                        if (!isDisabled && !preventFocusOnPress) (0, $61nPD.focusWithoutScrolling)(e.currentTarget);
                        let stopPressStart = triggerPressStart(e, "virtual");
                        let stopPressUp = triggerPressUp(e, "virtual");
                        let stopPressEnd = triggerPressEnd(e, "virtual");
                        shouldStopPropagation = stopPressStart && stopPressUp && stopPressEnd;
                    }
                    state.ignoreEmulatedMouseEvents = false;
                    state.ignoreClickAfterPress = false;
                    if (shouldStopPropagation) e.stopPropagation();
                }
            }
        };
        let onKeyUp = (e)=>{
            var _state_metaKeyEvents;
            if (state.isPressed && state.target && $b28f596898fd4eac$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e, state.target)) {
                var _state_metaKeyEvents1;
                if ($b28f596898fd4eac$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                let target = e.target;
                triggerPressEnd($b28f596898fd4eac$var$$f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard", state.target.contains(target));
                removeAllGlobalListeners();
                // If a link was triggered with a key other than Enter, open the URL ourselves.
                // This means the link has a role override, and the default browser behavior
                // only applies when using the Enter key.
                if (e.key !== "Enter" && $b28f596898fd4eac$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(state.target) && state.target.contains(target) && !e[$b28f596898fd4eac$var$$f6c31cce2adf654f$var$LINK_CLICKED]) {
                    // Store a hidden property on the event so we only trigger link click once,
                    // even if there are multiple usePress instances attached to the element.
                    e[$b28f596898fd4eac$var$$f6c31cce2adf654f$var$LINK_CLICKED] = true;
                    (0, $aCMC4.openLink)(state.target, e, false);
                }
                state.isPressed = false;
                (_state_metaKeyEvents1 = state.metaKeyEvents) === null || _state_metaKeyEvents1 === void 0 || _state_metaKeyEvents1.delete(e.key);
            } else if (e.key === "Meta" && ((_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 ? void 0 : _state_metaKeyEvents.size)) {
                var _state_target;
                // If we recorded keydown events that occurred while the Meta key was pressed,
                // and those haven't received keyup events already, fire keyup events ourselves.
                // See comment above for more info about the macOS bug causing this.
                let events = state.metaKeyEvents;
                state.metaKeyEvents = undefined;
                for (let event of events.values())(_state_target = state.target) === null || _state_target === void 0 || _state_target.dispatchEvent(new KeyboardEvent("keyup", event));
            }
        };
        if (typeof PointerEvent !== "undefined") {
            pressProps.onPointerDown = (e)=>{
                // Only handle left clicks, and ignore events that bubbled through portals.
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // iOS safari fires pointer events from VoiceOver with incorrect coordinates/target.
                // Ignore and let the onClick handler take care of it instead.
                // https://bugs.webkit.org/show_bug.cgi?id=222627
                // https://bugs.webkit.org/show_bug.cgi?id=223202
                if ((0, $7uYIl.isVirtualPointerEvent)(e.nativeEvent)) {
                    state.pointerType = "virtual";
                    return;
                }
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on pointer down and handle focusing the pressable element ourselves.
                if ($b28f596898fd4eac$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                state.pointerType = e.pointerType;
                let shouldStopPropagation = true;
                if (!state.isPressed) {
                    state.isPressed = true;
                    state.isOverTarget = true;
                    state.activePointerId = e.pointerId;
                    state.target = e.currentTarget;
                    if (!isDisabled && !preventFocusOnPress) (0, $61nPD.focusWithoutScrolling)(e.currentTarget);
                    if (!allowTextSelectionOnPress) (0, $ff38e19e007ac345$export$16a4697467175487)(state.target);
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    addGlobalListener((0, $ld26B.getOwnerDocument)(e.currentTarget), "pointermove", onPointerMove, false);
                    addGlobalListener((0, $ld26B.getOwnerDocument)(e.currentTarget), "pointerup", onPointerUp, false);
                    addGlobalListener((0, $ld26B.getOwnerDocument)(e.currentTarget), "pointercancel", onPointerCancel, false);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseDown = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (e.button === 0) {
                    // Chrome and Firefox on touch Windows devices require mouse down events
                    // to be canceled in addition to pointer events, or an extra asynchronous
                    // focus event will be fired.
                    if ($b28f596898fd4eac$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                    e.stopPropagation();
                }
            };
            pressProps.onPointerUp = (e)=>{
                // iOS fires pointerup with zero width and height, so check the pointerType recorded during pointerdown.
                if (!e.currentTarget.contains(e.target) || state.pointerType === "virtual") return;
                // Only handle left clicks
                // Safari on iOS sometimes fires pointerup events, even
                // when the touch isn't over the target, so double check.
                if (e.button === 0 && $b28f596898fd4eac$var$$f6c31cce2adf654f$var$isOverTarget(e, e.currentTarget)) triggerPressUp(e, state.pointerType || e.pointerType);
            };
            // Safari on iOS < 13.2 does not implement pointerenter/pointerleave events correctly.
            // Use pointer move events instead to implement our own hit testing.
            // See https://bugs.webkit.org/show_bug.cgi?id=199803
            let onPointerMove = (e)=>{
                if (e.pointerId !== state.activePointerId) return;
                if (state.target && $b28f596898fd4eac$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        triggerPressStart($b28f596898fd4eac$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    }
                } else if (state.target && state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    triggerPressEnd($b28f596898fd4eac$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    cancelOnPointerExit(e);
                }
            };
            let onPointerUp = (e)=>{
                if (e.pointerId === state.activePointerId && state.isPressed && e.button === 0 && state.target) {
                    if ($b28f596898fd4eac$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd($b28f596898fd4eac$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    else if (state.isOverTarget && state.pointerType != null) triggerPressEnd($b28f596898fd4eac$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    state.isPressed = false;
                    state.isOverTarget = false;
                    state.activePointerId = null;
                    state.pointerType = null;
                    removeAllGlobalListeners();
                    if (!allowTextSelectionOnPress) (0, $ff38e19e007ac345$export$b0d6fa1ab32e3295)(state.target);
                }
            };
            let onPointerCancel = (e)=>{
                cancel(e);
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                // Safari does not call onPointerCancel when a drag starts, whereas Chrome and Firefox do.
                cancel(e);
            };
        } else {
            pressProps.onMouseDown = (e)=>{
                // Only handle left clicks
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on mouse down and handle focusing the pressable element ourselves.
                if ($b28f596898fd4eac$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                if (state.ignoreEmulatedMouseEvents) {
                    e.stopPropagation();
                    return;
                }
                state.isPressed = true;
                state.isOverTarget = true;
                state.target = e.currentTarget;
                state.pointerType = (0, $7uYIl.isVirtualClick)(e.nativeEvent) ? "virtual" : "mouse";
                if (!isDisabled && !preventFocusOnPress) (0, $61nPD.focusWithoutScrolling)(e.currentTarget);
                let shouldStopPropagation = triggerPressStart(e, state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, $ld26B.getOwnerDocument)(e.currentTarget), "mouseup", onMouseUp, false);
            };
            pressProps.onMouseEnter = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = true;
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseLeave = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                    cancelOnPointerExit(e);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseUp = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.ignoreEmulatedMouseEvents && e.button === 0) triggerPressUp(e, state.pointerType || "mouse");
            };
            let onMouseUp = (e)=>{
                // Only handle left clicks
                if (e.button !== 0) return;
                state.isPressed = false;
                removeAllGlobalListeners();
                if (state.ignoreEmulatedMouseEvents) {
                    state.ignoreEmulatedMouseEvents = false;
                    return;
                }
                if (state.target && $b28f596898fd4eac$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd($b28f596898fd4eac$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                else if (state.target && state.isOverTarget && state.pointerType != null) triggerPressEnd($b28f596898fd4eac$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                state.isOverTarget = false;
            };
            pressProps.onTouchStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let touch = $b28f596898fd4eac$var$$f6c31cce2adf654f$var$getTouchFromEvent(e.nativeEvent);
                if (!touch) return;
                state.activePointerId = touch.identifier;
                state.ignoreEmulatedMouseEvents = true;
                state.isOverTarget = true;
                state.isPressed = true;
                state.target = e.currentTarget;
                state.pointerType = "touch";
                // Due to browser inconsistencies, especially on mobile browsers, we prevent default
                // on the emulated mouse event and handle focusing the pressable element ourselves.
                if (!isDisabled && !preventFocusOnPress) (0, $61nPD.focusWithoutScrolling)(e.currentTarget);
                if (!allowTextSelectionOnPress) (0, $ff38e19e007ac345$export$16a4697467175487)(state.target);
                let shouldStopPropagation = triggerPressStart(e, state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, $ld26B.getOwnerWindow)(e.currentTarget), "scroll", onScroll, true);
            };
            pressProps.onTouchMove = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                let touch = $b28f596898fd4eac$var$$f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                let shouldStopPropagation = true;
                if (touch && $b28f596898fd4eac$var$$f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    }
                } else if (state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                    cancelOnPointerExit(e);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onTouchEnd = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                let touch = $b28f596898fd4eac$var$$f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                let shouldStopPropagation = true;
                if (touch && $b28f596898fd4eac$var$$f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget) && state.pointerType != null) {
                    triggerPressUp(e, state.pointerType);
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType);
                } else if (state.isOverTarget && state.pointerType != null) shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                if (shouldStopPropagation) e.stopPropagation();
                state.isPressed = false;
                state.activePointerId = null;
                state.isOverTarget = false;
                state.ignoreEmulatedMouseEvents = true;
                if (state.target && !allowTextSelectionOnPress) (0, $ff38e19e007ac345$export$b0d6fa1ab32e3295)(state.target);
                removeAllGlobalListeners();
            };
            pressProps.onTouchCancel = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (state.isPressed) cancel(e);
            };
            let onScroll = (e)=>{
                if (state.isPressed && e.target.contains(state.target)) cancel({
                    currentTarget: state.target,
                    shiftKey: false,
                    ctrlKey: false,
                    metaKey: false,
                    altKey: false
                });
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                cancel(e);
            };
        }
        return pressProps;
    }, [
        addGlobalListener,
        isDisabled,
        preventFocusOnPress,
        removeAllGlobalListeners,
        allowTextSelectionOnPress,
        cancel,
        cancelOnPointerExit,
        triggerPressEnd,
        triggerPressStart,
        triggerPressUp
    ]);
    (0, $bh6RR.useEffect)(()=>{
        return ()=>{
            var _ref_current_target;
            if (!allowTextSelectionOnPress) (0, $ff38e19e007ac345$export$b0d6fa1ab32e3295)((_ref_current_target = ref.current.target) !== null && _ref_current_target !== void 0 ? _ref_current_target : undefined);
        };
    }, [
        allowTextSelectionOnPress
    ]);
    return {
        isPressed: isPressedProp || isPressed,
        pressProps: (0, $dCyIs.mergeProps)(domProps, pressProps)
    };
}
function $b28f596898fd4eac$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target) {
    return target.tagName === "A" && target.hasAttribute("href");
}
function $b28f596898fd4eac$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(event, currentTarget) {
    const { key: key, code: code } = event;
    const element = currentTarget;
    const role = element.getAttribute("role");
    // Accessibility for keyboards. Space and Enter only.
    // "Spacebar" is for IE 11
    return (key === "Enter" || key === " " || key === "Spacebar" || code === "Space") && !(element instanceof (0, $ld26B.getOwnerWindow)(element).HTMLInputElement && !$b28f596898fd4eac$var$$f6c31cce2adf654f$var$isValidInputKey(element, key) || element instanceof (0, $ld26B.getOwnerWindow)(element).HTMLTextAreaElement || element.isContentEditable) && // Links should only trigger with Enter key
    !((role === "link" || !role && $b28f596898fd4eac$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(element)) && key !== "Enter");
}
function $b28f596898fd4eac$var$$f6c31cce2adf654f$var$getTouchFromEvent(event) {
    const { targetTouches: targetTouches } = event;
    if (targetTouches.length > 0) return targetTouches[0];
    return null;
}
function $b28f596898fd4eac$var$$f6c31cce2adf654f$var$getTouchById(event, pointerId) {
    const changedTouches = event.changedTouches;
    for(let i = 0; i < changedTouches.length; i++){
        const touch = changedTouches[i];
        if (touch.identifier === pointerId) return touch;
    }
    return null;
}
function $b28f596898fd4eac$var$$f6c31cce2adf654f$var$createEvent(target, e) {
    return {
        currentTarget: target,
        shiftKey: e.shiftKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        altKey: e.altKey
    };
}
function $b28f596898fd4eac$var$$f6c31cce2adf654f$var$getPointClientRect(point) {
    let offsetX = 0;
    let offsetY = 0;
    if (point.width !== undefined) offsetX = point.width / 2;
    else if (point.radiusX !== undefined) offsetX = point.radiusX;
    if (point.height !== undefined) offsetY = point.height / 2;
    else if (point.radiusY !== undefined) offsetY = point.radiusY;
    return {
        top: point.clientY - offsetY,
        right: point.clientX + offsetX,
        bottom: point.clientY + offsetY,
        left: point.clientX - offsetX
    };
}
function $b28f596898fd4eac$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(a, b) {
    // check if they cannot overlap on x axis
    if (a.left > b.right || b.left > a.right) return false;
    // check if they cannot overlap on y axis
    if (a.top > b.bottom || b.top > a.bottom) return false;
    return true;
}
function $b28f596898fd4eac$var$$f6c31cce2adf654f$var$isOverTarget(point, target) {
    let rect = target.getBoundingClientRect();
    let pointRect = $b28f596898fd4eac$var$$f6c31cce2adf654f$var$getPointClientRect(point);
    return $b28f596898fd4eac$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(rect, pointRect);
}
function $b28f596898fd4eac$var$$f6c31cce2adf654f$var$shouldPreventDefault(target) {
    // We cannot prevent default if the target is a draggable element.
    return !(target instanceof HTMLElement) || !target.hasAttribute("draggable");
}
function $b28f596898fd4eac$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(target, key) {
    if (target instanceof HTMLInputElement) return !$b28f596898fd4eac$var$$f6c31cce2adf654f$var$isValidInputKey(target, key);
    if (target instanceof HTMLButtonElement) return target.type !== "submit" && target.type !== "reset";
    if ($b28f596898fd4eac$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target)) return false;
    return true;
}
const $b28f596898fd4eac$var$$f6c31cce2adf654f$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
function $b28f596898fd4eac$var$$f6c31cce2adf654f$var$isValidInputKey(target, key) {
    // Only space should toggle checkboxes and radios, not enter.
    return target.type === "checkbox" || target.type === "radio" ? key === " " : $b28f596898fd4eac$var$$f6c31cce2adf654f$var$nonTextInputTypes.has(target.type);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $046ee89106153b43$export$dcf14c9974fe2767(props, ref) {
    let { elementType: elementType = "a", onPress: onPress, onPressStart: onPressStart, onPressEnd: onPressEnd, onClick: deprecatedOnClick, isDisabled: isDisabled, ...otherProps } = props;
    let linkProps = {};
    if (elementType !== "a") linkProps = {
        role: "link",
        tabIndex: !isDisabled ? 0 : undefined
    };
    let { focusableProps: focusableProps } = (0, $a49c9d1e29111bf4$export$4c014de7c8940b4c)(props, ref);
    let { pressProps: pressProps, isPressed: isPressed } = (0, $b28f596898fd4eac$export$45712eceda6fad21)({
        onPress: onPress,
        onPressStart: onPressStart,
        onPressEnd: onPressEnd,
        isDisabled: isDisabled,
        ref: ref
    });
    let domProps = (0, $leZvJ.filterDOMProps)(otherProps, {
        labelable: true
    });
    let interactionHandlers = (0, $dCyIs.mergeProps)(focusableProps, pressProps);
    let router = (0, $aCMC4.useRouter)();
    let routerLinkProps = (0, $aCMC4.useLinkProps)(props);
    return {
        isPressed: isPressed,
        linkProps: (0, $dCyIs.mergeProps)(domProps, routerLinkProps, {
            ...interactionHandlers,
            ...linkProps,
            "aria-disabled": isDisabled || undefined,
            "aria-current": props["aria-current"],
            onClick: (e)=>{
                var _pressProps_onClick;
                (_pressProps_onClick = pressProps.onClick) === null || _pressProps_onClick === void 0 || _pressProps_onClick.call(pressProps, e);
                if (deprecatedOnClick) {
                    deprecatedOnClick(e);
                    console.warn("onClick is deprecated, please use onPress");
                }
                // If a custom router is provided, prevent default and forward if this link should client navigate.
                if (!router.isNative && e.currentTarget instanceof HTMLAnchorElement && e.currentTarget.href && // If props are applied to a router Link component, it may have already prevented default.
                !e.isDefaultPrevented() && (0, $aCMC4.shouldClientNavigate)(e.currentTarget, e) && props.href) {
                    e.preventDefault();
                    router.open(e.currentTarget, e, props.href, props.routerOptions);
                }
            }
        })
    };
}



var $hN2BG = parcelRequire("hN2BG");
var $gSab4 = parcelRequire("gSab4");

var $gedB5 = parcelRequire("gedB5");

var $3HS2q = parcelRequire("3HS2q");

var $6G4gc = parcelRequire("6G4gc");
var $6N9Z9 = parcelRequire("6N9Z9");

var $bh6RR = parcelRequire("bh6RR");

var $dCyIs = parcelRequire("dCyIs");
"use client";
function $ad4fcdebf94bc3da$export$dcf14c9974fe2767(originalProps) {
    var _a, _b, _c, _d;
    const globalContext = (0, $gSab4.useProviderContext)();
    const [props, variantProps] = (0, $hN2BG.mapPropsVariants)(originalProps, (0, $63b3dc4cdca591ba$export$9c30223ca0a664fb).variantKeys);
    const { ref: ref, as: as, children: children, anchorIcon: anchorIcon, isExternal: isExternal = false, showAnchorIcon: showAnchorIcon = false, autoFocus: autoFocus = false, className: className, onPress: onPress, onPressStart: onPressStart, onPressEnd: onPressEnd, onClick: onClick, ...otherProps } = props;
    const Component = as || "a";
    const domRef = (0, $gedB5.useDOMRef)(ref);
    const disableAnimation = (_b = (_a = originalProps == null ? void 0 : originalProps.disableAnimation) != null ? _a : globalContext == null ? void 0 : globalContext.disableAnimation) != null ? _b : false;
    const { linkProps: linkProps } = (0, $046ee89106153b43$export$dcf14c9974fe2767)({
        ...otherProps,
        onPress: onPress,
        onPressStart: onPressStart,
        onPressEnd: onPressEnd,
        onClick: onClick,
        isDisabled: originalProps.isDisabled,
        elementType: `${as}`
    }, domRef);
    const { isFocused: isFocused, isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $3HS2q.useFocusRing)({
        autoFocus: autoFocus
    });
    if (isExternal) {
        otherProps.rel = (_c = otherProps.rel) != null ? _c : "noopener noreferrer";
        otherProps.target = (_d = otherProps.target) != null ? _d : "_blank";
    }
    const classNames = (0, $bh6RR.useMemo)(()=>(0, $63b3dc4cdca591ba$export$9c30223ca0a664fb)({
            ...variantProps,
            disableAnimation: disableAnimation,
            className: className
        }), [
        (0, $6N9Z9.objectToDeps)(variantProps),
        disableAnimation,
        className
    ]);
    const getLinkProps = (0, $bh6RR.useCallback)(()=>{
        return {
            ref: domRef,
            className: classNames,
            "data-focus": (0, $6G4gc.dataAttr)(isFocused),
            "data-disabled": (0, $6G4gc.dataAttr)(originalProps.isDisabled),
            "data-focus-visible": (0, $6G4gc.dataAttr)(isFocusVisible),
            ...(0, $dCyIs.mergeProps)(focusProps, linkProps, otherProps)
        };
    }, [
        classNames,
        isFocused,
        isFocusVisible,
        focusProps,
        linkProps,
        otherProps
    ]);
    return {
        Component: Component,
        children: children,
        anchorIcon: anchorIcon,
        showAnchorIcon: showAnchorIcon,
        getLinkProps: getLinkProps
    };
}



var $hN2BG = parcelRequire("hN2BG");
// src/link.tsx

var $ih19M = parcelRequire("ih19M");
var $9b51c2b1b33e140d$export$69387b41dfc808f7 = (props)=>/* @__PURE__ */ (0, $ih19M.jsxs)("svg", {
        "aria-hidden": "true",
        fill: "none",
        focusable: "false",
        height: "1em",
        shapeRendering: "geometricPrecision",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.5",
        viewBox: "0 0 24 24",
        width: "1em",
        ...props,
        children: [
            /* @__PURE__ */ (0, $ih19M.jsx)("path", {
                d: "M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6"
            }),
            /* @__PURE__ */ (0, $ih19M.jsx)("path", {
                d: "M15 3h6v6"
            }),
            /* @__PURE__ */ (0, $ih19M.jsx)("path", {
                d: "M10 14L21 3"
            })
        ]
    });




var $ih19M = parcelRequire("ih19M");
"use client";
var $e51a08e6b8ac999a$var$Link = (0, $hN2BG.forwardRef)((props, ref)=>{
    const { Component: Component, children: children, showAnchorIcon: showAnchorIcon, anchorIcon: anchorIcon = /* @__PURE__ */ (0, $ih19M.jsx)((0, $9b51c2b1b33e140d$export$69387b41dfc808f7), {
        className: (0, $63b3dc4cdca591ba$export$1d42287988367e45)
    }), getLinkProps: getLinkProps } = (0, $ad4fcdebf94bc3da$export$dcf14c9974fe2767)({
        ref: ref,
        ...props
    });
    return /* @__PURE__ */ (0, $ih19M.jsx)(Component, {
        ...getLinkProps(),
        children: /* @__PURE__ */ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
            children: [
                children,
                showAnchorIcon && anchorIcon
            ]
        })
    });
});
$e51a08e6b8ac999a$var$Link.displayName = "NextUI.Link";
var $e51a08e6b8ac999a$export$2e315dfe55958408 = $e51a08e6b8ac999a$var$Link;



var $jLJKz = parcelRequire("jLJKz");
var $644a483104a3be90$exports = {};
$644a483104a3be90$exports = new URL("logotype_bold_light.68b1554b.svg", import.meta.url).toString();


const $78f30308591a87d9$var$logo = new URL($644a483104a3be90$exports);
function $78f30308591a87d9$export$896df779a8e2818(props) {
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: "bg-[#F6F6F4]",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "mx-auto max-w-4xl px-4 sm:px-7",
                children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: "flex items-center justify-between py-8",
                    children: /*#__PURE__*/ (0, $ih19M.jsx)("a", {
                        className: "-m-2.5 inline-block cursor-pointer p-2.5 hover:bg-[#2c97d1]",
                        href: "https://www.sleeve.fm/",
                        children: /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                            src: $78f30308591a87d9$var$logo.toString(),
                            className: "select-none"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("article", {
                className: "font mx-auto min-h-fit max-w-4xl p-4 pb-32 font-sans sm:p-7",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("h1", {
                        className: "mb-3 text-balance text-2xl font-bold leading-tight tracking-tighter sm:mb-6 sm:text-3xl md:text-5xl md:leading-none lg:text-6xl",
                        children: "A few true fans can change everything."
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $4e54f759c6d6bd3e$export$c4b5f538249c1147), {
                        className: "p-0",
                        hideIndicator: true,
                        itemClasses: {
                            base: "base",
                            heading: "heading",
                            trigger: "p-0 trigger group/trigger"
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $c7696c16791d5195$export$8a1014f5852fad66), {
                            "aria-label": "Description",
                            title: /*#__PURE__*/ (0, $ih19M.jsxs)("p", {
                                className: "prose prose-sm",
                                children: [
                                    "Kevin Kelly's idea in",
                                    " ",
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $e51a08e6b8ac999a$export$2e315dfe55958408), {
                                        size: "sm",
                                        color: "foreground",
                                        className: "underline underline-offset-2 hover:no-underline",
                                        target: "_blank",
                                        href: "https://kk.org/thetechnium/1000-true-fans/",
                                        children: "1,000 True Fans"
                                    }),
                                    " ",
                                    "is simple but powerful: you don't need to go viral to make a living. A small group of dedicated listeners can support your career \u2014 through memberships, album sales, livestreams, and more.",
                                    " ",
                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                        className: "font-bold transition group-data-[open=true]/trigger:hidden",
                                        children: "Read more..."
                                    })
                                ]
                            }),
                            children: /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                className: "prose prose-sm",
                                children: "Sleeve helps you turn that idea into income. This calculator shows how much you could earn through monthly fan memberships alone. Add in revenue from other features like album sales and livestreams, and the potential grows."
                            })
                        }, "1")
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $jLJKz.Calculator), {
                        ...props
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "mt-6 flex flex-col border-t border-slate-300 pt-4",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("h3", {
                                className: "prose-lg font-semibold",
                                children: "Understanding the Data"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: "grid gap-2",
                                children: /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                    className: "prose prose-sm text-balance",
                                    children: "This calculator models recurring income from memberships only. Earnings from music sales, livestreams, and other direct offers aren't included here \u2014 but they can be powerful additions. Sleeve takes zero rake, so you keep 100% of what your fans pay. Estimates account for average payment processing fees (~6%), which vary by country, currency, and method."
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


const $1d55148ac0a2fe5d$var$appElement = document.getElementById("calculator");
if ($1d55148ac0a2fe5d$var$appElement) {
    const props = {
        audienceSize: 3,
        popularity: 2,
        currencyName: "USD",
        tiers: [
            {
                id: crypto.randomUUID(),
                amount: 2,
                pledgers: 1200
            },
            {
                id: crypto.randomUUID(),
                amount: 10,
                pledgers: 1000
            },
            {
                id: crypto.randomUUID(),
                amount: 20,
                pledgers: 100
            }
        ],
        frequencyName: "monthly",
        albumSales: 50,
        avgSalePrice: 20
    };
    try {
        if (window.location.search.length !== 0) {
            const initialData = JSON.parse(atob(decodeURIComponent(window.location.search.substring(1))));
            // props.audienceSize = initialData.a;
            // props.popularity = initialData.p;
            if (initialData.c) props.currencyName = initialData.c;
            if (initialData.f) props.frequencyName = initialData.f;
            if (initialData.t) props.tiers = initialData.t;
            if (initialData.s) props.avgSalePrice = initialData.s;
            if (initialData.m) props.albumSales = initialData.m;
        }
    } catch (e) {
        console.log("error", e);
    }
    const root = (0, $9ATkq.createRoot)($1d55148ac0a2fe5d$var$appElement);
    // createRoot(container!) if you use TypeScript
    root.render((0, $bh6RR.createElement)((0, $78f30308591a87d9$export$896df779a8e2818), props));
}


//# sourceMappingURL=index.6f94c501.js.map
